/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function (global, factory) {
  typeof module === "object" && typeof module.exports === "object"
    ? (module.exports = global.document
        ? factory(global, !0)
        : function (w) {
            if (!w.document)
              throw new Error("Flits requires a window with a document");
            return factory(w);
          })
    : factory(global);
})(typeof window !== "undefined" ? window : this, function (window, noGlobal) {
  function isArrayLike(obj) {
    var length = !!obj && "length" in obj && obj.length,
      type = Flits.type(obj);
    return type === "function" || Flits.isWindow(obj)
      ? !1
      : type === "array" ||
          length === 0 ||
          (typeof length === "number" && length > 0 && length - 1 in obj);
  }
  function winnow(elements, qualifier, not) {
    if (Flits.isFunction(qualifier))
      return Flits.grep(elements, function (elem, i) {
        return !!qualifier.call(elem, i, elem) !== not;
      });
    if (qualifier.nodeType)
      return Flits.grep(elements, function (elem) {
        return (elem === qualifier) !== not;
      });
    if (typeof qualifier === "string") {
      if (risSimple.test(qualifier))
        return Flits.filter(qualifier, elements, not);
      qualifier = Flits.filter(qualifier, elements);
    }
    return Flits.grep(elements, function (elem) {
      return indexOf.call(qualifier, elem) > -1 !== not;
    });
  }
  function sibling(cur, dir) {
    while ((cur = cur[dir]) && cur.nodeType !== 1);
    return cur;
  }
  function createOptions(options) {
    var object = {};
    return (
      Flits.each(options.match(rnotwhite) || [], function (_, flag) {
        object[flag] = !0;
      }),
      object
    );
  }
  function completed() {
    document.removeEventListener("DOMContentLoaded", completed),
      window.removeEventListener("load", completed),
      Flits.ready();
  }
  function Data() {
    this.expando = Flits.expando + Data.uid++;
  }
  function dataAttr(elem, key, data) {
    var name;
    if (data === undefined && elem.nodeType === 1)
      if (
        ((name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase()),
        (data = elem.getAttribute(name)),
        typeof data === "string")
      ) {
        try {
          data =
            data === "true"
              ? !0
              : data === "false"
              ? !1
              : data === "null"
              ? null
              : +data + "" === data
              ? +data
              : rbrace.test(data)
              ? Flits.parseJSON(data)
              : data;
        } catch (e) {}
        dataUser.set(elem, key, data);
      } else data = undefined;
    return data;
  }
  function adjustCSS(elem, prop, valueParts, tween) {
    var adjusted,
      scale = 1,
      maxIterations = 20,
      currentValue = tween
        ? function () {
            return tween.cur();
          }
        : function () {
            return Flits.css(elem, prop, "");
          },
      initial = currentValue(),
      unit =
        (valueParts && valueParts[3]) || (Flits.cssNumber[prop] ? "" : "px"),
      initialInUnit =
        (Flits.cssNumber[prop] || (unit !== "px" && +initial)) &&
        rcssNum.exec(Flits.css(elem, prop));
    if (initialInUnit && initialInUnit[3] !== unit) {
      (unit = unit || initialInUnit[3]),
        (valueParts = valueParts || []),
        (initialInUnit = +initial || 1);
      do
        (scale = scale || ".5"),
          (initialInUnit /= scale),
          Flits.style(elem, prop, initialInUnit + unit);
      while (
        scale !== (scale = currentValue() / initial) &&
        scale !== 1 &&
        --maxIterations
      );
    }
    return (
      valueParts &&
        ((initialInUnit = +initialInUnit || +initial || 0),
        (adjusted = valueParts[1]
          ? initialInUnit + (valueParts[1] + 1) * valueParts[2]
          : +valueParts[2]),
        tween &&
          ((tween.unit = unit),
          (tween.start = initialInUnit),
          (tween.end = adjusted))),
      adjusted
    );
  }
  function getAll(context, tag) {
    var ret =
      context.getElementsByTagName !== void 0
        ? context.getElementsByTagName(tag || "*")
        : context.querySelectorAll !== void 0
        ? context.querySelectorAll(tag || "*")
        : [];
    return tag === undefined || (tag && Flits.nodeName(context, tag))
      ? Flits.merge([context], ret)
      : ret;
  }
  function setGlobalEval(elems, refElements) {
    var i = 0,
      l = elems.length;
    for (; i < l; i++)
      dataPriv.set(
        elems[i],
        "globalEval",
        !refElements || dataPriv.get(refElements[i], "globalEval")
      );
  }
  function buildFragment(elems, context, scripts, selection, ignored) {
    var elem,
      tmp,
      tag,
      wrap,
      contains,
      j,
      fragment = context.createDocumentFragment(),
      nodes = [],
      i = 0,
      l = elems.length;
    for (; i < l; i++)
      if (((elem = elems[i]), elem || elem === 0))
        if (Flits.type(elem) === "object")
          Flits.merge(nodes, elem.nodeType ? [elem] : elem);
        else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
        else {
          (tmp = tmp || fragment.appendChild(context.createElement("div"))),
            (tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase()),
            (wrap = wrapMap[tag] || wrapMap._default),
            (tmp.innerHTML = wrap[1] + Flits.htmlPrefilter(elem) + wrap[2]),
            (j = wrap[0]);
          while (j--) tmp = tmp.lastChild;
          Flits.merge(nodes, tmp.childNodes),
            (tmp = fragment.firstChild),
            (tmp.textContent = "");
        }
    (fragment.textContent = ""), (i = 0);
    while ((elem = nodes[i++])) {
      if (selection && Flits.inArray(elem, selection) > -1) {
        ignored && ignored.push(elem);
        continue;
      }
      if (
        ((contains = Flits.contains(elem.ownerDocument, elem)),
        (tmp = getAll(fragment.appendChild(elem), "script")),
        contains && setGlobalEval(tmp),
        scripts)
      ) {
        j = 0;
        while ((elem = tmp[j++]))
          rscriptType.test(elem.type || "") && scripts.push(elem);
      }
    }
    return fragment;
  }
  function returnTrue() {
    return !0;
  }
  function returnFalse() {
    return !1;
  }
  function safeActiveElement() {
    try {
      return document.activeElement;
    } catch (err) {}
  }
  function on(elem, types, selector, data, fn, one) {
    var origFn, type;
    if (typeof types === "object") {
      typeof selector !== "string" &&
        ((data = data || selector), (selector = undefined));
      for (type in types) on(elem, type, selector, data, types[type], one);
      return elem;
    }
    if (
      (data == null && fn == null
        ? ((fn = selector), (data = selector = undefined))
        : fn == null &&
          (typeof selector === "string"
            ? ((fn = data), (data = undefined))
            : ((fn = data), (data = selector), (selector = undefined))),
      fn === !1)
    )
      fn = returnFalse;
    else if (!fn) return elem;
    return (
      one === 1 &&
        ((origFn = fn),
        (fn = function (event) {
          return Flits().off(event), origFn.apply(this, arguments);
        }),
        (fn.guid = origFn.guid || (origFn.guid = Flits.guid++))),
      elem.each(function () {
        Flits.event.add(this, types, fn, data, selector);
      })
    );
  }
  function manipulationTarget(elem, content) {
    return Flits.nodeName(elem, "table") &&
      Flits.nodeName(
        content.nodeType !== 11 ? content : content.firstChild,
        "tr"
      )
      ? elem.getElementsByTagName("tbody")[0] ||
          elem.appendChild(elem.ownerDocument.createElement("tbody"))
      : elem;
  }
  function disableScript(elem) {
    return (
      (elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type), elem
    );
  }
  function restoreScript(elem) {
    var match = rscriptTypeMasked.exec(elem.type);
    return match ? (elem.type = match[1]) : elem.removeAttribute("type"), elem;
  }
  function cloneCopyEvent(src, dest) {
    var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
    if (dest.nodeType !== 1) return;
    if (
      dataPriv.hasData(src) &&
      ((pdataOld = dataPriv.access(src)),
      (pdataCur = dataPriv.set(dest, pdataOld)),
      (events = pdataOld.events),
      events)
    ) {
      delete pdataCur.handle, (pdataCur.events = {});
      for (type in events)
        for (i = 0, l = events[type].length; i < l; i++)
          Flits.event.add(dest, type, events[type][i]);
    }
    dataUser.hasData(src) &&
      ((udataOld = dataUser.access(src)),
      (udataCur = Flits.extend({}, udataOld)),
      dataUser.set(dest, udataCur));
  }
  function fixInput(src, dest) {
    var nodeName = dest.nodeName.toLowerCase();
    nodeName === "input" && rcheckableType.test(src.type)
      ? (dest.checked = src.checked)
      : (nodeName === "input" || nodeName === "textarea") &&
        (dest.defaultValue = src.defaultValue);
  }
  function domManip(collection, args, callback, ignored) {
    args = concat.apply([], args);
    var fragment,
      first,
      scripts,
      hasScripts,
      node,
      doc,
      i = 0,
      l = collection.length,
      iNoClone = l - 1,
      value = args[0],
      isFunction = Flits.isFunction(value);
    if (
      isFunction ||
      (l > 1 &&
        typeof value === "string" &&
        !support.checkClone &&
        rchecked.test(value))
    )
      return collection.each(function (index) {
        var self = collection.eq(index);
        isFunction && (args[0] = value.call(this, index, self.html())),
          domManip(self, args, callback, ignored);
      });
    if (
      l &&
      ((fragment = buildFragment(
        args,
        collection[0].ownerDocument,
        !1,
        collection,
        ignored
      )),
      (first = fragment.firstChild),
      fragment.childNodes.length === 1 && (fragment = first),
      first || ignored)
    ) {
      for (
        scripts = Flits.map(getAll(fragment, "script"), disableScript),
          hasScripts = scripts.length;
        i < l;
        i++
      )
        (node = fragment),
          i !== iNoClone &&
            ((node = Flits.clone(node, !0, !0)),
            hasScripts && Flits.merge(scripts, getAll(node, "script"))),
          callback.call(collection[i], node, i);
      if (hasScripts)
        for (
          doc = scripts[scripts.length - 1].ownerDocument,
            Flits.map(scripts, restoreScript),
            i = 0;
          i < hasScripts;
          i++
        )
          (node = scripts[i]),
            rscriptType.test(node.type || "") &&
              !dataPriv.access(node, "globalEval") &&
              Flits.contains(doc, node) &&
              (node.src
                ? Flits._evalUrl && Flits._evalUrl(node.src)
                : Flits.globalEval(node.textContent.replace(rcleanScript, "")));
    }
    return collection;
  }
  function remove(elem, selector, keepData) {
    var node,
      nodes = selector ? Flits.filter(selector, elem) : elem,
      i = 0;
    for (; (node = nodes[i]) != null; i++)
      !keepData && node.nodeType === 1 && Flits.cleanData(getAll(node)),
        node.parentNode &&
          (keepData &&
            Flits.contains(node.ownerDocument, node) &&
            setGlobalEval(getAll(node, "script")),
          node.parentNode.removeChild(node));
    return elem;
  }
  function actualDisplay(name, doc) {
    var elem = Flits(doc.createElement(name)).appendTo(doc.body),
      display = Flits.css(elem[0], "display");
    return elem.detach(), display;
  }
  function defaultDisplay(nodeName) {
    var doc = document,
      display = elemdisplay[nodeName];
    return (
      display ||
        ((display = actualDisplay(nodeName, doc)),
        (display === "none" || !display) &&
          ((iframe = (
            iframe || Flits("<iframe frameborder='0' width='0' height='0'/>")
          ).appendTo(doc.documentElement)),
          (doc = iframe[0].contentDocument),
          doc.write(),
          doc.close(),
          (display = actualDisplay(nodeName, doc)),
          iframe.detach()),
        (elemdisplay[nodeName] = display)),
      display
    );
  }
  function curCSS(elem, name, computed) {
    var width,
      minWidth,
      maxWidth,
      ret,
      style = elem.style;
    return (
      (computed = computed || getStyles(elem)),
      (ret = computed
        ? computed.getPropertyValue(name) || computed[name]
        : undefined),
      (ret === "" || ret === undefined) &&
        !Flits.contains(elem.ownerDocument, elem) &&
        (ret = Flits.style(elem, name)),
      computed &&
        !support.pixelMarginRight() &&
        rnumnonpx.test(ret) &&
        rmargin.test(name) &&
        ((width = style.width),
        (minWidth = style.minWidth),
        (maxWidth = style.maxWidth),
        (style.minWidth = style.maxWidth = style.width = ret),
        (ret = computed.width),
        (style.width = width),
        (style.minWidth = minWidth),
        (style.maxWidth = maxWidth)),
      ret !== undefined ? ret + "" : ret
    );
  }
  function addGetHookIf(conditionFn, hookFn) {
    return {
      get: function () {
        if (conditionFn()) {
          delete this.get;
          return;
        }
        return (this.get = hookFn).apply(this, arguments);
      },
    };
  }
  function vendorPropName(name) {
    if (name in emptyStyle) return name;
    var capName = name[0].toUpperCase() + name.slice(1),
      i = cssPrefixes.length;
    while (i--)
      if (((name = cssPrefixes[i] + capName), name in emptyStyle)) return name;
  }
  function setPositiveNumber(elem, value, subtract) {
    var matches = rcssNum.exec(value);
    return matches
      ? Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px")
      : value;
  }
  function augmentWidthOrHeight(elem, name, extra, isBorderBox, styles) {
    var i =
        extra === (isBorderBox ? "border" : "content")
          ? 4
          : name === "width"
          ? 1
          : 0,
      val = 0;
    for (; i < 4; i += 2)
      extra === "margin" &&
        (val += Flits.css(elem, extra + cssExpand[i], !0, styles)),
        isBorderBox
          ? (extra === "content" &&
              (val -= Flits.css(elem, "padding" + cssExpand[i], !0, styles)),
            extra !== "margin" &&
              (val -= Flits.css(
                elem,
                "border" + cssExpand[i] + "Width",
                !0,
                styles
              )))
          : ((val += Flits.css(elem, "padding" + cssExpand[i], !0, styles)),
            extra !== "padding" &&
              (val += Flits.css(
                elem,
                "border" + cssExpand[i] + "Width",
                !0,
                styles
              )));
    return val;
  }
  function getWidthOrHeight(elem, name, extra) {
    var valueIsBorderBox = !0,
      val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
      styles = getStyles(elem),
      isBorderBox = Flits.css(elem, "boxSizing", !1, styles) === "border-box";
    if (val <= 0 || val == null) {
      if (
        ((val = curCSS(elem, name, styles)),
        (val < 0 || val == null) && (val = elem.style[name]),
        rnumnonpx.test(val))
      )
        return val;
      (valueIsBorderBox =
        isBorderBox &&
        (support.boxSizingReliable() || val === elem.style[name])),
        (val = parseFloat(val) || 0);
    }
    return (
      val +
      augmentWidthOrHeight(
        elem,
        name,
        extra || (isBorderBox ? "border" : "content"),
        valueIsBorderBox,
        styles
      ) +
      "px"
    );
  }
  function showHide(elements, show) {
    var display,
      elem,
      hidden,
      values = [],
      index = 0,
      length = elements.length;
    for (; index < length; index++) {
      if (((elem = elements[index]), !elem.style)) continue;
      (values[index] = dataPriv.get(elem, "olddisplay")),
        (display = elem.style.display),
        show
          ? (!values[index] && display === "none" && (elem.style.display = ""),
            elem.style.display === "" &&
              isHidden(elem) &&
              (values[index] = dataPriv.access(
                elem,
                "olddisplay",
                defaultDisplay(elem.nodeName)
              )))
          : ((hidden = isHidden(elem)),
            (display !== "none" || !hidden) &&
              dataPriv.set(
                elem,
                "olddisplay",
                hidden ? display : Flits.css(elem, "display")
              ));
    }
    for (index = 0; index < length; index++) {
      if (((elem = elements[index]), !elem.style)) continue;
      (!show || elem.style.display === "none" || elem.style.display === "") &&
        (elem.style.display = show ? values[index] || "" : "none");
    }
    return elements;
  }
  function Tween(elem, options, prop, end, easing) {
    return new Tween.prototype.init(elem, options, prop, end, easing);
  }
  function createFxNow() {
    return (
      window.setTimeout(function () {
        fxNow = undefined;
      }),
      (fxNow = Flits.now())
    );
  }
  function genFx(type, includeWidth) {
    var which,
      i = 0,
      attrs = { height: type };
    for (includeWidth = includeWidth ? 1 : 0; i < 4; i += 2 - includeWidth)
      (which = cssExpand[i]),
        (attrs["margin" + which] = attrs["padding" + which] = type);
    return includeWidth && (attrs.opacity = attrs.width = type), attrs;
  }
  function createTween(value, prop, animation) {
    var tween,
      collection = (Animation.tweeners[prop] || []).concat(
        Animation.tweeners["*"]
      ),
      index = 0,
      length = collection.length;
    for (; index < length; index++)
      if ((tween = collection[index].call(animation, prop, value)))
        return tween;
  }
  function defaultPrefilter(elem, props, opts) {
    var prop,
      value,
      toggle,
      tween,
      hooks,
      oldfire,
      display,
      checkDisplay,
      anim = this,
      orig = {},
      style = elem.style,
      hidden = elem.nodeType && isHidden(elem),
      dataShow = dataPriv.get(elem, "fxshow");
    opts.queue ||
      ((hooks = Flits._queueHooks(elem, "fx")),
      hooks.unqueued == null &&
        ((hooks.unqueued = 0),
        (oldfire = hooks.empty.fire),
        (hooks.empty.fire = function () {
          hooks.unqueued || oldfire();
        })),
      hooks.unqueued++,
      anim.always(function () {
        anim.always(function () {
          hooks.unqueued--,
            Flits.queue(elem, "fx").length || hooks.empty.fire();
        });
      })),
      elem.nodeType === 1 &&
        ("height" in props || "width" in props) &&
        ((opts.overflow = [style.overflow, style.overflowX, style.overflowY]),
        (display = Flits.css(elem, "display")),
        (checkDisplay =
          display === "none"
            ? dataPriv.get(elem, "olddisplay") || defaultDisplay(elem.nodeName)
            : display),
        checkDisplay === "inline" &&
          Flits.css(elem, "float") === "none" &&
          (style.display = "inline-block")),
      opts.overflow &&
        ((style.overflow = "hidden"),
        anim.always(function () {
          (style.overflow = opts.overflow[0]),
            (style.overflowX = opts.overflow[1]),
            (style.overflowY = opts.overflow[2]);
        }));
    for (prop in props)
      if (((value = props[prop]), rfxtypes.exec(value))) {
        if (
          (delete props[prop],
          (toggle = toggle || value === "toggle"),
          value === (hidden ? "hide" : "show"))
        )
          if (value === "show" && dataShow && dataShow[prop] !== undefined)
            hidden = !0;
          else continue;
        orig[prop] = (dataShow && dataShow[prop]) || Flits.style(elem, prop);
      } else display = undefined;
    if (!Flits.isEmptyObject(orig)) {
      dataShow
        ? "hidden" in dataShow && (hidden = dataShow.hidden)
        : (dataShow = dataPriv.access(elem, "fxshow", {})),
        toggle && (dataShow.hidden = !hidden),
        hidden
          ? Flits(elem).show()
          : anim.done(function () {
              Flits(elem).hide();
            }),
        anim.done(function () {
          var prop;
          dataPriv.remove(elem, "fxshow");
          for (prop in orig) Flits.style(elem, prop, orig[prop]);
        });
      for (prop in orig)
        (tween = createTween(hidden ? dataShow[prop] : 0, prop, anim)),
          prop in dataShow ||
            ((dataShow[prop] = tween.start),
            hidden &&
              ((tween.end = tween.start),
              (tween.start = prop === "width" || prop === "height" ? 1 : 0)));
    } else (display === "none" ? defaultDisplay(elem.nodeName) : display) === "inline" && (style.display = display);
  }
  function propFilter(props, specialEasing) {
    var index, name, easing, value, hooks;
    for (index in props)
      if (
        ((name = Flits.camelCase(index)),
        (easing = specialEasing[name]),
        (value = props[index]),
        Flits.isArray(value) &&
          ((easing = value[1]), (value = props[index] = value[0])),
        index !== name && ((props[name] = value), delete props[index]),
        (hooks = Flits.cssHooks[name]),
        hooks && "expand" in hooks)
      ) {
        (value = hooks.expand(value)), delete props[name];
        for (index in value)
          index in props ||
            ((props[index] = value[index]), (specialEasing[index] = easing));
      } else specialEasing[name] = easing;
  }
  function Animation(elem, properties, options) {
    var result,
      stopped,
      index = 0,
      length = Animation.prefilters.length,
      deferred = Flits.Deferred().always(function () {
        delete tick.elem;
      }),
      tick = function () {
        if (stopped) return !1;
        var currentTime = fxNow || createFxNow(),
          remaining = Math.max(
            0,
            animation.startTime + animation.duration - currentTime
          ),
          temp = remaining / animation.duration || 0,
          percent = 1 - temp,
          index = 0,
          length = animation.tweens.length;
        for (; index < length; index++) animation.tweens[index].run(percent);
        return (
          deferred.notifyWith(elem, [animation, percent, remaining]),
          percent < 1 && length
            ? remaining
            : (deferred.resolveWith(elem, [animation]), !1)
        );
      },
      animation = deferred.promise({
        elem: elem,
        props: Flits.extend({}, properties),
        opts: Flits.extend(
          !0,
          { specialEasing: {}, easing: Flits.easing._default },
          options
        ),
        originalProperties: properties,
        originalOptions: options,
        startTime: fxNow || createFxNow(),
        duration: options.duration,
        tweens: [],
        createTween: function (prop, end) {
          var tween = Flits.Tween(
            elem,
            animation.opts,
            prop,
            end,
            animation.opts.specialEasing[prop] || animation.opts.easing
          );
          return animation.tweens.push(tween), tween;
        },
        stop: function (gotoEnd) {
          var index = 0,
            length = gotoEnd ? animation.tweens.length : 0;
          if (stopped) return this;
          for (stopped = !0; index < length; index++)
            animation.tweens[index].run(1);
          return (
            gotoEnd
              ? (deferred.notifyWith(elem, [animation, 1, 0]),
                deferred.resolveWith(elem, [animation, gotoEnd]))
              : deferred.rejectWith(elem, [animation, gotoEnd]),
            this
          );
        },
      }),
      props = animation.props;
    for (
      propFilter(props, animation.opts.specialEasing);
      index < length;
      index++
    )
      if (
        ((result = Animation.prefilters[index].call(
          animation,
          elem,
          props,
          animation.opts
        )),
        result)
      )
        return (
          Flits.isFunction(result.stop) &&
            (Flits._queueHooks(animation.elem, animation.opts.queue).stop =
              Flits.proxy(result.stop, result)),
          result
        );
    return (
      Flits.map(props, createTween, animation),
      Flits.isFunction(animation.opts.start) &&
        animation.opts.start.call(elem, animation),
      Flits.fx.timer(
        Flits.extend(tick, {
          elem: elem,
          anim: animation,
          queue: animation.opts.queue,
        })
      ),
      animation
        .progress(animation.opts.progress)
        .done(animation.opts.done, animation.opts.complete)
        .fail(animation.opts.fail)
        .always(animation.opts.always)
    );
  }
  function getClass(elem) {
    return (elem.getAttribute && elem.getAttribute("class")) || "";
  }
  function addToPrefiltersOrTransports(structure) {
    return function (dataTypeExpression, func) {
      typeof dataTypeExpression !== "string" &&
        ((func = dataTypeExpression), (dataTypeExpression = "*"));
      var dataType,
        i = 0,
        dataTypes = dataTypeExpression.toLowerCase().match(rnotwhite) || [];
      if (Flits.isFunction(func))
        while ((dataType = dataTypes[i++]))
          dataType[0] === "+"
            ? ((dataType = dataType.slice(1) || "*"),
              (structure[dataType] = structure[dataType] || []).unshift(func))
            : (structure[dataType] = structure[dataType] || []).push(func);
    };
  }
  function inspectPrefiltersOrTransports(
    structure,
    options,
    originalOptions,
    flitsXHR
  ) {
    function inspect(dataType) {
      var selected;
      return (
        (inspected[dataType] = !0),
        Flits.each(structure[dataType] || [], function (_, prefilterOrFactory) {
          var dataTypeOrTransport = prefilterOrFactory(
            options,
            originalOptions,
            flitsXHR
          );
          if (
            typeof dataTypeOrTransport === "string" &&
            !seekingTransport &&
            !inspected[dataTypeOrTransport]
          )
            return (
              options.dataTypes.unshift(dataTypeOrTransport),
              inspect(dataTypeOrTransport),
              !1
            );
          else if (seekingTransport) return !(selected = dataTypeOrTransport);
        }),
        selected
      );
    }
    var inspected = {},
      seekingTransport = structure === transports;
    return inspect(options.dataTypes[0]) || (!inspected["*"] && inspect("*"));
  }
  function ajaxExtend(target, src) {
    var key,
      deep,
      flatOptions = Flits.ajaxSettings.flatOptions || {};
    for (key in src)
      src[key] !== undefined &&
        ((flatOptions[key] ? target : deep || (deep = {}))[key] = src[key]);
    return deep && Flits.extend(!0, target, deep), target;
  }
  function ajaxHandleResponses(s, flitsXHR, responses) {
    var ct,
      type,
      finalDataType,
      firstDataType,
      contents = s.contents,
      dataTypes = s.dataTypes;
    while (dataTypes[0] === "*")
      dataTypes.shift(),
        ct === undefined &&
          (ct = s.mimeType || flitsXHR.getResponseHeader("Content-Type"));
    if (ct)
      for (type in contents)
        if (contents[type] && contents[type].test(ct)) {
          dataTypes.unshift(type);
          break;
        }
    if (dataTypes[0] in responses) finalDataType = dataTypes[0];
    else {
      for (type in responses) {
        if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
          finalDataType = type;
          break;
        }
        firstDataType || (firstDataType = type);
      }
      finalDataType = finalDataType || firstDataType;
    }
    return finalDataType
      ? (finalDataType !== dataTypes[0] && dataTypes.unshift(finalDataType),
        responses[finalDataType])
      : void 0;
  }
  function ajaxConvert(s, response, flitsXHR, isSuccess) {
    var conv2,
      current,
      conv,
      tmp,
      prev,
      converters = {},
      dataTypes = s.dataTypes.slice();
    if (dataTypes[1])
      for (conv in s.converters)
        converters[conv.toLowerCase()] = s.converters[conv];
    current = dataTypes.shift();
    while (current)
      if (
        (s.responseFields[current] &&
          (flitsXHR[s.responseFields[current]] = response),
        !prev &&
          isSuccess &&
          s.dataFilter &&
          (response = s.dataFilter(response, s.dataType)),
        (prev = current),
        (current = dataTypes.shift()),
        current)
      )
        if (current === "*") current = prev;
        else if (prev !== "*" && prev !== current) {
          if (
            ((conv =
              converters[prev + " " + current] || converters["* " + current]),
            !conv)
          )
            for (conv2 in converters)
              if (
                ((tmp = conv2.split(" ")),
                tmp[1] === current &&
                  ((conv =
                    converters[prev + " " + tmp[0]] ||
                    converters["* " + tmp[0]]),
                  conv))
              ) {
                conv === !0
                  ? (conv = converters[conv2])
                  : converters[conv2] !== !0 &&
                    ((current = tmp[0]), dataTypes.unshift(tmp[1]));
                break;
              }
          if (conv !== !0)
            if (conv && s.throws) response = conv(response);
            else
              try {
                response = conv(response);
              } catch (e) {
                return {
                  state: "parsererror",
                  error: conv
                    ? e
                    : "No conversion from " + prev + " to " + current,
                };
              }
        }
    return { state: "success", data: response };
  }
  function buildParams(prefix, obj, traditional, add) {
    var name;
    if (Flits.isArray(obj))
      Flits.each(obj, function (i, v) {
        traditional || rbracket.test(prefix)
          ? add(prefix, v)
          : buildParams(
              prefix +
                "[" +
                (typeof v === "object" && v != null ? i : "") +
                "]",
              v,
              traditional,
              add
            );
      });
    else if (!traditional && Flits.type(obj) === "object")
      for (name in obj)
        buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
    else add(prefix, obj);
  }
  function getWindow(elem) {
    return Flits.isWindow(elem)
      ? elem
      : elem.nodeType === 9 && elem.defaultView;
  }
  var arr = [];
  var document = window.document;
  var slice = arr.slice;
  var concat = arr.concat;
  var push = arr.push;
  var indexOf = arr.indexOf;
  var class2type = {};
  var toString = class2type.toString;
  var hasOwn = class2type.hasOwnProperty;
  var support = {};
  var version = "2.2.5-pre b14ce54334a568eaaa107be4c441660a57c3db24",
    Flits = function (selector, context) {
      return new Flits.fn.init(selector, context);
    },
    rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
    rmsPrefix = /^-ms-/,
    rdashAlpha = /-([\da-z])/gi,
    fcamelCase = function (all, letter) {
      return letter.toUpperCase();
    };
  (Flits.module =
    Flits.fn =
    Flits.prototype =
      {
        Flits: version,
        constructor: Flits,
        selector: "",
        length: 0,
        toArray: function () {
          return slice.call(this);
        },
        get: function (num) {
          return num != null
            ? num < 0
              ? this[num + this.length]
              : this[num]
            : slice.call(this);
        },
        pushStack: function (elems) {
          var ret = Flits.merge(this.constructor(), elems);
          return (ret.prevObject = this), (ret.context = this.context), ret;
        },
        each: function (callback) {
          return Flits.each(this, callback);
        },
        map: function (callback) {
          return this.pushStack(
            Flits.map(this, function (elem, i) {
              return callback.call(elem, i, elem);
            })
          );
        },
        slice: function () {
          return this.pushStack(slice.apply(this, arguments));
        },
        first: function () {
          return this.eq(0);
        },
        last: function () {
          return this.eq(-1);
        },
        eq: function (i) {
          var len = this.length,
            j = +i + (i < 0 ? len : 0);
          return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
        },
        end: function () {
          return this.prevObject || this.constructor();
        },
        push: push,
        sort: arr.sort,
        splice: arr.splice,
      }),
    (Flits.extend = Flits.fn.extend =
      function () {
        var options,
          name,
          src,
          copy,
          copyIsArray,
          clone,
          target = arguments[0] || {},
          i = 1,
          length = arguments.length,
          deep = !1;
        for (
          typeof target === "boolean" &&
            ((deep = target), (target = arguments[i] || {}), i++),
            typeof target !== "object" &&
              !Flits.isFunction(target) &&
              (target = {}),
            i === length && ((target = this), i--);
          i < length;
          i++
        )
          if ((options = arguments[i]) != null)
            for (name in options) {
              if (
                ((src = target[name]), (copy = options[name]), target === copy)
              )
                continue;
              deep &&
              copy &&
              (Flits.isPlainObject(copy) || (copyIsArray = Flits.isArray(copy)))
                ? (copyIsArray
                    ? ((copyIsArray = !1),
                      (clone = src && Flits.isArray(src) ? src : []))
                    : (clone = src && Flits.isPlainObject(src) ? src : {}),
                  (target[name] = Flits.extend(deep, clone, copy)))
                : copy !== undefined && (target[name] = copy);
            }
        return target;
      }),
    Flits.extend({
      expando: "Flits" + (version + Math.random()).replace(/\D/g, ""),
      isReady: !0,
      error: function (msg) {
        throw new Error(msg);
      },
      noop: function () {},
      isFunction: function (obj) {
        return Flits.type(obj) === "function";
      },
      isArray: Array.isArray,
      isWindow: function (obj) {
        return obj != null && obj === obj.window;
      },
      isNumeric: function (obj) {
        var realStringObj = obj && obj.toString();
        return (
          !Flits.isArray(obj) &&
          realStringObj - parseFloat(realStringObj) + 1 >= 0
        );
      },
      isPlainObject: function (obj) {
        var key;
        if (Flits.type(obj) !== "object" || obj.nodeType || Flits.isWindow(obj))
          return !1;
        if (
          obj.constructor &&
          !hasOwn.call(obj, "constructor") &&
          !hasOwn.call(obj.constructor.prototype || {}, "isPrototypeOf")
        )
          return !1;
        for (key in obj);
        return key === undefined || hasOwn.call(obj, key);
      },
      isEmptyObject: function (obj) {
        var name;
        for (name in obj) return !1;
        return !0;
      },
      type: function (obj) {
        return obj == null
          ? obj + ""
          : typeof obj === "object" || typeof obj === "function"
          ? class2type[toString.call(obj)] || "object"
          : typeof obj;
      },
      globalEval: function (code) {
        var script,
          indirect = eval;
        (code = Flits.trim(code)),
          code &&
            (code.indexOf("use strict") === 1
              ? ((script = document.createElement("script")),
                (script.text = code),
                document.head
                  .appendChild(script)
                  .parentNode.removeChild(script))
              : indirect(code));
      },
      camelCase: function (string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
      },
      nodeName: function (elem, name) {
        return (
          elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase()
        );
      },
      each: function (obj, callback) {
        var length,
          i = 0;
        if (isArrayLike(obj)) {
          for (length = obj.length; i < length; i++)
            if (callback.call(obj[i], i, obj[i]) === !1) break;
        } else
          for (i in obj) if (callback.call(obj[i], i, obj[i]) === !1) break;
        return obj;
      },
      trim: function (text) {
        return text == null ? "" : (text + "").replace(rtrim, "");
      },
      makeArray: function (arr, results) {
        var ret = results || [];
        return (
          arr != null &&
            (isArrayLike(Object(arr))
              ? Flits.merge(ret, typeof arr === "string" ? [arr] : arr)
              : push.call(ret, arr)),
          ret
        );
      },
      inArray: function (elem, arr, i) {
        return arr == null ? -1 : indexOf.call(arr, elem, i);
      },
      merge: function (first, second) {
        var len = +second.length,
          j = 0,
          i = first.length;
        for (; j < len; j++) first[i++] = second[j];
        return (first.length = i), first;
      },
      grep: function (elems, callback, invert) {
        var callbackInverse,
          matches = [],
          i = 0,
          length = elems.length,
          callbackExpect = !invert;
        for (; i < length; i++)
          (callbackInverse = !callback(elems[i], i)),
            callbackInverse !== callbackExpect && matches.push(elems[i]);
        return matches;
      },
      map: function (elems, callback, arg) {
        var length,
          value,
          i = 0,
          ret = [];
        if (isArrayLike(elems))
          for (length = elems.length; i < length; i++)
            (value = callback(elems[i], i, arg)),
              value != null && ret.push(value);
        else
          for (i in elems)
            (value = callback(elems[i], i, arg)),
              value != null && ret.push(value);
        return concat.apply([], ret);
      },
      guid: 1,
      proxy: function (fn, context) {
        var tmp, args, proxy;
        return (
          typeof context === "string" &&
            ((tmp = fn[context]), (context = fn), (fn = tmp)),
          Flits.isFunction(fn)
            ? ((args = slice.call(arguments, 2)),
              (proxy = function () {
                return fn.apply(
                  context || this,
                  args.concat(slice.call(arguments))
                );
              }),
              (proxy.guid = fn.guid = fn.guid || Flits.guid++),
              proxy)
            : undefined
        );
      },
      now: Date.now,
      support: support,
    }),
    typeof Symbol === "function" &&
      (Flits.fn[Symbol.iterator] = arr[Symbol.iterator]),
    Flits.each(
      "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
        " "
      ),
      function (i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
      }
    );
  var Sizzle = (function (
    window,
    i,
    support,
    Expr,
    getText,
    isXML,
    tokenize,
    compile,
    select,
    outermostContext,
    sortInput,
    hasDuplicate,
    setDocument,
    document,
    docElem,
    documentIsHTML,
    rbuggyQSA,
    rbuggyMatches,
    matches,
    contains,
    expando,
    preferredDoc,
    dirruns,
    done,
    classCache,
    tokenCache,
    compilerCache,
    sortOrder,
    MAX_NEGATIVE,
    hasOwn,
    arr,
    pop,
    push_native,
    push,
    slice,
    indexOf,
    booleans,
    whitespace,
    identifier,
    attributes,
    pseudos,
    rwhitespace,
    rtrim,
    rcomma,
    rcombinators,
    rattributeQuotes,
    rpseudo,
    ridentifier,
    matchExpr,
    rinputs,
    rheader,
    rnative,
    rquickExpr,
    rsibling,
    rescape,
    runescape,
    funescape,
    unloadHandler
  ) {
    function Sizzle(selector, context, results, seed) {
      var m,
        i,
        elem,
        nid,
        nidselect,
        match,
        groups,
        newSelector,
        newContext = context && context.ownerDocument,
        nodeType = context ? context.nodeType : 9;
      if (
        ((results = results || []),
        typeof selector !== "string" ||
          !selector ||
          (nodeType !== 1 && nodeType !== 9 && nodeType !== 11))
      )
        return results;
      if (
        !seed &&
        ((context ? context.ownerDocument || context : preferredDoc) !==
          document && setDocument(context),
        (context = context || document),
        documentIsHTML)
      ) {
        if (nodeType !== 11 && (match = rquickExpr.exec(selector)))
          if ((m = match[1])) {
            if (nodeType === 9)
              if ((elem = context.getElementById(m))) {
                if (elem.id === m) return results.push(elem), results;
              } else return results;
            else if (
              newContext &&
              (elem = newContext.getElementById(m)) &&
              contains(context, elem) &&
              elem.id === m
            )
              return results.push(elem), results;
          } else if (match[2])
            return (
              push.apply(results, context.getElementsByTagName(selector)),
              results
            );
          else if (
            (m = match[3]) &&
            support.getElementsByClassName &&
            context.getElementsByClassName
          )
            return (
              push.apply(results, context.getElementsByClassName(m)), results
            );
        if (
          support.qsa &&
          !compilerCache[selector + " "] &&
          !(rbuggyQSA && rbuggyQSA.test(selector))
        ) {
          if (nodeType !== 1) (newContext = context), (newSelector = selector);
          else if (context.nodeName.toLowerCase() !== "object") {
            (nid = context.getAttribute("id"))
              ? (nid = nid.replace(rescape, "\\$&"))
              : context.setAttribute("id", (nid = expando)),
              (groups = tokenize(selector)),
              (i = groups.length),
              (nidselect = ridentifier.test(nid)
                ? "#" + nid
                : "[id='" + nid + "']");
            while (i--) groups[i] = nidselect + " " + toSelector(groups[i]);
            (newSelector = groups.join(",")),
              (newContext =
                (rsibling.test(selector) && testContext(context.parentNode)) ||
                context);
          }
          if (newSelector)
            try {
              return (
                push.apply(results, newContext.querySelectorAll(newSelector)),
                results
              );
            } catch (qsaError) {
            } finally {
              nid === expando && context.removeAttribute("id");
            }
        }
      }
      return select(selector.replace(rtrim, "$1"), context, results, seed);
    }
    function createCache() {
      function cache(key, value) {
        return (
          keys.push(key + " ") > Expr.cacheLength && delete cache[keys.shift()],
          (cache[key + " "] = value)
        );
      }
      var keys = [];
      return cache;
    }
    function markFunction(fn) {
      return (fn[expando] = !0), fn;
    }
    function assert(fn) {
      var div = document.createElement("div");
      try {
        return !!fn(div);
      } catch (e) {
        return false;
      } finally {
        div.parentNode && div.parentNode.removeChild(div), (div = null);
      }
    }
    function addHandle(attrs, handler) {
      var arr = attrs.split("|"),
        i = arr.length;
      while (i--) Expr.attrHandle[arr[i]] = handler;
    }
    function siblingCheck(a, b) {
      var cur = b && a,
        diff =
          cur &&
          a.nodeType === 1 &&
          b.nodeType === 1 &&
          (~b.sourceIndex || MAX_NEGATIVE) - (~a.sourceIndex || MAX_NEGATIVE);
      if (diff) return diff;
      if (cur) while ((cur = cur.nextSibling)) if (cur === b) return -1;
      return a ? 1 : -1;
    }
    function createInputPseudo(type) {
      return function (elem) {
        var name = elem.nodeName.toLowerCase();
        return name === "input" && elem.type === type;
      };
    }
    function createButtonPseudo(type) {
      return function (elem) {
        var name = elem.nodeName.toLowerCase();
        return (name === "input" || name === "button") && elem.type === type;
      };
    }
    function createPositionalPseudo(fn) {
      return markFunction(function (argument) {
        return (
          (argument = +argument),
          markFunction(function (seed, matches) {
            var j,
              matchIndexes = fn([], seed.length, argument),
              i = matchIndexes.length;
            while (i--)
              seed[(j = matchIndexes[i])] &&
                (seed[j] = !(matches[j] = seed[j]));
          })
        );
      });
    }
    function testContext(context) {
      return context && context.getElementsByTagName !== void 0 && context;
    }
    function setFilters() {}
    function toSelector(tokens) {
      var i = 0,
        len = tokens.length,
        selector = "";
      for (; i < len; i++) selector += tokens[i].value;
      return selector;
    }
    function addCombinator(matcher, combinator, base) {
      var dir = combinator.dir,
        checkNonElements = base && dir === "parentNode",
        doneName = done++;
      return combinator.first
        ? function (elem, context, xml) {
            while ((elem = elem[dir]))
              if (elem.nodeType === 1 || checkNonElements)
                return matcher(elem, context, xml);
          }
        : function (elem, context, xml) {
            var oldCache,
              uniqueCache,
              outerCache,
              newCache = [dirruns, doneName];
            if (xml) {
              while ((elem = elem[dir]))
                if (
                  (elem.nodeType === 1 || checkNonElements) &&
                  matcher(elem, context, xml)
                )
                  return !0;
            } else
              while ((elem = elem[dir]))
                if (elem.nodeType === 1 || checkNonElements)
                  if (
                    ((outerCache = elem[expando] || (elem[expando] = {})),
                    (uniqueCache =
                      outerCache[elem.uniqueID] ||
                      (outerCache[elem.uniqueID] = {})),
                    (oldCache = uniqueCache[dir]) &&
                      oldCache[0] === dirruns &&
                      oldCache[1] === doneName)
                  )
                    return (newCache[2] = oldCache[2]);
                  else if (
                    ((uniqueCache[dir] = newCache),
                    (newCache[2] = matcher(elem, context, xml)))
                  )
                    return !0;
          };
    }
    function elementMatcher(matchers) {
      return matchers.length > 1
        ? function (elem, context, xml) {
            var i = matchers.length;
            while (i--) if (!matchers[i](elem, context, xml)) return !1;
            return !0;
          }
        : matchers[0];
    }
    function multipleContexts(selector, contexts, results) {
      var i = 0,
        len = contexts.length;
      for (; i < len; i++) Sizzle(selector, contexts[i], results);
      return results;
    }
    function condense(unmatched, map, filter, context, xml) {
      var elem,
        newUnmatched = [],
        i = 0,
        len = unmatched.length,
        mapped = map != null;
      for (; i < len; i++)
        (elem = unmatched[i]) &&
          (!filter || filter(elem, context, xml)) &&
          (newUnmatched.push(elem), mapped && map.push(i));
      return newUnmatched;
    }
    function setMatcher(
      preFilter,
      selector,
      matcher,
      postFilter,
      postFinder,
      postSelector
    ) {
      return (
        postFilter &&
          !postFilter[expando] &&
          (postFilter = setMatcher(postFilter)),
        postFinder &&
          !postFinder[expando] &&
          (postFinder = setMatcher(postFinder, postSelector)),
        markFunction(function (seed, results, context, xml) {
          var temp,
            i,
            elem,
            preMap = [],
            postMap = [],
            preexisting = results.length,
            elems =
              seed ||
              multipleContexts(
                selector || "*",
                context.nodeType ? [context] : context,
                []
              ),
            matcherIn =
              preFilter && (seed || !selector)
                ? condense(elems, preMap, preFilter, context, xml)
                : elems,
            matcherOut = matcher
              ? postFinder || (seed ? preFilter : preexisting || postFilter)
                ? []
                : results
              : matcherIn;
          if (
            (matcher && matcher(matcherIn, matcherOut, context, xml),
            postFilter)
          ) {
            (temp = condense(matcherOut, postMap)),
              postFilter(temp, [], context, xml),
              (i = temp.length);
            while (i--)
              (elem = temp[i]) &&
                (matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem));
          }
          if (seed) {
            if (postFinder || preFilter) {
              if (postFinder) {
                (temp = []), (i = matcherOut.length);
                while (i--)
                  (elem = matcherOut[i]) && temp.push((matcherIn[i] = elem));
                postFinder(null, (matcherOut = []), temp, xml);
              }
              i = matcherOut.length;
              while (i--)
                (elem = matcherOut[i]) &&
                  (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1 &&
                  (seed[temp] = !(results[temp] = elem));
            }
          } else (matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut)), postFinder ? postFinder(null, results, matcherOut, xml) : push.apply(results, matcherOut);
        })
      );
    }
    function matcherFromTokens(tokens) {
      var checkContext,
        matcher,
        j,
        len = tokens.length,
        leadingRelative = Expr.relative[tokens[0].type],
        implicitRelative = leadingRelative || Expr.relative[" "],
        i = leadingRelative ? 1 : 0,
        matchContext = addCombinator(
          function (elem) {
            return elem === checkContext;
          },
          implicitRelative,
          !0
        ),
        matchAnyContext = addCombinator(
          function (elem) {
            return indexOf(checkContext, elem) > -1;
          },
          implicitRelative,
          !0
        ),
        matchers = [
          function (elem, context, xml) {
            var ret =
              (!leadingRelative && (xml || context !== outermostContext)) ||
              ((checkContext = context).nodeType
                ? matchContext(elem, context, xml)
                : matchAnyContext(elem, context, xml));
            return (checkContext = null), ret;
          },
        ];
      for (; i < len; i++)
        if ((matcher = Expr.relative[tokens[i].type]))
          matchers = [addCombinator(elementMatcher(matchers), matcher)];
        else {
          if (
            ((matcher = Expr.filter[tokens[i].type].apply(
              null,
              tokens[i].matches
            )),
            matcher[expando])
          ) {
            for (j = ++i; j < len; j++)
              if (Expr.relative[tokens[j].type]) break;
            return setMatcher(
              i > 1 && elementMatcher(matchers),
              i > 1 &&
                toSelector(
                  tokens
                    .slice(0, i - 1)
                    .concat({ value: tokens[i - 2].type === " " ? "*" : "" })
                ).replace(rtrim, "$1"),
              matcher,
              i < j && matcherFromTokens(tokens.slice(i, j)),
              j < len && matcherFromTokens((tokens = tokens.slice(j))),
              j < len && toSelector(tokens)
            );
          }
          matchers.push(matcher);
        }
      return elementMatcher(matchers);
    }
    function matcherFromGroupMatchers(elementMatchers, setMatchers) {
      var bySet = setMatchers.length > 0,
        byElement = elementMatchers.length > 0,
        superMatcher = function (seed, context, xml, results, outermost) {
          var elem,
            j,
            matcher,
            matchedCount = 0,
            i = "0",
            unmatched = seed && [],
            setMatched = [],
            contextBackup = outermostContext,
            elems = seed || (byElement && Expr.find.TAG("*", outermost)),
            dirrunsUnique = (dirruns +=
              contextBackup == null ? 1 : Math.random() || 0.1),
            len = elems.length;
          for (
            outermost &&
            (outermostContext = context === document || context || outermost);
            i !== len && (elem = elems[i]) != null;
            i++
          ) {
            if (byElement && elem) {
              (j = 0),
                !context &&
                  elem.ownerDocument !== document &&
                  (setDocument(elem), (xml = !documentIsHTML));
              while ((matcher = elementMatchers[j++]))
                if (matcher(elem, context || document, xml)) {
                  results.push(elem);
                  break;
                }
              outermost && (dirruns = dirrunsUnique);
            }
            bySet &&
              ((elem = !matcher && elem) && matchedCount--,
              seed && unmatched.push(elem));
          }
          if (((matchedCount += i), bySet && i !== matchedCount)) {
            j = 0;
            while ((matcher = setMatchers[j++]))
              matcher(unmatched, setMatched, context, xml);
            if (seed) {
              if (matchedCount > 0)
                while (i--)
                  unmatched[i] ||
                    setMatched[i] ||
                    (setMatched[i] = pop.call(results));
              setMatched = condense(setMatched);
            }
            push.apply(results, setMatched),
              outermost &&
                !seed &&
                setMatched.length > 0 &&
                matchedCount + setMatchers.length > 1 &&
                Sizzle.uniqueSort(results);
          }
          return (
            outermost &&
              ((dirruns = dirrunsUnique), (outermostContext = contextBackup)),
            unmatched
          );
        };
      return bySet ? markFunction(superMatcher) : superMatcher;
    }
    (expando = "sizzle" + 1 * new Date()),
      (preferredDoc = window.document),
      (dirruns = 0),
      (done = 0),
      (classCache = createCache()),
      (tokenCache = createCache()),
      (compilerCache = createCache()),
      (sortOrder = function (a, b) {
        return a === b && (hasDuplicate = !0), 0;
      }),
      (MAX_NEGATIVE = 1 << 31),
      (hasOwn = {}.hasOwnProperty),
      (arr = []),
      (pop = arr.pop),
      (push_native = arr.push),
      (push = arr.push),
      (slice = arr.slice),
      (indexOf = function (list, elem) {
        var i = 0,
          len = list.length;
        for (; i < len; i++) if (list[i] === elem) return i;
        return -1;
      }),
      (booleans =
        "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped"),
      (whitespace = "[\\x20\\t\\r\\n\\f]"),
      (identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+"),
      (attributes =
        "\\[" +
        whitespace +
        "*(" +
        identifier +
        ")(?:" +
        whitespace +
        "*([*^$|!~]?=)" +
        whitespace +
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
        identifier +
        "))|)" +
        whitespace +
        "*\\]"),
      (pseudos =
        ":(" +
        identifier +
        ")(?:\\((" +
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
        "((?:\\\\.|[^\\\\()[\\]]|" +
        attributes +
        ")*)|" +
        ".*" +
        ")\\)|)"),
      (rwhitespace = new RegExp(whitespace + "+", "g")),
      (rtrim = new RegExp(
        "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
        "g"
      )),
      (rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*")),
      (rcombinators = new RegExp(
        "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"
      )),
      (rattributeQuotes = new RegExp(
        "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]",
        "g"
      )),
      (rpseudo = new RegExp(pseudos)),
      (ridentifier = new RegExp("^" + identifier + "$")),
      (matchExpr = {
        ID: new RegExp("^#(" + identifier + ")"),
        CLASS: new RegExp("^\\.(" + identifier + ")"),
        TAG: new RegExp("^(" + identifier + "|[*])"),
        ATTR: new RegExp("^" + attributes),
        PSEUDO: new RegExp("^" + pseudos),
        CHILD: new RegExp(
          "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
            whitespace +
            "*(even|odd|(([+-]|)(\\d*)n|)" +
            whitespace +
            "*(?:([+-]|)" +
            whitespace +
            "*(\\d+)|))" +
            whitespace +
            "*\\)|)",
          "i"
        ),
        bool: new RegExp("^(?:" + booleans + ")$", "i"),
        needsContext: new RegExp(
          "^" +
            whitespace +
            "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
            whitespace +
            "*((?:-\\d)?\\d*)" +
            whitespace +
            "*\\)|)(?=[^-]|$)",
          "i"
        ),
      }),
      (rinputs = /^(?:input|select|textarea|button)$/i),
      (rheader = /^h\d$/i),
      (rnative = /^[^{]+\{\s*\[native \w/),
      (rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/),
      (rsibling = /[+~]/),
      (rescape = /'|\\/g),
      (runescape = new RegExp(
        "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)",
        "ig"
      )),
      (funescape = function (_, escaped, escapedWhitespace) {
        var high = "0x" + escaped - 65536;
        return high !== high || escapedWhitespace
          ? escaped
          : high < 0
          ? String.fromCharCode(high + 65536)
          : String.fromCharCode((high >> 10) | 55296, (high & 1023) | 56320);
      }),
      (unloadHandler = function () {
        setDocument();
      });
    try {
      push.apply(
        (arr = slice.call(preferredDoc.childNodes)),
        preferredDoc.childNodes
      ),
        arr[preferredDoc.childNodes.length].nodeType;
    } catch (e) {
      push = {
        apply: arr.length
          ? function (target, els) {
              push_native.apply(target, slice.call(els));
            }
          : function (target, els) {
              var j = target.length,
                i = 0;
              while ((target[j++] = els[i++])) {}
              target.length = j - 1;
            },
      };
    }
    (support = Sizzle.support = {}),
      (isXML = Sizzle.isXML =
        function (elem) {
          var documentElement =
            elem && (elem.ownerDocument || elem).documentElement;
          return documentElement ? documentElement.nodeName !== "HTML" : !1;
        }),
      (setDocument = Sizzle.setDocument =
        function (node) {
          var hasCompare,
            parent,
            doc = node ? node.ownerDocument || node : preferredDoc;
          return doc === document || doc.nodeType !== 9 || !doc.documentElement
            ? document
            : ((document = doc),
              (docElem = document.documentElement),
              (documentIsHTML = !isXML(document)),
              (parent = document.defaultView) &&
                parent.top !== parent &&
                (parent.addEventListener
                  ? parent.addEventListener("unload", unloadHandler, !1)
                  : parent.attachEvent &&
                    parent.attachEvent("onunload", unloadHandler)),
              (support.attributes = assert(function (div) {
                return (div.className = "i"), !div.getAttribute("className");
              })),
              (support.getElementsByTagName = assert(function (div) {
                return (
                  div.appendChild(document.createComment("")),
                  !div.getElementsByTagName("*").length
                );
              })),
              (support.getElementsByClassName = rnative.test(
                document.getElementsByClassName
              )),
              (support.getById = assert(function (div) {
                return (
                  (docElem.appendChild(div).id = expando),
                  !document.getElementsByName ||
                    !document.getElementsByName(expando).length
                );
              })),
              support.getById
                ? ((Expr.find.ID = function (id, context) {
                    if (context.getElementById !== void 0 && documentIsHTML) {
                      var m = context.getElementById(id);
                      return m ? [m] : [];
                    }
                  }),
                  (Expr.filter.ID = function (id) {
                    var attrId = id.replace(runescape, funescape);
                    return function (elem) {
                      return elem.getAttribute("id") === attrId;
                    };
                  }))
                : (delete Expr.find.ID,
                  (Expr.filter.ID = function (id) {
                    var attrId = id.replace(runescape, funescape);
                    return function (elem) {
                      var node =
                        elem.getAttributeNode !== void 0 &&
                        elem.getAttributeNode("id");
                      return node && node.value === attrId;
                    };
                  })),
              (Expr.find.TAG = support.getElementsByTagName
                ? function (tag, context) {
                    if (context.getElementsByTagName !== void 0)
                      return context.getElementsByTagName(tag);
                    else if (support.qsa) return context.querySelectorAll(tag);
                  }
                : function (tag, context) {
                    var elem,
                      tmp = [],
                      i = 0,
                      results = context.getElementsByTagName(tag);
                    if (tag === "*") {
                      while ((elem = results[i++]))
                        elem.nodeType === 1 && tmp.push(elem);
                      return tmp;
                    }
                    return results;
                  }),
              (Expr.find.CLASS =
                support.getElementsByClassName &&
                function (className, context) {
                  return context.getElementsByClassName !== void 0 &&
                    documentIsHTML
                    ? context.getElementsByClassName(className)
                    : void 0;
                }),
              (rbuggyMatches = []),
              (rbuggyQSA = []),
              (support.qsa = rnative.test(document.querySelectorAll)) &&
                (assert(function (div) {
                  (docElem.appendChild(div).innerHTML =
                    "<a id='" +
                    expando +
                    "'></a>" +
                    "<select id='" +
                    expando +
                    "-\r\\' msallowcapture=''>" +
                    "<option selected=''></option></select>"),
                    div.querySelectorAll("[msallowcapture^='']").length &&
                      rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")"),
                    div.querySelectorAll("[selected]").length ||
                      rbuggyQSA.push(
                        "\\[" + whitespace + "*(?:value|" + booleans + ")"
                      ),
                    div.querySelectorAll("[id~=" + expando + "-]").length ||
                      rbuggyQSA.push("~="),
                    div.querySelectorAll(":checked").length ||
                      rbuggyQSA.push(":checked"),
                    div.querySelectorAll("a#" + expando + "+*").length ||
                      rbuggyQSA.push(".#.+[+~]");
                }),
                assert(function (div) {
                  var input = document.createElement("input");
                  input.setAttribute("type", "hidden"),
                    div.appendChild(input).setAttribute("name", "D"),
                    div.querySelectorAll("[name=d]").length &&
                      rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?="),
                    div.querySelectorAll(":enabled").length ||
                      rbuggyQSA.push(":enabled", ":disabled"),
                    div.querySelectorAll("*,:x"),
                    rbuggyQSA.push(",.*:");
                })),
              (support.matchesSelector = rnative.test(
                (matches =
                  docElem.matches ||
                  docElem.webkitMatchesSelector ||
                  docElem.mozMatchesSelector ||
                  docElem.oMatchesSelector ||
                  docElem.msMatchesSelector)
              )) &&
                assert(function (div) {
                  (support.disconnectedMatch = matches.call(div, "div")),
                    matches.call(div, "[s!='']:x"),
                    rbuggyMatches.push("!=", pseudos);
                }),
              (rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"))),
              (rbuggyMatches =
                rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"))),
              (hasCompare = rnative.test(docElem.compareDocumentPosition)),
              (contains =
                hasCompare || rnative.test(docElem.contains)
                  ? function (a, b) {
                      var adown = a.nodeType === 9 ? a.documentElement : a,
                        bup = b && b.parentNode;
                      return (
                        a === bup ||
                        !!(
                          bup &&
                          bup.nodeType === 1 &&
                          (adown.contains
                            ? adown.contains(bup)
                            : a.compareDocumentPosition &&
                              a.compareDocumentPosition(bup) & 16)
                        )
                      );
                    }
                  : function (a, b) {
                      if (b) while ((b = b.parentNode)) if (b === a) return !0;
                      return !1;
                    }),
              (sortOrder = hasCompare
                ? function (a, b) {
                    if (a === b) return (hasDuplicate = !0), 0;
                    var compare =
                      !a.compareDocumentPosition - !b.compareDocumentPosition;
                    return compare
                      ? compare
                      : ((compare =
                          (a.ownerDocument || a) === (b.ownerDocument || b)
                            ? a.compareDocumentPosition(b)
                            : 1),
                        compare & 1 ||
                        (!support.sortDetached &&
                          b.compareDocumentPosition(a) === compare)
                          ? a === document ||
                            (a.ownerDocument === preferredDoc &&
                              contains(preferredDoc, a))
                            ? -1
                            : b === document ||
                              (b.ownerDocument === preferredDoc &&
                                contains(preferredDoc, b))
                            ? 1
                            : sortInput
                            ? indexOf(sortInput, a) - indexOf(sortInput, b)
                            : 0
                          : compare & 4
                          ? -1
                          : 1);
                  }
                : function (a, b) {
                    if (a === b) return (hasDuplicate = !0), 0;
                    var cur,
                      i = 0,
                      aup = a.parentNode,
                      bup = b.parentNode,
                      ap = [a],
                      bp = [b];
                    if (!(aup && bup))
                      return a === document
                        ? -1
                        : b === document
                        ? 1
                        : aup
                        ? -1
                        : bup
                        ? 1
                        : sortInput
                        ? indexOf(sortInput, a) - indexOf(sortInput, b)
                        : 0;
                    else if (aup === bup) return siblingCheck(a, b);
                    cur = a;
                    while ((cur = cur.parentNode)) ap.unshift(cur);
                    cur = b;
                    while ((cur = cur.parentNode)) bp.unshift(cur);
                    while (ap[i] === bp[i]) i++;
                    return i
                      ? siblingCheck(ap[i], bp[i])
                      : ap[i] === preferredDoc
                      ? -1
                      : bp[i] === preferredDoc
                      ? 1
                      : 0;
                  }),
              document);
        }),
      (Sizzle.matches = function (expr, elements) {
        return Sizzle(expr, null, null, elements);
      }),
      (Sizzle.matchesSelector = function (elem, expr) {
        if (
          ((elem.ownerDocument || elem) !== document && setDocument(elem),
          (expr = expr.replace(rattributeQuotes, "='$1']")),
          support.matchesSelector &&
            documentIsHTML &&
            !compilerCache[expr + " "] &&
            !(rbuggyMatches && rbuggyMatches.test(expr)) &&
            !(rbuggyQSA && rbuggyQSA.test(expr)))
        )
          try {
            var ret = matches.call(elem, expr);
            if (
              ret ||
              support.disconnectedMatch ||
              (elem.document && elem.document.nodeType !== 11)
            )
              return ret;
          } catch (e) {}
        return Sizzle(expr, document, null, [elem]).length > 0;
      }),
      (Sizzle.contains = function (context, elem) {
        return (
          (context.ownerDocument || context) !== document &&
            setDocument(context),
          contains(context, elem)
        );
      }),
      (Sizzle.attr = function (elem, name) {
        (elem.ownerDocument || elem) !== document && setDocument(elem);
        var fn = Expr.attrHandle[name.toLowerCase()],
          val =
            fn && hasOwn.call(Expr.attrHandle, name.toLowerCase())
              ? fn(elem, name, !documentIsHTML)
              : undefined;
        return val !== undefined
          ? val
          : support.attributes || !documentIsHTML
          ? elem.getAttribute(name)
          : (val = elem.getAttributeNode(name)) && val.specified
          ? val.value
          : null;
      }),
      (Sizzle.error = function (msg) {
        throw new Error("Syntax error, unrecognized expression: " + msg);
      }),
      (Sizzle.uniqueSort = function (results) {
        var elem,
          duplicates = [],
          j = 0,
          i = 0;
        if (
          ((hasDuplicate = !support.detectDuplicates),
          (sortInput = !support.sortStable && results.slice(0)),
          results.sort(sortOrder),
          hasDuplicate)
        ) {
          while ((elem = results[i++]))
            elem === results[i] && (j = duplicates.push(i));
          while (j--) results.splice(duplicates[j], 1);
        }
        return (sortInput = null), results;
      }),
      (getText = Sizzle.getText =
        function (elem) {
          var node,
            ret = "",
            i = 0,
            nodeType = elem.nodeType;
          if (!nodeType) while ((node = elem[i++])) ret += getText(node);
          else if (nodeType === 1 || nodeType === 9 || nodeType === 11)
            if (typeof elem.textContent === "string") return elem.textContent;
            else
              for (elem = elem.firstChild; elem; elem = elem.nextSibling)
                ret += getText(elem);
          else if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
          return ret;
        }),
      (Expr = Sizzle.selectors =
        {
          cacheLength: 50,
          createPseudo: markFunction,
          match: matchExpr,
          attrHandle: {},
          find: {},
          relative: {
            ">": { dir: "parentNode", first: !0 },
            " ": { dir: "parentNode" },
            "+": { dir: "previousSibling", first: !0 },
            "~": { dir: "previousSibling" },
          },
          preFilter: {
            ATTR: function (match) {
              return (
                (match[1] = match[1].replace(runescape, funescape)),
                (match[3] = (match[3] || match[4] || match[5] || "").replace(
                  runescape,
                  funescape
                )),
                match[2] === "~=" && (match[3] = " " + match[3] + " "),
                match.slice(0, 4)
              );
            },
            CHILD: function (match) {
              return (
                (match[1] = match[1].toLowerCase()),
                match[1].slice(0, 3) === "nth"
                  ? (match[3] || Sizzle.error(match[0]),
                    (match[4] = +(match[4]
                      ? match[5] + (match[6] || 1)
                      : 2 * (match[3] === "even" || match[3] === "odd"))),
                    (match[5] = +(match[7] + match[8] || match[3] === "odd")))
                  : match[3] && Sizzle.error(match[0]),
                match
              );
            },
            PSEUDO: function (match) {
              var excess,
                unquoted = !match[6] && match[2];
              return matchExpr.CHILD.test(match[0])
                ? null
                : (match[3]
                    ? (match[2] = match[4] || match[5] || "")
                    : unquoted &&
                      rpseudo.test(unquoted) &&
                      (excess = tokenize(unquoted, !0)) &&
                      (excess =
                        unquoted.indexOf(")", unquoted.length - excess) -
                        unquoted.length) &&
                      ((match[0] = match[0].slice(0, excess)),
                      (match[2] = unquoted.slice(0, excess))),
                  match.slice(0, 3));
            },
          },
          filter: {
            TAG: function (nodeNameSelector) {
              var nodeName = nodeNameSelector
                .replace(runescape, funescape)
                .toLowerCase();
              return nodeNameSelector === "*"
                ? function () {
                    return !0;
                  }
                : function (elem) {
                    return (
                      elem.nodeName && elem.nodeName.toLowerCase() === nodeName
                    );
                  };
            },
            CLASS: function (className) {
              var pattern = classCache[className + " "];
              return (
                pattern ||
                ((pattern = new RegExp(
                  "(^|" +
                    whitespace +
                    ")" +
                    className +
                    "(" +
                    whitespace +
                    "|$)"
                )) &&
                  classCache(className, function (elem) {
                    return pattern.test(
                      (typeof elem.className === "string" && elem.className) ||
                        (elem.getAttribute !== void 0 &&
                          elem.getAttribute("class")) ||
                        ""
                    );
                  }))
              );
            },
            ATTR: function (name, operator, check) {
              return function (elem) {
                var result = Sizzle.attr(elem, name);
                return result == null
                  ? operator === "!="
                  : operator
                  ? ((result += ""),
                    operator === "="
                      ? result === check
                      : operator === "!="
                      ? result !== check
                      : operator === "^="
                      ? check && result.indexOf(check) === 0
                      : operator === "*="
                      ? check && result.indexOf(check) > -1
                      : operator === "$="
                      ? check && result.slice(-check.length) === check
                      : operator === "~="
                      ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(
                          check
                        ) > -1
                      : operator === "|="
                      ? result === check ||
                        result.slice(0, check.length + 1) === check + "-"
                      : !1)
                  : !0;
              };
            },
            CHILD: function (type, what, argument, first, last) {
              var simple = type.slice(0, 3) !== "nth",
                forward = type.slice(-4) !== "last",
                ofType = what === "of-type";
              return first === 1 && last === 0
                ? function (elem) {
                    return !!elem.parentNode;
                  }
                : function (elem, context, xml) {
                    var cache,
                      uniqueCache,
                      outerCache,
                      node,
                      nodeIndex,
                      start,
                      dir =
                        simple !== forward ? "nextSibling" : "previousSibling",
                      parent = elem.parentNode,
                      name = ofType && elem.nodeName.toLowerCase(),
                      useCache = !xml && !ofType,
                      diff = !1;
                    if (parent) {
                      if (simple) {
                        while (dir) {
                          node = elem;
                          while ((node = node[dir]))
                            if (
                              ofType
                                ? node.nodeName.toLowerCase() === name
                                : node.nodeType === 1
                            )
                              return !1;
                          start = dir =
                            type === "only" && !start && "nextSibling";
                        }
                        return !0;
                      }
                      if (
                        ((start = [
                          forward ? parent.firstChild : parent.lastChild,
                        ]),
                        forward && useCache)
                      ) {
                        (node = parent),
                          (outerCache = node[expando] || (node[expando] = {})),
                          (uniqueCache =
                            outerCache[node.uniqueID] ||
                            (outerCache[node.uniqueID] = {})),
                          (cache = uniqueCache[type] || []),
                          (nodeIndex = cache[0] === dirruns && cache[1]),
                          (diff = nodeIndex && cache[2]),
                          (node = nodeIndex && parent.childNodes[nodeIndex]);
                        while (
                          (node =
                            (++nodeIndex && node && node[dir]) ||
                            (diff = nodeIndex = 0) ||
                            start.pop())
                        )
                          if (node.nodeType === 1 && ++diff && node === elem) {
                            uniqueCache[type] = [dirruns, nodeIndex, diff];
                            break;
                          }
                      } else if (
                        (useCache &&
                          ((node = elem),
                          (outerCache = node[expando] || (node[expando] = {})),
                          (uniqueCache =
                            outerCache[node.uniqueID] ||
                            (outerCache[node.uniqueID] = {})),
                          (cache = uniqueCache[type] || []),
                          (nodeIndex = cache[0] === dirruns && cache[1]),
                          (diff = nodeIndex)),
                        diff === !1)
                      )
                        while (
                          (node =
                            (++nodeIndex && node && node[dir]) ||
                            (diff = nodeIndex = 0) ||
                            start.pop())
                        )
                          if (
                            (ofType
                              ? node.nodeName.toLowerCase() === name
                              : node.nodeType === 1) &&
                            ++diff &&
                            (useCache &&
                              ((outerCache =
                                node[expando] || (node[expando] = {})),
                              (uniqueCache =
                                outerCache[node.uniqueID] ||
                                (outerCache[node.uniqueID] = {})),
                              (uniqueCache[type] = [dirruns, diff])),
                            node === elem)
                          )
                            break;
                      return (
                        (diff -= last),
                        diff === first ||
                          (diff % first === 0 && diff / first >= 0)
                      );
                    }
                  };
            },
            PSEUDO: function (pseudo, argument) {
              var args,
                fn =
                  Expr.pseudos[pseudo] ||
                  Expr.setFilters[pseudo.toLowerCase()] ||
                  Sizzle.error("unsupported pseudo: " + pseudo);
              return fn[expando]
                ? fn(argument)
                : fn.length > 1
                ? ((args = [pseudo, pseudo, "", argument]),
                  Expr.setFilters.hasOwnProperty(pseudo.toLowerCase())
                    ? markFunction(function (seed, matches) {
                        var idx,
                          matched = fn(seed, argument),
                          i = matched.length;
                        while (i--)
                          (idx = indexOf(seed, matched[i])),
                            (seed[idx] = !(matches[idx] = matched[i]));
                      })
                    : function (elem) {
                        return fn(elem, 0, args);
                      })
                : fn;
            },
          },
          pseudos: {
            not: markFunction(function (selector) {
              var input = [],
                results = [],
                matcher = compile(selector.replace(rtrim, "$1"));
              return matcher[expando]
                ? markFunction(function (seed, matches, context, xml) {
                    var elem,
                      unmatched = matcher(seed, null, xml, []),
                      i = seed.length;
                    while (i--)
                      (elem = unmatched[i]) && (seed[i] = !(matches[i] = elem));
                  })
                : function (elem, context, xml) {
                    return (
                      (input[0] = elem),
                      matcher(input, null, xml, results),
                      (input[0] = null),
                      !results.pop()
                    );
                  };
            }),
            has: markFunction(function (selector) {
              return function (elem) {
                return Sizzle(selector, elem).length > 0;
              };
            }),
            contains: markFunction(function (text) {
              return (
                (text = text.replace(runescape, funescape)),
                function (elem) {
                  return (
                    (
                      elem.textContent ||
                      elem.innerText ||
                      getText(elem)
                    ).indexOf(text) > -1
                  );
                }
              );
            }),
            lang: markFunction(function (lang) {
              return (
                ridentifier.test(lang || "") ||
                  Sizzle.error("unsupported lang: " + lang),
                (lang = lang.replace(runescape, funescape).toLowerCase()),
                function (elem) {
                  var elemLang;
                  do
                    if (
                      (elemLang = documentIsHTML
                        ? elem.lang
                        : elem.getAttribute("xml:lang") ||
                          elem.getAttribute("lang"))
                    )
                      return (
                        (elemLang = elemLang.toLowerCase()),
                        elemLang === lang || elemLang.indexOf(lang + "-") === 0
                      );
                  while ((elem = elem.parentNode) && elem.nodeType === 1);
                  return !1;
                }
              );
            }),
            target: function (elem) {
              var hash = window.location && window.location.hash;
              return hash && hash.slice(1) === elem.id;
            },
            root: function (elem) {
              return elem === docElem;
            },
            focus: function (elem) {
              return (
                elem === document.activeElement &&
                (!document.hasFocus || document.hasFocus()) &&
                !!(elem.type || elem.href || ~elem.tabIndex)
              );
            },
            enabled: function (elem) {
              return elem.disabled === !1;
            },
            disabled: function (elem) {
              return elem.disabled === !0;
            },
            checked: function (elem) {
              var nodeName = elem.nodeName.toLowerCase();
              return (
                (nodeName === "input" && !!elem.checked) ||
                (nodeName === "option" && !!elem.selected)
              );
            },
            selected: function (elem) {
              return (
                elem.parentNode && elem.parentNode.selectedIndex,
                elem.selected === !0
              );
            },
            empty: function (elem) {
              for (elem = elem.firstChild; elem; elem = elem.nextSibling)
                if (elem.nodeType < 6) return !1;
              return !0;
            },
            parent: function (elem) {
              return !Expr.pseudos.empty(elem);
            },
            header: function (elem) {
              return rheader.test(elem.nodeName);
            },
            input: function (elem) {
              return rinputs.test(elem.nodeName);
            },
            button: function (elem) {
              var name = elem.nodeName.toLowerCase();
              return (
                (name === "input" && elem.type === "button") ||
                name === "button"
              );
            },
            text: function (elem) {
              var attr;
              return (
                elem.nodeName.toLowerCase() === "input" &&
                elem.type === "text" &&
                ((attr = elem.getAttribute("type")) == null ||
                  attr.toLowerCase() === "text")
              );
            },
            first: createPositionalPseudo(function () {
              return [0];
            }),
            last: createPositionalPseudo(function (matchIndexes, length) {
              return [length - 1];
            }),
            eq: createPositionalPseudo(function (
              matchIndexes,
              length,
              argument
            ) {
              return [argument < 0 ? argument + length : argument];
            }),
            even: createPositionalPseudo(function (matchIndexes, length) {
              var i = 0;
              for (; i < length; i += 2) matchIndexes.push(i);
              return matchIndexes;
            }),
            odd: createPositionalPseudo(function (matchIndexes, length) {
              var i = 1;
              for (; i < length; i += 2) matchIndexes.push(i);
              return matchIndexes;
            }),
            lt: createPositionalPseudo(function (
              matchIndexes,
              length,
              argument
            ) {
              var i = argument < 0 ? argument + length : argument;
              for (; --i >= 0; ) matchIndexes.push(i);
              return matchIndexes;
            }),
            gt: createPositionalPseudo(function (
              matchIndexes,
              length,
              argument
            ) {
              var i = argument < 0 ? argument + length : argument;
              for (; ++i < length; ) matchIndexes.push(i);
              return matchIndexes;
            }),
          },
        }),
      (Expr.pseudos.nth = Expr.pseudos.eq);
    for (i in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 })
      Expr.pseudos[i] = createInputPseudo(i);
    for (i in { submit: !0, reset: !0 })
      Expr.pseudos[i] = createButtonPseudo(i);
    return (
      (setFilters.prototype = Expr.filters = Expr.pseudos),
      (Expr.setFilters = new setFilters()),
      (tokenize = Sizzle.tokenize =
        function (selector, parseOnly) {
          var matched,
            match,
            tokens,
            type,
            soFar,
            groups,
            preFilters,
            cached = tokenCache[selector + " "];
          if (cached) return parseOnly ? 0 : cached.slice(0);
          (soFar = selector), (groups = []), (preFilters = Expr.preFilter);
          while (soFar) {
            (!matched || (match = rcomma.exec(soFar))) &&
              (match && (soFar = soFar.slice(match[0].length) || soFar),
              groups.push((tokens = []))),
              (matched = !1),
              (match = rcombinators.exec(soFar)) &&
                ((matched = match.shift()),
                tokens.push({
                  value: matched,
                  type: match[0].replace(rtrim, " "),
                }),
                (soFar = soFar.slice(matched.length)));
            for (type in Expr.filter)
              (match = matchExpr[type].exec(soFar)) &&
                (!preFilters[type] || (match = preFilters[type](match))) &&
                ((matched = match.shift()),
                tokens.push({ value: matched, type: type, matches: match }),
                (soFar = soFar.slice(matched.length)));
            if (!matched) break;
          }
          return parseOnly
            ? soFar.length
            : soFar
            ? Sizzle.error(selector)
            : tokenCache(selector, groups).slice(0);
        }),
      (compile = Sizzle.compile =
        function (selector, match) {
          var i,
            setMatchers = [],
            elementMatchers = [],
            cached = compilerCache[selector + " "];
          if (!cached) {
            match || (match = tokenize(selector)), (i = match.length);
            while (i--)
              (cached = matcherFromTokens(match[i])),
                cached[expando]
                  ? setMatchers.push(cached)
                  : elementMatchers.push(cached);
            (cached = compilerCache(
              selector,
              matcherFromGroupMatchers(elementMatchers, setMatchers)
            )),
              (cached.selector = selector);
          }
          return cached;
        }),
      (select = Sizzle.select =
        function (selector, context, results, seed) {
          var i,
            tokens,
            token,
            type,
            find,
            compiled = typeof selector === "function" && selector,
            match =
              !seed && tokenize((selector = compiled.selector || selector));
          if (((results = results || []), match.length === 1)) {
            if (
              ((tokens = match[0] = match[0].slice(0)),
              tokens.length > 2 &&
                (token = tokens[0]).type === "ID" &&
                support.getById &&
                context.nodeType === 9 &&
                documentIsHTML &&
                Expr.relative[tokens[1].type])
            ) {
              if (
                ((context = (Expr.find.ID(
                  token.matches[0].replace(runescape, funescape),
                  context
                ) || [])[0]),
                !context)
              )
                return results;
              else compiled && (context = context.parentNode);
              selector = selector.slice(tokens.shift().value.length);
            }
            i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
            while (i--) {
              if (((token = tokens[i]), Expr.relative[(type = token.type)]))
                break;
              if (
                (find = Expr.find[type]) &&
                (seed = find(
                  token.matches[0].replace(runescape, funescape),
                  (rsibling.test(tokens[0].type) &&
                    testContext(context.parentNode)) ||
                    context
                ))
              ) {
                if (
                  (tokens.splice(i, 1),
                  (selector = seed.length && toSelector(tokens)),
                  !selector)
                )
                  return push.apply(results, seed), results;
                break;
              }
            }
          }
          return (
            (compiled || compile(selector, match))(
              seed,
              context,
              !documentIsHTML,
              results,
              !context ||
                (rsibling.test(selector) && testContext(context.parentNode)) ||
                context
            ),
            results
          );
        }),
      (support.sortStable =
        expando.split("").sort(sortOrder).join("") === expando),
      (support.detectDuplicates = !!hasDuplicate),
      setDocument(),
      (support.sortDetached = assert(function (div1) {
        return div1.compareDocumentPosition(document.createElement("div")) & 1;
      })),
      assert(function (div) {
        return (
          (div.innerHTML = "<a href='#'></a>"),
          div.firstChild.getAttribute("href") === "#"
        );
      }) ||
        addHandle("type|href|height|width", function (elem, name, isXML) {
          return isXML
            ? void 0
            : elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
        }),
      (support.attributes &&
        assert(function (div) {
          return (
            (div.innerHTML = "<input/>"),
            div.firstChild.setAttribute("value", ""),
            div.firstChild.getAttribute("value") === ""
          );
        })) ||
        addHandle("value", function (elem, name, isXML) {
          return !isXML && elem.nodeName.toLowerCase() === "input"
            ? elem.defaultValue
            : void 0;
        }),
      assert(function (div) {
        return div.getAttribute("disabled") == null;
      }) ||
        addHandle(booleans, function (elem, name, isXML) {
          var val;
          return isXML
            ? void 0
            : elem[name] === !0
            ? name.toLowerCase()
            : (val = elem.getAttributeNode(name)) && val.specified
            ? val.value
            : null;
        }),
      Sizzle
    );
  })(window);
  (Flits.find = Sizzle),
    (Flits.expr = Sizzle.selectors),
    (Flits.expr[":"] = Flits.expr.pseudos),
    (Flits.uniqueSort = Flits.unique = Sizzle.uniqueSort),
    (Flits.text = Sizzle.getText),
    (Flits.isXMLDoc = Sizzle.isXML),
    (Flits.contains = Sizzle.contains);
  var dir = function (elem, dir, until) {
    var matched = [],
      truncate = until !== undefined;
    while ((elem = elem[dir]) && elem.nodeType !== 9)
      if (elem.nodeType === 1) {
        if (truncate && Flits(elem).is(until)) break;
        matched.push(elem);
      }
    return matched;
  };
  var siblings = function (n, elem) {
    var matched = [];
    for (; n; n = n.nextSibling)
      n.nodeType === 1 && n !== elem && matched.push(n);
    return matched;
  };
  var rneedsContext = Flits.expr.match.needsContext;
  var rsingleTag = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
  var risSimple = /^.[^:#\[\.,]*$/;
  (Flits.filter = function (expr, elems, not) {
    var elem = elems[0];
    return (
      not && (expr = ":not(" + expr + ")"),
      elems.length === 1 && elem.nodeType === 1
        ? Flits.find.matchesSelector(elem, expr)
          ? [elem]
          : []
        : Flits.find.matches(
            expr,
            Flits.grep(elems, function (elem) {
              return elem.nodeType === 1;
            })
          )
    );
  }),
    Flits.fn.extend({
      find: function (selector) {
        var i,
          len = this.length,
          ret = [],
          self = this;
        if (typeof selector !== "string")
          return this.pushStack(
            Flits(selector).filter(function () {
              for (i = 0; i < len; i++)
                if (Flits.contains(self[i], this)) return !0;
            })
          );
        for (i = 0; i < len; i++) Flits.find(selector, self[i], ret);
        return (
          (ret = this.pushStack(len > 1 ? Flits.unique(ret) : ret)),
          (ret.selector = this.selector
            ? this.selector + " " + selector
            : selector),
          ret
        );
      },
      filter: function (selector) {
        return this.pushStack(winnow(this, selector || [], !1));
      },
      not: function (selector) {
        return this.pushStack(winnow(this, selector || [], !0));
      },
      is: function (selector) {
        return !!winnow(
          this,
          typeof selector === "string" && rneedsContext.test(selector)
            ? Flits(selector)
            : selector || [],
          !1
        ).length;
      },
    });
  var rootFlits,
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
    init = (Flits.fn.init = function (selector, context, root) {
      var match, elem;
      if (!selector) return this;
      if (((root = root || rootFlits), typeof selector === "string"))
        if (
          (selector[0] === "<" &&
          selector[selector.length - 1] === ">" &&
          selector.length >= 3
            ? (match = [null, selector, null])
            : (match = rquickExpr.exec(selector)),
          match && (match[1] || !context))
        )
          if (match[1]) {
            if (
              ((context = context instanceof Flits ? context[0] : context),
              Flits.merge(
                this,
                Flits.parseHTML(
                  match[1],
                  context && context.nodeType
                    ? context.ownerDocument || context
                    : document,
                  !0
                )
              ),
              rsingleTag.test(match[1]) && Flits.isPlainObject(context))
            )
              for (match in context)
                Flits.isFunction(this[match])
                  ? this[match](context[match])
                  : this.attr(match, context[match]);
            return this;
          } else
            return (
              (elem = document.getElementById(match[2])),
              elem && elem.parentNode && ((this.length = 1), (this[0] = elem)),
              (this.context = document),
              (this.selector = selector),
              this
            );
        else
          return !context || context.Flits
            ? (context || root).find(selector)
            : this.constructor(context).find(selector);
      else if (selector.nodeType)
        return (this.context = this[0] = selector), (this.length = 1), this;
      else if (Flits.isFunction(selector))
        return root.ready !== undefined
          ? root.ready(selector)
          : selector(Flits);
      return (
        selector.selector !== undefined &&
          ((this.selector = selector.selector),
          (this.context = selector.context)),
        Flits.makeArray(selector, this)
      );
    });
  (init.prototype = Flits.fn), (rootFlits = Flits(document));
  var rparentsprev = /^(?:parents|prev(?:Until|All))/,
    guaranteedUnique = { children: !0, contents: !0, next: !0, prev: !0 };
  Flits.fn.extend({
    has: function (target) {
      var targets = Flits(target, this),
        l = targets.length;
      return this.filter(function () {
        var i = 0;
        for (; i < l; i++) if (Flits.contains(this, targets[i])) return !0;
      });
    },
    closest: function (selectors, context) {
      var cur,
        i = 0,
        l = this.length,
        matched = [],
        pos =
          rneedsContext.test(selectors) || typeof selectors !== "string"
            ? Flits(selectors, context || this.context)
            : 0;
      for (; i < l; i++)
        for (cur = this[i]; cur && cur !== context; cur = cur.parentNode)
          if (
            cur.nodeType < 11 &&
            (pos
              ? pos.index(cur) > -1
              : cur.nodeType === 1 &&
                Flits.find.matchesSelector(cur, selectors))
          ) {
            matched.push(cur);
            break;
          }
      return this.pushStack(
        matched.length > 1 ? Flits.uniqueSort(matched) : matched
      );
    },
    index: function (elem) {
      return elem
        ? typeof elem === "string"
          ? indexOf.call(Flits(elem), this[0])
          : indexOf.call(this, elem.Flits ? elem[0] : elem)
        : this[0] && this[0].parentNode
        ? this.first().prevAll().length
        : -1;
    },
    add: function (selector, context) {
      return this.pushStack(
        Flits.uniqueSort(Flits.merge(this.get(), Flits(selector, context)))
      );
    },
    addBack: function (selector) {
      return this.add(
        selector == null ? this.prevObject : this.prevObject.filter(selector)
      );
    },
  }),
    Flits.each(
      {
        parent: function (elem) {
          var parent = elem.parentNode;
          return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function (elem) {
          return dir(elem, "parentNode");
        },
        parentsUntil: function (elem, i, until) {
          return dir(elem, "parentNode", until);
        },
        next: function (elem) {
          return sibling(elem, "nextSibling");
        },
        prev: function (elem) {
          return sibling(elem, "previousSibling");
        },
        nextAll: function (elem) {
          return dir(elem, "nextSibling");
        },
        prevAll: function (elem) {
          return dir(elem, "previousSibling");
        },
        nextUntil: function (elem, i, until) {
          return dir(elem, "nextSibling", until);
        },
        prevUntil: function (elem, i, until) {
          return dir(elem, "previousSibling", until);
        },
        siblings: function (elem) {
          return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function (elem) {
          return siblings(elem.firstChild);
        },
        contents: function (elem) {
          return elem.contentDocument || Flits.merge([], elem.childNodes);
        },
      },
      function (name, fn) {
        Flits.fn[name] = function (until, selector) {
          var matched = Flits.map(this, fn, until);
          return (
            name.slice(-5) !== "Until" && (selector = until),
            selector &&
              typeof selector === "string" &&
              (matched = Flits.filter(selector, matched)),
            this.length > 1 &&
              (guaranteedUnique[name] || Flits.uniqueSort(matched),
              rparentsprev.test(name) && matched.reverse()),
            this.pushStack(matched)
          );
        };
      }
    );
  var rnotwhite = /\S+/g;
  (Flits.Callbacks = function (options) {
    options =
      typeof options === "string"
        ? createOptions(options)
        : Flits.extend({}, options);
    var firing,
      memory,
      fired,
      locked,
      list = [],
      queue = [],
      firingIndex = -1,
      fire = function () {
        for (
          locked = options.once, fired = firing = !0;
          queue.length;
          firingIndex = -1
        ) {
          memory = queue.shift();
          while (++firingIndex < list.length)
            list[firingIndex].apply(memory[0], memory[1]) === !1 &&
              options.stopOnFalse &&
              ((firingIndex = list.length), (memory = !1));
        }
        options.memory || (memory = !1),
          (firing = !1),
          locked && (memory ? (list = []) : (list = ""));
      },
      self = {
        add: function () {
          return (
            list &&
              (memory &&
                !firing &&
                ((firingIndex = list.length - 1), queue.push(memory)),
              (function add(args) {
                Flits.each(args, function (_, arg) {
                  Flits.isFunction(arg)
                    ? (options.unique && self.has(arg)) || list.push(arg)
                    : arg &&
                      arg.length &&
                      Flits.type(arg) !== "string" &&
                      add(arg);
                });
              })(arguments),
              memory && !firing && fire()),
            this
          );
        },
        remove: function () {
          return (
            Flits.each(arguments, function (_, arg) {
              var index;
              while ((index = Flits.inArray(arg, list, index)) > -1)
                list.splice(index, 1), index <= firingIndex && firingIndex--;
            }),
            this
          );
        },
        has: function (fn) {
          return fn ? Flits.inArray(fn, list) > -1 : list.length > 0;
        },
        empty: function () {
          return list && (list = []), this;
        },
        disable: function () {
          return (locked = queue = []), (list = memory = ""), this;
        },
        disabled: function () {
          return !list;
        },
        lock: function () {
          return (locked = queue = []), memory || (list = memory = ""), this;
        },
        locked: function () {
          return !!locked;
        },
        fireWith: function (context, args) {
          return (
            locked ||
              ((args = args || []),
              (args = [context, args.slice ? args.slice() : args]),
              queue.push(args),
              firing || fire()),
            this
          );
        },
        fire: function () {
          return self.fireWith(this, arguments), this;
        },
        fired: function () {
          return !!fired;
        },
      };
    return self;
  }),
    Flits.extend({
      Deferred: function (func) {
        var tuples = [
            ["resolve", "done", Flits.Callbacks("once memory"), "resolved"],
            ["reject", "fail", Flits.Callbacks("once memory"), "rejected"],
            ["notify", "progress", Flits.Callbacks("memory")],
          ],
          state = "pending",
          promise = {
            state: function () {
              return state;
            },
            always: function () {
              return deferred.done(arguments).fail(arguments), this;
            },
            then: function () {
              var fns = arguments;
              return Flits.Deferred(function (newDefer) {
                Flits.each(tuples, function (i, tuple) {
                  var fn = Flits.isFunction(fns[i]) && fns[i];
                  deferred[tuple[1]](function () {
                    var returned = fn && fn.apply(this, arguments);
                    returned && Flits.isFunction(returned.promise)
                      ? returned
                          .promise()
                          .progress(newDefer.notify)
                          .done(newDefer.resolve)
                          .fail(newDefer.reject)
                      : newDefer[tuple[0] + "With"](
                          this === promise ? newDefer.promise() : this,
                          fn ? [returned] : arguments
                        );
                  });
                }),
                  (fns = null);
              }).promise();
            },
            promise: function (obj) {
              return obj != null ? Flits.extend(obj, promise) : promise;
            },
          },
          deferred = {};
        return (
          (promise.pipe = promise.then),
          Flits.each(tuples, function (i, tuple) {
            var list = tuple[2],
              stateString = tuple[3];
            (promise[tuple[1]] = list.add),
              stateString &&
                list.add(
                  function () {
                    state = stateString;
                  },
                  tuples[i ^ 1][2].disable,
                  tuples[2][2].lock
                ),
              (deferred[tuple[0]] = function () {
                return (
                  deferred[tuple[0] + "With"](
                    this === deferred ? promise : this,
                    arguments
                  ),
                  this
                );
              }),
              (deferred[tuple[0] + "With"] = list.fireWith);
          }),
          promise.promise(deferred),
          func && func.call(deferred, deferred),
          deferred
        );
      },
      when: function (subordinate) {
        var i = 0,
          resolveValues = slice.call(arguments),
          length = resolveValues.length,
          remaining =
            length !== 1 ||
            (subordinate && Flits.isFunction(subordinate.promise))
              ? length
              : 0,
          deferred = remaining === 1 ? subordinate : Flits.Deferred(),
          updateFunc = function (i, contexts, values) {
            return function (value) {
              (contexts[i] = this),
                (values[i] =
                  arguments.length > 1 ? slice.call(arguments) : value),
                values === progressValues
                  ? deferred.notifyWith(contexts, values)
                  : --remaining || deferred.resolveWith(contexts, values);
            };
          },
          progressValues,
          progressContexts,
          resolveContexts;
        if (length > 1)
          for (
            progressValues = new Array(length),
              progressContexts = new Array(length),
              resolveContexts = new Array(length);
            i < length;
            i++
          )
            resolveValues[i] && Flits.isFunction(resolveValues[i].promise)
              ? resolveValues[i]
                  .promise()
                  .progress(updateFunc(i, progressContexts, progressValues))
                  .done(updateFunc(i, resolveContexts, resolveValues))
                  .fail(deferred.reject)
              : --remaining;
        return (
          remaining || deferred.resolveWith(resolveContexts, resolveValues),
          deferred.promise()
        );
      },
    });
  var readyList;
  (Flits.fn.ready = function (fn) {
    return Flits.ready.promise().done(fn), this;
  }),
    Flits.extend({
      isReady: !1,
      readyWait: 1,
      holdReady: function (hold) {
        hold ? Flits.readyWait++ : Flits.ready(!0);
      },
      ready: function (wait) {
        if (wait === !0 ? --Flits.readyWait : Flits.isReady) return;
        if (((Flits.isReady = !0), wait !== !0 && --Flits.readyWait > 0))
          return;
        readyList.resolveWith(document, [Flits]),
          Flits.fn.triggerHandler &&
            (Flits(document).triggerHandler("ready"),
            Flits(document).off("ready"));
      },
    }),
    (Flits.ready.promise = function (obj) {
      return (
        readyList ||
          ((readyList = Flits.Deferred()),
          document.readyState === "complete" ||
          (document.readyState !== "loading" &&
            !document.documentElement.doScroll)
            ? window.setTimeout(Flits.ready)
            : (document.addEventListener("DOMContentLoaded", completed),
              window.addEventListener("load", completed))),
        readyList.promise(obj)
      );
    }),
    Flits.ready.promise();
  var access = function (elems, fn, key, value, chainable, emptyGet, raw) {
    var i = 0,
      len = elems.length,
      bulk = key == null;
    if (Flits.type(key) === "object") {
      chainable = !0;
      for (i in key) access(elems, fn, i, key[i], !0, emptyGet, raw);
    } else if (
      value !== undefined &&
      ((chainable = !0),
      Flits.isFunction(value) || (raw = !0),
      bulk &&
        (raw
          ? (fn.call(elems, value), (fn = null))
          : ((bulk = fn),
            (fn = function (elem, key, value) {
              return bulk.call(Flits(elem), value);
            }))),
      fn)
    )
      for (; i < len; i++)
        fn(
          elems[i],
          key,
          raw ? value : value.call(elems[i], i, fn(elems[i], key))
        );
    return chainable
      ? elems
      : bulk
      ? fn.call(elems)
      : len
      ? fn(elems[0], key)
      : emptyGet;
  };
  var acceptData = function (owner) {
    return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
  };
  (Data.uid = 1),
    (Data.prototype = {
      register: function (owner, initial) {
        var value = initial || {};
        return (
          owner.nodeType
            ? (owner[this.expando] = value)
            : Object.defineProperty(owner, this.expando, {
                value: value,
                writable: !0,
                configurable: !0,
              }),
          owner[this.expando]
        );
      },
      cache: function (owner) {
        if (!acceptData(owner)) return {};
        var value = owner[this.expando];
        return (
          value ||
            ((value = {}),
            acceptData(owner) &&
              (owner.nodeType
                ? (owner[this.expando] = value)
                : Object.defineProperty(owner, this.expando, {
                    value: value,
                    configurable: !0,
                  }))),
          value
        );
      },
      set: function (owner, data, value) {
        var prop,
          cache = this.cache(owner);
        if (typeof data === "string") cache[data] = value;
        else for (prop in data) cache[prop] = data[prop];
        return cache;
      },
      get: function (owner, key) {
        return key === undefined
          ? this.cache(owner)
          : owner[this.expando] && owner[this.expando][key];
      },
      access: function (owner, key, value) {
        var stored;
        return key === undefined ||
          (key && typeof key === "string" && value === undefined)
          ? ((stored = this.get(owner, key)),
            stored !== undefined
              ? stored
              : this.get(owner, Flits.camelCase(key)))
          : (this.set(owner, key, value), value !== undefined ? value : key);
      },
      remove: function (owner, key) {
        var i,
          name,
          camel,
          cache = owner[this.expando];
        if (cache === undefined) return;
        if (key === undefined) this.register(owner);
        else {
          Flits.isArray(key)
            ? (name = key.concat(key.map(Flits.camelCase)))
            : ((camel = Flits.camelCase(key)),
              key in cache
                ? (name = [key, camel])
                : ((name = camel),
                  (name =
                    name in cache ? [name] : name.match(rnotwhite) || []))),
            (i = name.length);
          while (i--) delete cache[name[i]];
        }
        (key === undefined || Flits.isEmptyObject(cache)) &&
          (owner.nodeType
            ? (owner[this.expando] = undefined)
            : delete owner[this.expando]);
      },
      hasData: function (owner) {
        var cache = owner[this.expando];
        return cache !== undefined && !Flits.isEmptyObject(cache);
      },
    });
  var dataPriv = new Data();
  var dataUser = new Data();
  var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    rmultiDash = /[A-Z]/g;
  Flits.extend({
    hasData: function (elem) {
      return dataUser.hasData(elem) || dataPriv.hasData(elem);
    },
    data: function (elem, name, data) {
      return dataUser.access(elem, name, data);
    },
    removeData: function (elem, name) {
      dataUser.remove(elem, name);
    },
    _data: function (elem, name, data) {
      return dataPriv.access(elem, name, data);
    },
    _removeData: function (elem, name) {
      dataPriv.remove(elem, name);
    },
  }),
    Flits.fn.extend({
      data: function (key, value) {
        var i,
          name,
          data,
          elem = this[0],
          attrs = elem && elem.attributes;
        if (key === undefined) {
          if (
            this.length &&
            ((data = dataUser.get(elem)),
            elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs"))
          ) {
            i = attrs.length;
            while (i--)
              attrs[i] &&
                ((name = attrs[i].name),
                name.indexOf("data-") === 0 &&
                  ((name = Flits.camelCase(name.slice(5))),
                  dataAttr(elem, name, data[name])));
            dataPriv.set(elem, "hasDataAttrs", !0);
          }
          return data;
        }
        return typeof key === "object"
          ? this.each(function () {
              dataUser.set(this, key);
            })
          : access(
              this,
              function (value) {
                var data, camelKey;
                if (elem && value === undefined)
                  return (
                    (data =
                      dataUser.get(elem, key) ||
                      dataUser.get(
                        elem,
                        key.replace(rmultiDash, "-$&").toLowerCase()
                      )),
                    data !== undefined
                      ? data
                      : ((camelKey = Flits.camelCase(key)),
                        (data = dataUser.get(elem, camelKey)),
                        data !== undefined
                          ? data
                          : ((data = dataAttr(elem, camelKey, undefined)),
                            data !== undefined ? data : void 0))
                  );
                (camelKey = Flits.camelCase(key)),
                  this.each(function () {
                    var data = dataUser.get(this, camelKey);
                    dataUser.set(this, camelKey, value),
                      key.indexOf("-") > -1 &&
                        data !== undefined &&
                        dataUser.set(this, key, value);
                  });
              },
              null,
              value,
              arguments.length > 1,
              null,
              !0
            );
      },
      removeData: function (key) {
        return this.each(function () {
          dataUser.remove(this, key);
        });
      },
    }),
    Flits.extend({
      queue: function (elem, type, data) {
        var queue;
        return elem
          ? ((type = (type || "fx") + "queue"),
            (queue = dataPriv.get(elem, type)),
            data &&
              (!queue || Flits.isArray(data)
                ? (queue = dataPriv.access(elem, type, Flits.makeArray(data)))
                : queue.push(data)),
            queue || [])
          : void 0;
      },
      dequeue: function (elem, type) {
        type = type || "fx";
        var queue = Flits.queue(elem, type),
          startLength = queue.length,
          fn = queue.shift(),
          hooks = Flits._queueHooks(elem, type),
          next = function () {
            Flits.dequeue(elem, type);
          };
        fn === "inprogress" && ((fn = queue.shift()), startLength--),
          fn &&
            (type === "fx" && queue.unshift("inprogress"),
            delete hooks.stop,
            fn.call(elem, next, hooks)),
          !startLength && hooks && hooks.empty.fire();
      },
      _queueHooks: function (elem, type) {
        var key = type + "queueHooks";
        return (
          dataPriv.get(elem, key) ||
          dataPriv.access(elem, key, {
            empty: Flits.Callbacks("once memory").add(function () {
              dataPriv.remove(elem, [type + "queue", key]);
            }),
          })
        );
      },
    }),
    Flits.fn.extend({
      queue: function (type, data) {
        var setter = 2;
        return (
          typeof type !== "string" && ((data = type), (type = "fx"), setter--),
          arguments.length < setter
            ? Flits.queue(this[0], type)
            : data === undefined
            ? this
            : this.each(function () {
                var queue = Flits.queue(this, type, data);
                Flits._queueHooks(this, type),
                  type === "fx" &&
                    queue[0] !== "inprogress" &&
                    Flits.dequeue(this, type);
              })
        );
      },
      dequeue: function (type) {
        return this.each(function () {
          Flits.dequeue(this, type);
        });
      },
      clearQueue: function (type) {
        return this.queue(type || "fx", []);
      },
      promise: function (type, obj) {
        var tmp,
          count = 1,
          defer = Flits.Deferred(),
          elements = this,
          i = this.length,
          resolve = function () {
            --count || defer.resolveWith(elements, [elements]);
          };
        typeof type !== "string" && ((obj = type), (type = undefined)),
          (type = type || "fx");
        while (i--)
          (tmp = dataPriv.get(elements[i], type + "queueHooks")),
            tmp && tmp.empty && (count++, tmp.empty.add(resolve));
        return resolve(), defer.promise(obj);
      },
    });
  var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
  var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
  var cssExpand = ["Top", "Right", "Bottom", "Left"];
  var isHidden = function (elem, el) {
    return (
      (elem = el || elem),
      Flits.css(elem, "display") === "none" ||
        !Flits.contains(elem.ownerDocument, elem)
    );
  };
  var rcheckableType = /^(?:checkbox|radio)$/i;
  var rtagName = /<([\w:-]+)/;
  var rscriptType = /^$|\/(?:java|ecma)script/i;
  var wrapMap = {
    option: [1, "<select multiple='multiple'>", "</select>"],
    thead: [1, "<table>", "</table>"],
    col: [2, "<table><colgroup>", "</colgroup></table>"],
    tr: [2, "<table><tbody>", "</tbody></table>"],
    td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
    _default: [0, "", ""],
  };
  (wrapMap.optgroup = wrapMap.option),
    (wrapMap.tbody =
      wrapMap.tfoot =
      wrapMap.colgroup =
      wrapMap.caption =
        wrapMap.thead),
    (wrapMap.th = wrapMap.td);
  var rhtml = /<|&#?\w+;/;
  (function (fragment, div, input) {
    (fragment = document.createDocumentFragment()),
      (div = fragment.appendChild(document.createElement("div"))),
      (input = document.createElement("input")),
      input.setAttribute("type", "radio"),
      input.setAttribute("checked", "checked"),
      input.setAttribute("name", "t"),
      div.appendChild(input),
      (support.checkClone = div.cloneNode(!0).cloneNode(!0).lastChild.checked),
      (div.innerHTML = "<textarea>x</textarea>"),
      (support.noCloneChecked = !!div.cloneNode(!0).lastChild.defaultValue);
  })();
  var rkeyEvent = /^key/,
    rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
    rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
  (Flits.event = {
    global: {},
    add: function (elem, types, handler, data, selector) {
      var handleObjIn,
        eventHandle,
        tmp,
        events,
        t,
        handleObj,
        special,
        handlers,
        type,
        namespaces,
        origType,
        elemData = dataPriv.get(elem);
      if (!elemData) return;
      handler.handler &&
        ((handleObjIn = handler),
        (handler = handleObjIn.handler),
        (selector = handleObjIn.selector)),
        handler.guid || (handler.guid = Flits.guid++),
        (events = elemData.events) || (events = elemData.events = {}),
        (eventHandle = elemData.handle) ||
          (eventHandle = elemData.handle =
            function (e) {
              return Flits !== void 0 && Flits.event.triggered !== e.type
                ? Flits.event.dispatch.apply(elem, arguments)
                : undefined;
            }),
        (types = (types || "").match(rnotwhite) || [""]),
        (t = types.length);
      while (t--) {
        if (
          ((tmp = rtypenamespace.exec(types[t]) || []),
          (type = origType = tmp[1]),
          (namespaces = (tmp[2] || "").split(".").sort()),
          !type)
        )
          continue;
        (special = Flits.event.special[type] || {}),
          (type = (selector ? special.delegateType : special.bindType) || type),
          (special = Flits.event.special[type] || {}),
          (handleObj = Flits.extend(
            {
              type: type,
              origType: origType,
              data: data,
              handler: handler,
              guid: handler.guid,
              selector: selector,
              needsContext:
                selector && Flits.expr.match.needsContext.test(selector),
              namespace: namespaces.join("."),
            },
            handleObjIn
          )),
          (handlers = events[type]) ||
            ((handlers = events[type] = []),
            (handlers.delegateCount = 0),
            (!special.setup ||
              special.setup.call(elem, data, namespaces, eventHandle) === !1) &&
              elem.addEventListener &&
              elem.addEventListener(type, eventHandle)),
          special.add &&
            (special.add.call(elem, handleObj),
            handleObj.handler.guid || (handleObj.handler.guid = handler.guid)),
          selector
            ? handlers.splice(handlers.delegateCount++, 0, handleObj)
            : handlers.push(handleObj),
          (Flits.event.global[type] = !0);
      }
    },
    remove: function (elem, types, handler, selector, mappedTypes) {
      var j,
        origCount,
        tmp,
        events,
        t,
        handleObj,
        special,
        handlers,
        type,
        namespaces,
        origType,
        elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
      if (!(elemData && (events = elemData.events))) return;
      (types = (types || "").match(rnotwhite) || [""]), (t = types.length);
      while (t--) {
        if (
          ((tmp = rtypenamespace.exec(types[t]) || []),
          (type = origType = tmp[1]),
          (namespaces = (tmp[2] || "").split(".").sort()),
          !type)
        ) {
          for (type in events)
            Flits.event.remove(elem, type + types[t], handler, selector, !0);
          continue;
        }
        (special = Flits.event.special[type] || {}),
          (type = (selector ? special.delegateType : special.bindType) || type),
          (handlers = events[type] || []),
          (tmp =
            tmp[2] &&
            new RegExp(
              "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)"
            )),
          (origCount = j = handlers.length);
        while (j--)
          (handleObj = handlers[j]),
            (mappedTypes || origType === handleObj.origType) &&
              (!handler || handler.guid === handleObj.guid) &&
              (!tmp || tmp.test(handleObj.namespace)) &&
              (!selector ||
                selector === handleObj.selector ||
                (selector === "**" && handleObj.selector)) &&
              (handlers.splice(j, 1),
              handleObj.selector && handlers.delegateCount--,
              special.remove && special.remove.call(elem, handleObj));
        origCount &&
          !handlers.length &&
          ((!special.teardown ||
            special.teardown.call(elem, namespaces, elemData.handle) === !1) &&
            Flits.removeEvent(elem, type, elemData.handle),
          delete events[type]);
      }
      Flits.isEmptyObject(events) && dataPriv.remove(elem, "handle events");
    },
    dispatch: function (event) {
      event = Flits.event.fix(event);
      var i,
        j,
        ret,
        matched,
        handleObj,
        handlerQueue = [],
        args = slice.call(arguments),
        handlers = (dataPriv.get(this, "events") || {})[event.type] || [],
        special = Flits.event.special[event.type] || {};
      if (
        ((args[0] = event),
        (event.delegateTarget = this),
        special.preDispatch && special.preDispatch.call(this, event) === !1)
      )
        return;
      (handlerQueue = Flits.event.handlers.call(this, event, handlers)),
        (i = 0);
      while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
        (event.currentTarget = matched.elem), (j = 0);
        while (
          (handleObj = matched.handlers[j++]) &&
          !event.isImmediatePropagationStopped()
        )
          (!event.rnamespace || event.rnamespace.test(handleObj.namespace)) &&
            ((event.handleObj = handleObj),
            (event.data = handleObj.data),
            (ret = (
              (Flits.event.special[handleObj.origType] || {}).handle ||
              handleObj.handler
            ).apply(matched.elem, args)),
            ret !== undefined &&
              (event.result = ret) === !1 &&
              (event.preventDefault(), event.stopPropagation()));
      }
      return (
        special.postDispatch && special.postDispatch.call(this, event),
        event.result
      );
    },
    handlers: function (event, handlers) {
      var i,
        matches,
        sel,
        handleObj,
        handlerQueue = [],
        delegateCount = handlers.delegateCount,
        cur = event.target;
      if (
        delegateCount &&
        cur.nodeType &&
        (event.type !== "click" || isNaN(event.button) || event.button < 1)
      )
        for (; cur !== this; cur = cur.parentNode || this)
          if (
            cur.nodeType === 1 &&
            (cur.disabled !== !0 || event.type !== "click")
          ) {
            for (matches = [], i = 0; i < delegateCount; i++)
              (handleObj = handlers[i]),
                (sel = handleObj.selector + " "),
                matches[sel] === undefined &&
                  (matches[sel] = handleObj.needsContext
                    ? Flits(sel, this).index(cur) > -1
                    : Flits.find(sel, this, null, [cur]).length),
                matches[sel] && matches.push(handleObj);
            matches.length &&
              handlerQueue.push({ elem: cur, handlers: matches });
          }
      return (
        delegateCount < handlers.length &&
          handlerQueue.push({
            elem: this,
            handlers: handlers.slice(delegateCount),
          }),
        handlerQueue
      );
    },
    props: (
      "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
      "metaKey relatedTarget shiftKey target timeStamp view which"
    ).split(" "),
    fixHooks: {},
    keyHooks: {
      props: "char charCode key keyCode".split(" "),
      filter: function (event, original) {
        return (
          event.which == null &&
            (event.which =
              original.charCode != null ? original.charCode : original.keyCode),
          event
        );
      },
    },
    mouseHooks: {
      props: (
        "button buttons clientX clientY offsetX offsetY pageX pageY " +
        "screenX screenY toElement"
      ).split(" "),
      filter: function (event, original) {
        var eventDoc,
          doc,
          body,
          button = original.button;
        return (
          event.pageX == null &&
            original.clientX != null &&
            ((eventDoc = event.target.ownerDocument || document),
            (doc = eventDoc.documentElement),
            (body = eventDoc.body),
            (event.pageX =
              original.clientX +
              ((doc && doc.scrollLeft) || (body && body.scrollLeft) || 0) -
              ((doc && doc.clientLeft) || (body && body.clientLeft) || 0)),
            (event.pageY =
              original.clientY +
              ((doc && doc.scrollTop) || (body && body.scrollTop) || 0) -
              ((doc && doc.clientTop) || (body && body.clientTop) || 0))),
          !event.which &&
            button !== undefined &&
            (event.which =
              button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0),
          event
        );
      },
    },
    fix: function (event) {
      if (event[Flits.expando]) return event;
      var i,
        prop,
        copy,
        type = event.type,
        originalEvent = event,
        fixHook = this.fixHooks[type];
      fixHook ||
        (this.fixHooks[type] = fixHook =
          rmouseEvent.test(type)
            ? this.mouseHooks
            : rkeyEvent.test(type)
            ? this.keyHooks
            : {}),
        (copy = fixHook.props ? this.props.concat(fixHook.props) : this.props),
        (event = new Flits.Event(originalEvent)),
        (i = copy.length);
      while (i--) (prop = copy[i]), (event[prop] = originalEvent[prop]);
      return (
        event.target || (event.target = document),
        event.target.nodeType === 3 && (event.target = event.target.parentNode),
        fixHook.filter ? fixHook.filter(event, originalEvent) : event
      );
    },
    special: {
      load: { noBubble: !0 },
      focus: {
        trigger: function () {
          return this !== safeActiveElement() && this.focus
            ? (this.focus(), !1)
            : void 0;
        },
        delegateType: "focusin",
      },
      blur: {
        trigger: function () {
          return this === safeActiveElement() && this.blur
            ? (this.blur(), !1)
            : void 0;
        },
        delegateType: "focusout",
      },
      click: {
        trigger: function () {
          return this.type === "checkbox" &&
            this.click &&
            Flits.nodeName(this, "input")
            ? (this.click(), !1)
            : void 0;
        },
        _default: function (event) {
          return Flits.nodeName(event.target, "a");
        },
      },
      beforeunload: {
        postDispatch: function (event) {
          event.result !== undefined &&
            event.originalEvent &&
            (event.originalEvent.returnValue = event.result);
        },
      },
    },
  }),
    (Flits.removeEvent = function (elem, type, handle) {
      elem.removeEventListener && elem.removeEventListener(type, handle);
    }),
    (Flits.Event = function (src, props) {
      if (!(this instanceof Flits.Event)) return new Flits.Event(src, props);
      src && src.type
        ? ((this.originalEvent = src),
          (this.type = src.type),
          (this.isDefaultPrevented =
            src.defaultPrevented ||
            (src.defaultPrevented === undefined && src.returnValue === !1)
              ? returnTrue
              : returnFalse))
        : (this.type = src),
        props && Flits.extend(this, props),
        (this.timeStamp = (src && src.timeStamp) || Flits.now()),
        (this[Flits.expando] = !0);
    }),
    (Flits.Event.prototype = {
      constructor: Flits.Event,
      isDefaultPrevented: returnFalse,
      isPropagationStopped: returnFalse,
      isImmediatePropagationStopped: returnFalse,
      isSimulated: !1,
      preventDefault: function () {
        var e = this.originalEvent;
        (this.isDefaultPrevented = returnTrue),
          e && !this.isSimulated && e.preventDefault();
      },
      stopPropagation: function () {
        var e = this.originalEvent;
        (this.isPropagationStopped = returnTrue),
          e && !this.isSimulated && e.stopPropagation();
      },
      stopImmediatePropagation: function () {
        var e = this.originalEvent;
        (this.isImmediatePropagationStopped = returnTrue),
          e && !this.isSimulated && e.stopImmediatePropagation(),
          this.stopPropagation();
      },
    }),
    Flits.each(
      {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout",
      },
      function (orig, fix) {
        Flits.event.special[orig] = {
          delegateType: fix,
          bindType: fix,
          handle: function (event) {
            var ret,
              target = this,
              related = event.relatedTarget,
              handleObj = event.handleObj;
            return (
              (!related ||
                (related !== target && !Flits.contains(target, related))) &&
                ((event.type = handleObj.origType),
                (ret = handleObj.handler.apply(this, arguments)),
                (event.type = fix)),
              ret
            );
          },
        };
      }
    ),
    Flits.fn.extend({
      on: function (types, selector, data, fn) {
        return on(this, types, selector, data, fn);
      },
      one: function (types, selector, data, fn) {
        return on(this, types, selector, data, fn, 1);
      },
      off: function (types, selector, fn) {
        var handleObj, type;
        if (types && types.preventDefault && types.handleObj)
          return (
            (handleObj = types.handleObj),
            Flits(types.delegateTarget).off(
              handleObj.namespace
                ? handleObj.origType + "." + handleObj.namespace
                : handleObj.origType,
              handleObj.selector,
              handleObj.handler
            ),
            this
          );
        if (typeof types === "object") {
          for (type in types) this.off(type, selector, types[type]);
          return this;
        }
        return (
          (selector === !1 || typeof selector === "function") &&
            ((fn = selector), (selector = undefined)),
          fn === !1 && (fn = returnFalse),
          this.each(function () {
            Flits.event.remove(this, types, fn, selector);
          })
        );
      },
    });
  var rxhtmlTag =
      /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
    rnoInnerhtml = /<script|<style|<link/i,
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
    rscriptTypeMasked = /^true\/(.*)/,
    rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
  Flits.extend({
    htmlPrefilter: function (html) {
      return html.replace(rxhtmlTag, "<$1></$2>");
    },
    clone: function (elem, dataAndEvents, deepDataAndEvents) {
      var i,
        l,
        srcElements,
        destElements,
        clone = elem.cloneNode(!0),
        inPage = Flits.contains(elem.ownerDocument, elem);
      if (
        !support.noCloneChecked &&
        (elem.nodeType === 1 || elem.nodeType === 11) &&
        !Flits.isXMLDoc(elem)
      )
        for (
          destElements = getAll(clone),
            srcElements = getAll(elem),
            i = 0,
            l = srcElements.length;
          i < l;
          i++
        )
          fixInput(srcElements[i], destElements[i]);
      if (dataAndEvents)
        if (deepDataAndEvents)
          for (
            srcElements = srcElements || getAll(elem),
              destElements = destElements || getAll(clone),
              i = 0,
              l = srcElements.length;
            i < l;
            i++
          )
            cloneCopyEvent(srcElements[i], destElements[i]);
        else cloneCopyEvent(elem, clone);
      return (
        (destElements = getAll(clone, "script")),
        destElements.length > 0 &&
          setGlobalEval(destElements, !inPage && getAll(elem, "script")),
        clone
      );
    },
    cleanData: function (elems) {
      var data,
        elem,
        type,
        special = Flits.event.special,
        i = 0;
      for (; (elem = elems[i]) !== undefined; i++)
        if (acceptData(elem)) {
          if ((data = elem[dataPriv.expando])) {
            if (data.events)
              for (type in data.events)
                special[type]
                  ? Flits.event.remove(elem, type)
                  : Flits.removeEvent(elem, type, data.handle);
            elem[dataPriv.expando] = undefined;
          }
          elem[dataUser.expando] && (elem[dataUser.expando] = undefined);
        }
    },
  }),
    Flits.fn.extend({
      domManip: domManip,
      detach: function (selector) {
        return remove(this, selector, !0);
      },
      remove: function (selector) {
        return remove(this, selector);
      },
      text: function (value) {
        return access(
          this,
          function (value) {
            return value === undefined
              ? Flits.text(this)
              : this.empty().each(function () {
                  (this.nodeType === 1 ||
                    this.nodeType === 11 ||
                    this.nodeType === 9) &&
                    (this.textContent = value);
                });
          },
          null,
          value,
          arguments.length
        );
      },
      append: function () {
        return domManip(this, arguments, function (elem) {
          if (
            this.nodeType === 1 ||
            this.nodeType === 11 ||
            this.nodeType === 9
          ) {
            var target = manipulationTarget(this, elem);
            target.appendChild(elem);
          }
        });
      },
      prepend: function () {
        return domManip(this, arguments, function (elem) {
          if (
            this.nodeType === 1 ||
            this.nodeType === 11 ||
            this.nodeType === 9
          ) {
            var target = manipulationTarget(this, elem);
            target.insertBefore(elem, target.firstChild);
          }
        });
      },
      before: function () {
        return domManip(this, arguments, function (elem) {
          this.parentNode && this.parentNode.insertBefore(elem, this);
        });
      },
      after: function () {
        return domManip(this, arguments, function (elem) {
          this.parentNode &&
            this.parentNode.insertBefore(elem, this.nextSibling);
        });
      },
      empty: function () {
        var elem,
          i = 0;
        for (; (elem = this[i]) != null; i++)
          elem.nodeType === 1 &&
            (Flits.cleanData(getAll(elem, !1)), (elem.textContent = ""));
        return this;
      },
      clone: function (dataAndEvents, deepDataAndEvents) {
        return (
          (dataAndEvents = dataAndEvents == null ? !1 : dataAndEvents),
          (deepDataAndEvents =
            deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents),
          this.map(function () {
            return Flits.clone(this, dataAndEvents, deepDataAndEvents);
          })
        );
      },
      html: function (value) {
        return access(
          this,
          function (value) {
            var elem = this[0] || {},
              i = 0,
              l = this.length;
            if (value === undefined && elem.nodeType === 1)
              return elem.innerHTML;
            if (
              typeof value === "string" &&
              !rnoInnerhtml.test(value) &&
              !wrapMap[(rtagName.exec(value) || ["", ""])[1].toLowerCase()]
            ) {
              value = Flits.htmlPrefilter(value);
              try {
                for (; i < l; i++)
                  (elem = this[i] || {}),
                    elem.nodeType === 1 &&
                      (Flits.cleanData(getAll(elem, !1)),
                      (elem.innerHTML = value));
                elem = 0;
              } catch (e) {}
            }
            elem && this.empty().append(value);
          },
          null,
          value,
          arguments.length
        );
      },
      replaceWith: function () {
        var ignored = [];
        return domManip(
          this,
          arguments,
          function (elem) {
            var parent = this.parentNode;
            Flits.inArray(this, ignored) < 0 &&
              (Flits.cleanData(getAll(this)),
              parent && parent.replaceChild(elem, this));
          },
          ignored
        );
      },
    }),
    Flits.each(
      {
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith",
      },
      function (name, original) {
        Flits.fn[name] = function (selector) {
          var elems,
            ret = [],
            insert = Flits(selector),
            last = insert.length - 1,
            i = 0;
          for (; i <= last; i++)
            (elems = i === last ? this : this.clone(!0)),
              Flits(insert[i])[original](elems),
              push.apply(ret, elems.get());
          return this.pushStack(ret);
        };
      }
    );
  var iframe,
    elemdisplay = { HTML: "block", BODY: "block" };
  var rmargin = /^margin/;
  var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
  var getStyles = function (elem) {
    var view = elem.ownerDocument.defaultView;
    return (
      (view && view.opener) || (view = window), view.getComputedStyle(elem)
    );
  };
  var swap = function (elem, options, callback, args) {
    var ret,
      name,
      old = {};
    for (name in options)
      (old[name] = elem.style[name]), (elem.style[name] = options[name]);
    ret = callback.apply(elem, args || []);
    for (name in options) elem.style[name] = old[name];
    return ret;
  };
  var documentElement = document.documentElement;
  (function (
    pixelPositionVal,
    boxSizingReliableVal,
    pixelMarginRightVal,
    reliableMarginLeftVal,
    container,
    div
  ) {
    function computeStyleTests() {
      (div.style.cssText =
        "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;" +
        "position:relative;display:block;" +
        "margin:auto;border:1px;padding:1px;" +
        "top:1%;width:50%"),
        (div.innerHTML = ""),
        documentElement.appendChild(container);
      var divStyle = window.getComputedStyle(div);
      (pixelPositionVal = divStyle.top !== "1%"),
        (reliableMarginLeftVal = divStyle.marginLeft === "2px"),
        (boxSizingReliableVal = divStyle.width === "4px"),
        (div.style.marginRight = "50%"),
        (pixelMarginRightVal = divStyle.marginRight === "4px"),
        documentElement.removeChild(container);
    }
    if (
      ((container = document.createElement("div")),
      (div = document.createElement("div")),
      !div.style)
    )
      return;
    (div.style.backgroundClip = "content-box"),
      (div.cloneNode(!0).style.backgroundClip = ""),
      (support.clearCloneStyle = div.style.backgroundClip === "content-box"),
      (container.style.cssText =
        "border:0;width:8px;height:0;top:0;left:-9999px;" +
        "padding:0;margin-top:1px;position:absolute"),
      container.appendChild(div),
      Flits.extend(support, {
        pixelPosition: function () {
          return computeStyleTests(), pixelPositionVal;
        },
        boxSizingReliable: function () {
          return (
            boxSizingReliableVal == null && computeStyleTests(),
            boxSizingReliableVal
          );
        },
        pixelMarginRight: function () {
          return (
            boxSizingReliableVal == null && computeStyleTests(),
            pixelMarginRightVal
          );
        },
        reliableMarginLeft: function () {
          return (
            boxSizingReliableVal == null && computeStyleTests(),
            reliableMarginLeftVal
          );
        },
        reliableMarginRight: function () {
          var ret,
            marginDiv = div.appendChild(document.createElement("div"));
          return (
            (marginDiv.style.cssText = div.style.cssText =
              "-webkit-box-sizing:content-box;box-sizing:content-box;" +
              "display:block;margin:0;border:0;padding:0"),
            (marginDiv.style.marginRight = marginDiv.style.width = "0"),
            (div.style.width = "1px"),
            documentElement.appendChild(container),
            (ret = !parseFloat(window.getComputedStyle(marginDiv).marginRight)),
            documentElement.removeChild(container),
            div.removeChild(marginDiv),
            ret
          );
        },
      });
  })();
  var rdisplayswap = /^(none|table(?!-c[ea]).+)/,
    cssShow = { position: "absolute", visibility: "hidden", display: "block" },
    cssNormalTransform = { letterSpacing: "0", fontWeight: "400" },
    cssPrefixes = ["Webkit", "O", "Moz", "ms"],
    emptyStyle = document.createElement("div").style;
  Flits.extend({
    cssHooks: {
      opacity: {
        get: function (elem, computed) {
          if (computed) {
            var ret = curCSS(elem, "opacity");
            return ret === "" ? "1" : ret;
          }
        },
      },
    },
    cssNumber: {
      animationIterationCount: !0,
      columnCount: !0,
      fillOpacity: !0,
      flexGrow: !0,
      flexShrink: !0,
      fontWeight: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
    },
    cssProps: { float: "cssFloat" },
    style: function (elem, name, value, extra) {
      if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style)
        return;
      var ret,
        type,
        hooks,
        origName = Flits.camelCase(name),
        style = elem.style;
      if (
        ((name =
          Flits.cssProps[origName] ||
          (Flits.cssProps[origName] = vendorPropName(origName) || origName)),
        (hooks = Flits.cssHooks[name] || Flits.cssHooks[origName]),
        value !== undefined)
      ) {
        if (
          ((type = typeof value),
          type === "string" &&
            (ret = rcssNum.exec(value)) &&
            ret[1] &&
            ((value = adjustCSS(elem, name, ret)), (type = "number")),
          value == null || value !== value)
        )
          return;
        type === "number" &&
          (value += (ret && ret[3]) || (Flits.cssNumber[origName] ? "" : "px")),
          !support.clearCloneStyle &&
            value === "" &&
            name.indexOf("background") === 0 &&
            (style[name] = "inherit"),
          (!(hooks && "set" in hooks) ||
            (value = hooks.set(elem, value, extra)) !== undefined) &&
            (style[name] = value);
      } else
        return hooks &&
          "get" in hooks &&
          (ret = hooks.get(elem, !1, extra)) !== undefined
          ? ret
          : style[name];
    },
    css: function (elem, name, extra, styles) {
      var val,
        num,
        hooks,
        origName = Flits.camelCase(name);
      return (
        (name =
          Flits.cssProps[origName] ||
          (Flits.cssProps[origName] = vendorPropName(origName) || origName)),
        (hooks = Flits.cssHooks[name] || Flits.cssHooks[origName]),
        hooks && "get" in hooks && (val = hooks.get(elem, !0, extra)),
        val === undefined && (val = curCSS(elem, name, styles)),
        val === "normal" &&
          name in cssNormalTransform &&
          (val = cssNormalTransform[name]),
        extra === "" || extra
          ? ((num = parseFloat(val)),
            extra === !0 || isFinite(num) ? num || 0 : val)
          : val
      );
    },
  }),
    Flits.each(["height", "width"], function (i, name) {
      Flits.cssHooks[name] = {
        get: function (elem, computed, extra) {
          return computed
            ? rdisplayswap.test(Flits.css(elem, "display")) &&
              elem.offsetWidth === 0
              ? swap(elem, cssShow, function () {
                  return getWidthOrHeight(elem, name, extra);
                })
              : getWidthOrHeight(elem, name, extra)
            : void 0;
        },
        set: function (elem, value, extra) {
          var matches,
            styles = extra && getStyles(elem),
            subtract =
              extra &&
              augmentWidthOrHeight(
                elem,
                name,
                extra,
                Flits.css(elem, "boxSizing", !1, styles) === "border-box",
                styles
              );
          return (
            subtract &&
              (matches = rcssNum.exec(value)) &&
              (matches[3] || "px") !== "px" &&
              ((elem.style[name] = value), (value = Flits.css(elem, name))),
            setPositiveNumber(elem, value, subtract)
          );
        },
      };
    }),
    (Flits.cssHooks.marginLeft = addGetHookIf(
      support.reliableMarginLeft,
      function (elem, computed) {
        return computed
          ? (parseFloat(curCSS(elem, "marginLeft")) ||
              elem.getBoundingClientRect().left -
                swap(elem, { marginLeft: 0 }, function () {
                  return elem.getBoundingClientRect().left;
                })) + "px"
          : void 0;
      }
    )),
    (Flits.cssHooks.marginRight = addGetHookIf(
      support.reliableMarginRight,
      function (elem, computed) {
        return computed
          ? swap(elem, { display: "inline-block" }, curCSS, [
              elem,
              "marginRight",
            ])
          : void 0;
      }
    )),
    Flits.each(
      { margin: "", padding: "", border: "Width" },
      function (prefix, suffix) {
        (Flits.cssHooks[prefix + suffix] = {
          expand: function (value) {
            var i = 0,
              expanded = {},
              parts = typeof value === "string" ? value.split(" ") : [value];
            for (; i < 4; i++)
              expanded[prefix + cssExpand[i] + suffix] =
                parts[i] || parts[i - 2] || parts[0];
            return expanded;
          },
        }),
          rmargin.test(prefix) ||
            (Flits.cssHooks[prefix + suffix].set = setPositiveNumber);
      }
    ),
    Flits.fn.extend({
      css: function (name, value) {
        return access(
          this,
          function (elem, name, value) {
            var styles,
              len,
              map = {},
              i = 0;
            if (Flits.isArray(name)) {
              for (styles = getStyles(elem), len = name.length; i < len; i++)
                map[name[i]] = Flits.css(elem, name[i], !1, styles);
              return map;
            }
            return value !== undefined
              ? Flits.style(elem, name, value)
              : Flits.css(elem, name);
          },
          name,
          value,
          arguments.length > 1
        );
      },
      show: function () {
        return showHide(this, !0);
      },
      hide: function () {
        return showHide(this);
      },
      toggle: function (state) {
        return typeof state === "boolean"
          ? state
            ? this.show()
            : this.hide()
          : this.each(function () {
              isHidden(this) ? Flits(this).show() : Flits(this).hide();
            });
      },
    }),
    (Flits.Tween = Tween),
    (Tween.prototype = {
      constructor: Tween,
      init: function (elem, options, prop, end, easing, unit) {
        (this.elem = elem),
          (this.prop = prop),
          (this.easing = easing || Flits.easing._default),
          (this.options = options),
          (this.start = this.now = this.cur()),
          (this.end = end),
          (this.unit = unit || (Flits.cssNumber[prop] ? "" : "px"));
      },
      cur: function () {
        var hooks = Tween.propHooks[this.prop];
        return hooks && hooks.get
          ? hooks.get(this)
          : Tween.propHooks._default.get(this);
      },
      run: function (percent) {
        var eased,
          hooks = Tween.propHooks[this.prop];
        return (
          this.options.duration
            ? (this.pos = eased =
                Flits.easing[this.easing](
                  percent,
                  this.options.duration * percent,
                  0,
                  1,
                  this.options.duration
                ))
            : (this.pos = eased = percent),
          (this.now = (this.end - this.start) * eased + this.start),
          this.options.step &&
            this.options.step.call(this.elem, this.now, this),
          hooks && hooks.set
            ? hooks.set(this)
            : Tween.propHooks._default.set(this),
          this
        );
      },
    }),
    (Tween.prototype.init.prototype = Tween.prototype),
    (Tween.propHooks = {
      _default: {
        get: function (tween) {
          var result;
          return tween.elem.nodeType !== 1 ||
            (tween.elem[tween.prop] != null &&
              tween.elem.style[tween.prop] == null)
            ? tween.elem[tween.prop]
            : ((result = Flits.css(tween.elem, tween.prop, "")),
              !result || result === "auto" ? 0 : result);
        },
        set: function (tween) {
          Flits.fx.step[tween.prop]
            ? Flits.fx.step[tween.prop](tween)
            : tween.elem.nodeType === 1 &&
              (tween.elem.style[Flits.cssProps[tween.prop]] != null ||
                Flits.cssHooks[tween.prop])
            ? Flits.style(tween.elem, tween.prop, tween.now + tween.unit)
            : (tween.elem[tween.prop] = tween.now);
        },
      },
    }),
    (Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft =
      {
        set: function (tween) {
          tween.elem.nodeType &&
            tween.elem.parentNode &&
            (tween.elem[tween.prop] = tween.now);
        },
      }),
    (Flits.easing = {
      linear: function (p) {
        return p;
      },
      swing: function (p) {
        return 0.5 - Math.cos(p * Math.PI) / 2;
      },
      _default: "swing",
    }),
    (Flits.fx = Tween.prototype.init),
    (Flits.fx.step = {});
  var fxNow,
    timerId,
    rfxtypes = /^(?:toggle|show|hide)$/,
    rrun = /queueHooks$/;
  (Flits.Animation = Flits.extend(Animation, {
    tweeners: {
      "*": [
        function (prop, value) {
          var tween = this.createTween(prop, value);
          return adjustCSS(tween.elem, prop, rcssNum.exec(value), tween), tween;
        },
      ],
    },
    tweener: function (props, callback) {
      Flits.isFunction(props)
        ? ((callback = props), (props = ["*"]))
        : (props = props.match(rnotwhite));
      var prop,
        index = 0,
        length = props.length;
      for (; index < length; index++)
        (prop = props[index]),
          (Animation.tweeners[prop] = Animation.tweeners[prop] || []),
          Animation.tweeners[prop].unshift(callback);
    },
    prefilters: [defaultPrefilter],
    prefilter: function (callback, prepend) {
      prepend
        ? Animation.prefilters.unshift(callback)
        : Animation.prefilters.push(callback);
    },
  })),
    (Flits.speed = function (speed, easing, fn) {
      var opt =
        speed && typeof speed === "object"
          ? Flits.extend({}, speed)
          : {
              complete:
                fn || (!fn && easing) || (Flits.isFunction(speed) && speed),
              duration: speed,
              easing:
                (fn && easing) ||
                (easing && !Flits.isFunction(easing) && easing),
            };
      return (
        (opt.duration = Flits.fx.off
          ? 0
          : typeof opt.duration === "number"
          ? opt.duration
          : opt.duration in Flits.fx.speeds
          ? Flits.fx.speeds[opt.duration]
          : Flits.fx.speeds._default),
        (opt.queue == null || opt.queue === !0) && (opt.queue = "fx"),
        (opt.old = opt.complete),
        (opt.complete = function () {
          Flits.isFunction(opt.old) && opt.old.call(this),
            opt.queue && Flits.dequeue(this, opt.queue);
        }),
        opt
      );
    }),
    Flits.fn.extend({
      fadeTo: function (speed, to, easing, callback) {
        return this.filter(isHidden)
          .css("opacity", 0)
          .show()
          .end()
          .animate({ opacity: to }, speed, easing, callback);
      },
      animate: function (prop, speed, easing, callback) {
        var empty = Flits.isEmptyObject(prop),
          optall = Flits.speed(speed, easing, callback),
          doAnimation = function () {
            var anim = Animation(this, Flits.extend({}, prop), optall);
            (empty || dataPriv.get(this, "finish")) && anim.stop(!0);
          };
        return (
          (doAnimation.finish = doAnimation),
          empty || optall.queue === !1
            ? this.each(doAnimation)
            : this.queue(optall.queue, doAnimation)
        );
      },
      stop: function (type, clearQueue, gotoEnd) {
        var stopQueue = function (hooks) {
          var stop = hooks.stop;
          delete hooks.stop, stop(gotoEnd);
        };
        return (
          typeof type !== "string" &&
            ((gotoEnd = clearQueue), (clearQueue = type), (type = undefined)),
          clearQueue && type !== !1 && this.queue(type || "fx", []),
          this.each(function () {
            var dequeue = !0,
              index = type != null && type + "queueHooks",
              timers = Flits.timers,
              data = dataPriv.get(this);
            if (index)
              data[index] && data[index].stop && stopQueue(data[index]);
            else
              for (index in data)
                data[index] &&
                  data[index].stop &&
                  rrun.test(index) &&
                  stopQueue(data[index]);
            for (index = timers.length; index--; )
              timers[index].elem === this &&
                (type == null || timers[index].queue === type) &&
                (timers[index].anim.stop(gotoEnd),
                (dequeue = !1),
                timers.splice(index, 1));
            (dequeue || !gotoEnd) && Flits.dequeue(this, type);
          })
        );
      },
      finish: function (type) {
        return (
          type !== !1 && (type = type || "fx"),
          this.each(function () {
            var index,
              data = dataPriv.get(this),
              queue = data[type + "queue"],
              hooks = data[type + "queueHooks"],
              timers = Flits.timers,
              length = queue ? queue.length : 0;
            for (
              data.finish = !0,
                Flits.queue(this, type, []),
                hooks && hooks.stop && hooks.stop.call(this, !0),
                index = timers.length;
              index--;

            )
              timers[index].elem === this &&
                timers[index].queue === type &&
                (timers[index].anim.stop(!0), timers.splice(index, 1));
            for (index = 0; index < length; index++)
              queue[index] &&
                queue[index].finish &&
                queue[index].finish.call(this);
            delete data.finish;
          })
        );
      },
    }),
    Flits.each(["toggle", "show", "hide"], function (i, name) {
      var cssFn = Flits.fn[name];
      Flits.fn[name] = function (speed, easing, callback) {
        return speed == null || typeof speed === "boolean"
          ? cssFn.apply(this, arguments)
          : this.animate(genFx(name, !0), speed, easing, callback);
      };
    }),
    Flits.each(
      {
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: { opacity: "show" },
        fadeOut: { opacity: "hide" },
        fadeToggle: { opacity: "toggle" },
      },
      function (name, props) {
        Flits.fn[name] = function (speed, easing, callback) {
          return this.animate(props, speed, easing, callback);
        };
      }
    ),
    (Flits.timers = []),
    (Flits.fx.tick = function () {
      var timer,
        i = 0,
        timers = Flits.timers;
      for (fxNow = Flits.now(); i < timers.length; i++)
        (timer = timers[i]),
          !timer() && timers[i] === timer && timers.splice(i--, 1);
      timers.length || Flits.fx.stop(), (fxNow = undefined);
    }),
    (Flits.fx.timer = function (timer) {
      Flits.timers.push(timer), timer() ? Flits.fx.start() : Flits.timers.pop();
    }),
    (Flits.fx.interval = 13),
    (Flits.fx.start = function () {
      timerId ||
        (timerId = window.setInterval(Flits.fx.tick, Flits.fx.interval));
    }),
    (Flits.fx.stop = function () {
      window.clearInterval(timerId), (timerId = null);
    }),
    (Flits.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
    (Flits.fn.delay = function (time, type) {
      return (
        (time = Flits.fx ? Flits.fx.speeds[time] || time : time),
        (type = type || "fx"),
        this.queue(type, function (next, hooks) {
          var timeout = window.setTimeout(next, time);
          hooks.stop = function () {
            window.clearTimeout(timeout);
          };
        })
      );
    }),
    (function (input, select, opt) {
      (input = document.createElement("input")),
        (select = document.createElement("select")),
        (opt = select.appendChild(document.createElement("option"))),
        (input.type = "checkbox"),
        (support.checkOn = input.value !== ""),
        (support.optSelected = opt.selected),
        (select.disabled = !0),
        (support.optDisabled = !opt.disabled),
        (input = document.createElement("input")),
        (input.value = "t"),
        (input.type = "radio"),
        (support.radioValue = input.value === "t");
    })();
  var boolHook,
    attrHandle = Flits.expr.attrHandle;
  Flits.fn.extend({
    attr: function (name, value) {
      return access(this, Flits.attr, name, value, arguments.length > 1);
    },
    removeAttr: function (name) {
      return this.each(function () {
        Flits.removeAttr(this, name);
      });
    },
  }),
    Flits.extend({
      attr: function (elem, name, value) {
        var ret,
          hooks,
          nType = elem.nodeType;
        if (nType === 3 || nType === 8 || nType === 2) return;
        if (elem.getAttribute === void 0) return Flits.prop(elem, name, value);
        if (
          ((nType !== 1 || !Flits.isXMLDoc(elem)) &&
            ((name = name.toLowerCase()),
            (hooks =
              Flits.attrHooks[name] ||
              (Flits.expr.match.bool.test(name) ? boolHook : undefined))),
          value !== undefined)
        ) {
          if (value === null) {
            Flits.removeAttr(elem, name);
            return;
          }
          return hooks &&
            "set" in hooks &&
            (ret = hooks.set(elem, value, name)) !== undefined
            ? ret
            : (elem.setAttribute(name, value + ""), value);
        }
        return hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null
          ? ret
          : ((ret = Flits.find.attr(elem, name)),
            ret == null ? undefined : ret);
      },
      attrHooks: {
        type: {
          set: function (elem, value) {
            if (
              !support.radioValue &&
              value === "radio" &&
              Flits.nodeName(elem, "input")
            ) {
              var val = elem.value;
              return (
                elem.setAttribute("type", value),
                val && (elem.value = val),
                value
              );
            }
          },
        },
      },
      removeAttr: function (elem, value) {
        var name,
          propName,
          i = 0,
          attrNames = value && value.match(rnotwhite);
        if (attrNames && elem.nodeType === 1)
          while ((name = attrNames[i++]))
            (propName = Flits.propFix[name] || name),
              Flits.expr.match.bool.test(name) && (elem[propName] = !1),
              elem.removeAttribute(name);
      },
    }),
    (boolHook = {
      set: function (elem, value, name) {
        return (
          value === !1
            ? Flits.removeAttr(elem, name)
            : elem.setAttribute(name, name),
          name
        );
      },
    }),
    Flits.each(Flits.expr.match.bool.source.match(/\w+/g), function (i, name) {
      var getter = attrHandle[name] || Flits.find.attr;
      attrHandle[name] = function (elem, name, isXML) {
        var ret, handle;
        return (
          isXML ||
            ((handle = attrHandle[name]),
            (attrHandle[name] = ret),
            (ret =
              getter(elem, name, isXML) != null ? name.toLowerCase() : null),
            (attrHandle[name] = handle)),
          ret
        );
      };
    });
  var rfocusable = /^(?:input|select|textarea|button)$/i,
    rclickable = /^(?:a|area)$/i;
  Flits.fn.extend({
    prop: function (name, value) {
      return access(this, Flits.prop, name, value, arguments.length > 1);
    },
    removeProp: function (name) {
      return this.each(function () {
        delete this[Flits.propFix[name] || name];
      });
    },
  }),
    Flits.extend({
      prop: function (elem, name, value) {
        var ret,
          hooks,
          nType = elem.nodeType;
        return nType === 3 || nType === 8 || nType === 2
          ? void 0
          : ((nType !== 1 || !Flits.isXMLDoc(elem)) &&
              ((name = Flits.propFix[name] || name),
              (hooks = Flits.propHooks[name])),
            value !== undefined
              ? hooks &&
                "set" in hooks &&
                (ret = hooks.set(elem, value, name)) !== undefined
                ? ret
                : (elem[name] = value)
              : hooks &&
                "get" in hooks &&
                (ret = hooks.get(elem, name)) !== null
              ? ret
              : elem[name]);
      },
      propHooks: {
        tabIndex: {
          get: function (elem) {
            var tabindex = Flits.find.attr(elem, "tabindex");
            return tabindex
              ? parseInt(tabindex, 10)
              : rfocusable.test(elem.nodeName) ||
                (rclickable.test(elem.nodeName) && elem.href)
              ? 0
              : -1;
          },
        },
      },
      propFix: { for: "htmlFor", class: "className" },
    }),
    support.optSelected ||
      (Flits.propHooks.selected = {
        get: function (elem) {
          var parent = elem.parentNode;
          return (
            parent && parent.parentNode && parent.parentNode.selectedIndex, null
          );
        },
        set: function (elem) {
          var parent = elem.parentNode;
          parent &&
            (parent.selectedIndex,
            parent.parentNode && parent.parentNode.selectedIndex);
        },
      }),
    Flits.each(
      [
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable",
      ],
      function () {
        Flits.propFix[this.toLowerCase()] = this;
      }
    );
  var rclass = /[\t\r\n\f]/g;
  Flits.fn.extend({
    addClass: function (value) {
      var classes,
        elem,
        cur,
        curValue,
        clazz,
        j,
        finalValue,
        i = 0;
      if (Flits.isFunction(value))
        return this.each(function (j) {
          Flits(this).addClass(value.call(this, j, getClass(this)));
        });
      if (typeof value === "string" && value) {
        classes = value.match(rnotwhite) || [];
        while ((elem = this[i++]))
          if (
            ((curValue = getClass(elem)),
            (cur =
              elem.nodeType === 1 &&
              (" " + curValue + " ").replace(rclass, " ")),
            cur)
          ) {
            j = 0;
            while ((clazz = classes[j++]))
              cur.indexOf(" " + clazz + " ") < 0 && (cur += clazz + " ");
            (finalValue = Flits.trim(cur)),
              curValue !== finalValue && elem.setAttribute("class", finalValue);
          }
      }
      return this;
    },
    removeClass: function (value) {
      var classes,
        elem,
        cur,
        curValue,
        clazz,
        j,
        finalValue,
        i = 0;
      if (Flits.isFunction(value))
        return this.each(function (j) {
          Flits(this).removeClass(value.call(this, j, getClass(this)));
        });
      if (!arguments.length) return this.attr("class", "");
      if (typeof value === "string" && value) {
        classes = value.match(rnotwhite) || [];
        while ((elem = this[i++]))
          if (
            ((curValue = getClass(elem)),
            (cur =
              elem.nodeType === 1 &&
              (" " + curValue + " ").replace(rclass, " ")),
            cur)
          ) {
            j = 0;
            while ((clazz = classes[j++]))
              while (cur.indexOf(" " + clazz + " ") > -1)
                cur = cur.replace(" " + clazz + " ", " ");
            (finalValue = Flits.trim(cur)),
              curValue !== finalValue && elem.setAttribute("class", finalValue);
          }
      }
      return this;
    },
    toggleClass: function (value, stateVal) {
      var type = typeof value;
      return typeof stateVal === "boolean" && type === "string"
        ? stateVal
          ? this.addClass(value)
          : this.removeClass(value)
        : Flits.isFunction(value)
        ? this.each(function (i) {
            Flits(this).toggleClass(
              value.call(this, i, getClass(this), stateVal),
              stateVal
            );
          })
        : this.each(function () {
            var className, i, self, classNames;
            if (type === "string") {
              (i = 0),
                (self = Flits(this)),
                (classNames = value.match(rnotwhite) || []);
              while ((className = classNames[i++]))
                self.hasClass(className)
                  ? self.removeClass(className)
                  : self.addClass(className);
            } else (value === undefined || type === "boolean") && ((className = getClass(this)), className && dataPriv.set(this, "__className__", className), this.setAttribute && this.setAttribute("class", className || value === !1 ? "" : dataPriv.get(this, "__className__") || ""));
          });
    },
    hasClass: function (selector) {
      var className,
        elem,
        i = 0;
      className = " " + selector + " ";
      while ((elem = this[i++]))
        if (
          elem.nodeType === 1 &&
          (" " + getClass(elem) + " ").replace(rclass, " ").indexOf(className) >
            -1
        )
          return !0;
      return !1;
    },
  });
  var rreturn = /\r/g,
    rspaces = /[\x20\t\r\n\f]+/g;
  Flits.fn.extend({
    val: function (value) {
      var hooks,
        ret,
        isFunction,
        elem = this[0];
      return arguments.length
        ? ((isFunction = Flits.isFunction(value)),
          this.each(function (i) {
            var val;
            if (this.nodeType !== 1) return;
            isFunction
              ? (val = value.call(this, i, Flits(this).val()))
              : (val = value),
              val == null
                ? (val = "")
                : typeof val === "number"
                ? (val += "")
                : Flits.isArray(val) &&
                  (val = Flits.map(val, function (value) {
                    return value == null ? "" : value + "";
                  })),
              (hooks =
                Flits.valHooks[this.type] ||
                Flits.valHooks[this.nodeName.toLowerCase()]),
              (!(hooks && "set" in hooks) ||
                hooks.set(this, val, "value") === undefined) &&
                (this.value = val);
          }))
        : elem
        ? ((hooks =
            Flits.valHooks[elem.type] ||
            Flits.valHooks[elem.nodeName.toLowerCase()]),
          hooks &&
          "get" in hooks &&
          (ret = hooks.get(elem, "value")) !== undefined
            ? ret
            : ((ret = elem.value),
              typeof ret === "string"
                ? ret.replace(rreturn, "")
                : ret == null
                ? ""
                : ret))
        : void 0;
    },
  }),
    Flits.extend({
      valHooks: {
        option: {
          get: function (elem) {
            var val = Flits.find.attr(elem, "value");
            return val != null
              ? val
              : Flits.trim(Flits.text(elem)).replace(rspaces, " ");
          },
        },
        select: {
          get: function (elem) {
            var value,
              option,
              options = elem.options,
              index = elem.selectedIndex,
              one = elem.type === "select-one" || index < 0,
              values = one ? null : [],
              max = one ? index + 1 : options.length,
              i = index < 0 ? max : one ? index : 0;
            for (; i < max; i++)
              if (
                ((option = options[i]),
                (option.selected || i === index) &&
                  (support.optDisabled
                    ? !option.disabled
                    : option.getAttribute("disabled") === null) &&
                  !(
                    option.parentNode.disabled &&
                    Flits.nodeName(option.parentNode, "optgroup")
                  ))
              ) {
                if (((value = Flits(option).val()), one)) return value;
                values.push(value);
              }
            return values;
          },
          set: function (elem, value) {
            var optionSet,
              option,
              options = elem.options,
              values = Flits.makeArray(value),
              i = options.length;
            while (i--)
              (option = options[i]),
                (option.selected =
                  Flits.inArray(Flits.valHooks.option.get(option), values) >
                  -1) && (optionSet = !0);
            return optionSet || (elem.selectedIndex = -1), values;
          },
        },
      },
    }),
    Flits.each(["radio", "checkbox"], function () {
      (Flits.valHooks[this] = {
        set: function (elem, value) {
          return Flits.isArray(value)
            ? (elem.checked = Flits.inArray(Flits(elem).val(), value) > -1)
            : void 0;
        },
      }),
        support.checkOn ||
          (Flits.valHooks[this].get = function (elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
          });
    });
  var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
  Flits.extend(Flits.event, {
    trigger: function (event, data, elem, onlyHandlers) {
      var i,
        cur,
        tmp,
        bubbleType,
        ontype,
        handle,
        special,
        eventPath = [elem || document],
        type = hasOwn.call(event, "type") ? event.type : event,
        namespaces = hasOwn.call(event, "namespace")
          ? event.namespace.split(".")
          : [];
      if (
        ((cur = tmp = elem = elem || document),
        elem.nodeType === 3 || elem.nodeType === 8)
      )
        return;
      if (rfocusMorph.test(type + Flits.event.triggered)) return;
      if (
        (type.indexOf(".") > -1 &&
          ((namespaces = type.split(".")),
          (type = namespaces.shift()),
          namespaces.sort()),
        (ontype = type.indexOf(":") < 0 && "on" + type),
        (event = event[Flits.expando]
          ? event
          : new Flits.Event(type, typeof event === "object" && event)),
        (event.isTrigger = onlyHandlers ? 2 : 3),
        (event.namespace = namespaces.join(".")),
        (event.rnamespace = event.namespace
          ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)")
          : null),
        (event.result = undefined),
        event.target || (event.target = elem),
        (data = data == null ? [event] : Flits.makeArray(data, [event])),
        (special = Flits.event.special[type] || {}),
        !onlyHandlers &&
          special.trigger &&
          special.trigger.apply(elem, data) === !1)
      )
        return;
      if (!(onlyHandlers || special.noBubble || Flits.isWindow(elem))) {
        for (
          bubbleType = special.delegateType || type,
            rfocusMorph.test(bubbleType + type) || (cur = cur.parentNode);
          cur;
          cur = cur.parentNode
        )
          eventPath.push(cur), (tmp = cur);
        tmp === (elem.ownerDocument || document) &&
          eventPath.push(tmp.defaultView || tmp.parentWindow || window);
      }
      i = 0;
      while ((cur = eventPath[i++]) && !event.isPropagationStopped())
        (event.type = i > 1 ? bubbleType : special.bindType || type),
          (handle =
            (dataPriv.get(cur, "events") || {})[event.type] &&
            dataPriv.get(cur, "handle")),
          handle && handle.apply(cur, data),
          (handle = ontype && cur[ontype]),
          handle &&
            handle.apply &&
            acceptData(cur) &&
            ((event.result = handle.apply(cur, data)),
            event.result === !1 && event.preventDefault());
      return (
        (event.type = type),
        !(onlyHandlers || event.isDefaultPrevented()) &&
          (!special._default ||
            special._default.apply(eventPath.pop(), data) === !1) &&
          acceptData(elem) &&
          ontype &&
          Flits.isFunction(elem[type]) &&
          !Flits.isWindow(elem) &&
          ((tmp = elem[ontype]),
          tmp && (elem[ontype] = null),
          (Flits.event.triggered = type),
          elem[type](),
          (Flits.event.triggered = undefined),
          tmp && (elem[ontype] = tmp)),
        event.result
      );
    },
    simulate: function (type, elem, event) {
      var e = Flits.extend(new Flits.Event(), event, {
        type: type,
        isSimulated: !0,
      });
      Flits.event.trigger(e, null, elem);
    },
  }),
    Flits.fn.extend({
      trigger: function (type, data) {
        return this.each(function () {
          Flits.event.trigger(type, data, this);
        });
      },
      triggerHandler: function (type, data) {
        var elem = this[0];
        return elem ? Flits.event.trigger(type, data, elem, !0) : void 0;
      },
    }),
    Flits.each(
      (
        "blur focus focusin focusout load resize scroll unload click dblclick " +
        "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
        "change select submit keydown keypress keyup error contextmenu"
      ).split(" "),
      function (i, name) {
        Flits.fn[name] = function (data, fn) {
          return arguments.length > 0
            ? this.on(name, null, data, fn)
            : this.trigger(name);
        };
      }
    ),
    Flits.fn.extend({
      hover: function (fnOver, fnOut) {
        return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
      },
    }),
    (support.focusin = "onfocusin" in window),
    support.focusin ||
      Flits.each({ focus: "focusin", blur: "focusout" }, function (orig, fix) {
        var handler = function (event) {
          Flits.event.simulate(fix, event.target, Flits.event.fix(event));
        };
        Flits.event.special[fix] = {
          setup: function () {
            var doc = this.ownerDocument || this,
              attaches = dataPriv.access(doc, fix);
            attaches || doc.addEventListener(orig, handler, !0),
              dataPriv.access(doc, fix, (attaches || 0) + 1);
          },
          teardown: function () {
            var doc = this.ownerDocument || this,
              attaches = dataPriv.access(doc, fix) - 1;
            attaches
              ? dataPriv.access(doc, fix, attaches)
              : (doc.removeEventListener(orig, handler, !0),
                dataPriv.remove(doc, fix));
          },
        };
      });
  var location = window.location;
  var nonce = Flits.now();
  var rquery = /\?/;
  (Flits.parseJSON = function (data) {
    return JSON.parse(data + "");
  }),
    (Flits.parseXML = function (data) {
      var xml;
      if (!data || typeof data !== "string") return null;
      try {
        xml = new window.DOMParser().parseFromString(data, "text/xml");
      } catch (e) {
        xml = undefined;
      }
      return (
        (!xml || xml.getElementsByTagName("parsererror").length) &&
          Flits.error("Invalid XML: " + data),
        xml
      );
    });
  var rhash = /#.*$/,
    rts = /([?&])_=[^&]*/,
    rheaders = /^(.*?):[ \t]*([^\r\n]*)$/gm,
    rlocalProtocol =
      /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
    rnoContent = /^(?:GET|HEAD)$/,
    rprotocol = /^\/\//,
    prefilters = {},
    transports = {},
    allTypes = "*/".concat("*"),
    originAnchor = document.createElement("a");
  (originAnchor.href = location.href),
    Flits.extend({
      active: 0,
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: location.href,
        type: "GET",
        isLocal: rlocalProtocol.test(location.protocol),
        global: !0,
        processData: !0,
        async: !0,
        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
        accepts: {
          "*": allTypes,
          text: "text/plain",
          html: "text/html",
          xml: "application/xml, text/xml",
          json: "application/json, text/javascript",
        },
        contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
        responseFields: {
          xml: "responseXML",
          text: "responseText",
          json: "responseJSON",
        },
        converters: {
          "* text": String,
          "text html": !0,
          "text json": Flits.parseJSON,
          "text xml": Flits.parseXML,
        },
        flatOptions: { url: !0, context: !0 },
      },
      ajaxSetup: function (target, settings) {
        return settings
          ? ajaxExtend(ajaxExtend(target, Flits.ajaxSettings), settings)
          : ajaxExtend(Flits.ajaxSettings, target);
      },
      ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
      ajaxTransport: addToPrefiltersOrTransports(transports),
      ajax: function (url, options) {
        function done(status, nativeStatusText, responses, headers) {
          var isSuccess,
            success,
            error,
            response,
            modified,
            statusText = nativeStatusText;
          if (state === 2) return;
          (state = 2),
            timeoutTimer && window.clearTimeout(timeoutTimer),
            (transport = undefined),
            (responseHeadersString = headers || ""),
            (flitsXHR.readyState = status > 0 ? 4 : 0),
            (isSuccess = (status >= 200 && status < 300) || status === 304),
            responses &&
              (response = ajaxHandleResponses(s, flitsXHR, responses)),
            (response = ajaxConvert(s, response, flitsXHR, isSuccess)),
            isSuccess
              ? (s.ifModified &&
                  ((modified = flitsXHR.getResponseHeader("Last-Modified")),
                  modified && (Flits.lastModified[cacheURL] = modified),
                  (modified = flitsXHR.getResponseHeader("etag")),
                  modified && (Flits.etag[cacheURL] = modified)),
                status === 204 || s.type === "HEAD"
                  ? (statusText = "nocontent")
                  : status === 304
                  ? (statusText = "notmodified")
                  : ((statusText = response.state),
                    (success = response.data),
                    (error = response.error),
                    (isSuccess = !error)))
              : ((error = statusText),
                (status || !statusText) &&
                  ((statusText = "error"), status < 0 && (status = 0))),
            (flitsXHR.status = status),
            (flitsXHR.statusText = (nativeStatusText || statusText) + ""),
            isSuccess
              ? deferred.resolveWith(callbackContext, [
                  success,
                  statusText,
                  flitsXHR,
                ])
              : deferred.rejectWith(callbackContext, [
                  flitsXHR,
                  statusText,
                  error,
                ]),
            flitsXHR.statusCode(statusCode),
            (statusCode = undefined),
            fireGlobals &&
              globalEventContext.trigger(
                isSuccess ? "ajaxSuccess" : "ajaxError",
                [flitsXHR, s, isSuccess ? success : error]
              ),
            completeDeferred.fireWith(callbackContext, [flitsXHR, statusText]),
            fireGlobals &&
              (globalEventContext.trigger("ajaxComplete", [flitsXHR, s]),
              --Flits.active || Flits.event.trigger("ajaxStop"));
        }
        typeof url === "object" && ((options = url), (url = undefined)),
          (options = options || {});
        var transport,
          cacheURL,
          responseHeadersString,
          responseHeaders,
          timeoutTimer,
          urlAnchor,
          fireGlobals,
          i,
          s = Flits.ajaxSetup({}, options),
          callbackContext = s.context || s,
          globalEventContext =
            s.context && (callbackContext.nodeType || callbackContext.Flits)
              ? Flits(callbackContext)
              : Flits.event,
          deferred = Flits.Deferred(),
          completeDeferred = Flits.Callbacks("once memory"),
          statusCode = s.statusCode || {},
          requestHeaders = {},
          requestHeadersNames = {},
          state = 0,
          strAbort = "canceled",
          flitsXHR = {
            readyState: 0,
            getResponseHeader: function (key) {
              var match;
              if (state === 2) {
                if (!responseHeaders) {
                  responseHeaders = {};
                  while ((match = rheaders.exec(responseHeadersString)))
                    responseHeaders[match[1].toLowerCase()] = match[2];
                }
                match = responseHeaders[key.toLowerCase()];
              }
              return match == null ? null : match;
            },
            getAllResponseHeaders: function () {
              return state === 2 ? responseHeadersString : null;
            },
            setRequestHeader: function (name, value) {
              var lname = name.toLowerCase();
              return (
                state ||
                  ((name = requestHeadersNames[lname] =
                    requestHeadersNames[lname] || name),
                  (requestHeaders[name] = value)),
                this
              );
            },
            overrideMimeType: function (type) {
              return state || (s.mimeType = type), this;
            },
            statusCode: function (map) {
              var code;
              if (map)
                if (state < 2)
                  for (code in map)
                    statusCode[code] = [statusCode[code], map[code]];
                else flitsXHR.always(map[flitsXHR.status]);
              return this;
            },
            abort: function (statusText) {
              var finalText = statusText || strAbort;
              return (
                transport && transport.abort(finalText),
                done(0, finalText),
                this
              );
            },
          };
        if (
          ((deferred.promise(flitsXHR).complete = completeDeferred.add),
          (flitsXHR.success = flitsXHR.done),
          (flitsXHR.error = flitsXHR.fail),
          (s.url = ((url || s.url || location.href) + "")
            .replace(rhash, "")
            .replace(rprotocol, location.protocol + "//")),
          (s.type = options.method || options.type || s.method || s.type),
          (s.dataTypes = Flits.trim(s.dataType || "*")
            .toLowerCase()
            .match(rnotwhite) || [""]),
          s.crossDomain == null)
        ) {
          urlAnchor = document.createElement("a");
          try {
            (urlAnchor.href = s.url),
              (urlAnchor.href = urlAnchor.href),
              (s.crossDomain =
                originAnchor.protocol + "//" + originAnchor.host !==
                urlAnchor.protocol + "//" + urlAnchor.host);
          } catch (e) {
            s.crossDomain = true;
          }
        }
        if (
          (s.data &&
            s.processData &&
            typeof s.data !== "string" &&
            (s.data = Flits.param(s.data, s.traditional)),
          inspectPrefiltersOrTransports(prefilters, s, options, flitsXHR),
          state === 2)
        )
          return flitsXHR;
        (fireGlobals = Flits.event && s.global),
          fireGlobals &&
            Flits.active++ === 0 &&
            Flits.event.trigger("ajaxStart"),
          (s.type = s.type.toUpperCase()),
          (s.hasContent = !rnoContent.test(s.type)),
          (cacheURL = s.url),
          s.hasContent ||
            (s.data &&
              ((cacheURL = s.url +=
                (rquery.test(cacheURL) ? "&" : "?") + s.data),
              delete s.data),
            s.cache === !1 &&
              (s.url = rts.test(cacheURL)
                ? cacheURL.replace(rts, "$1_=" + nonce++)
                : cacheURL +
                  (rquery.test(cacheURL) ? "&" : "?") +
                  "_=" +
                  nonce++)),
          s.ifModified &&
            (Flits.lastModified[cacheURL] &&
              flitsXHR.setRequestHeader(
                "If-Modified-Since",
                Flits.lastModified[cacheURL]
              ),
            Flits.etag[cacheURL] &&
              flitsXHR.setRequestHeader("If-None-Match", Flits.etag[cacheURL])),
          ((s.data && s.hasContent && s.contentType !== !1) ||
            options.contentType) &&
            flitsXHR.setRequestHeader("Content-Type", s.contentType),
          flitsXHR.setRequestHeader(
            "Accept",
            s.dataTypes[0] && s.accepts[s.dataTypes[0]]
              ? s.accepts[s.dataTypes[0]] +
                  (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "")
              : s.accepts["*"]
          );
        for (i in s.headers) flitsXHR.setRequestHeader(i, s.headers[i]);
        if (
          s.beforeSend &&
          (s.beforeSend.call(callbackContext, flitsXHR, s) === !1 ||
            state === 2)
        )
          return flitsXHR.abort();
        strAbort = "abort";
        for (i in { success: 1, error: 1, complete: 1 }) flitsXHR[i](s[i]);
        if (
          ((transport = inspectPrefiltersOrTransports(
            transports,
            s,
            options,
            flitsXHR
          )),
          !transport)
        )
          done(-1, "No Transport");
        else {
          if (
            ((flitsXHR.readyState = 1),
            fireGlobals &&
              globalEventContext.trigger("ajaxSend", [flitsXHR, s]),
            state === 2)
          )
            return flitsXHR;
          s.async &&
            s.timeout > 0 &&
            (timeoutTimer = window.setTimeout(function () {
              flitsXHR.abort("timeout");
            }, s.timeout));
          try {
            (state = 1), transport.send(requestHeaders, done);
          } catch (e) {
            if (state < 2) {
              done(-1, e);
            } else {
              throw e;
            }
          }
        }
        return flitsXHR;
      },
      getJSON: function (url, data, callback) {
        return Flits.get(url, data, callback, "json");
      },
      getScript: function (url, callback) {
        return Flits.get(url, undefined, callback, "script");
      },
    }),
    Flits.each(["get", "post"], function (i, method) {
      Flits[method] = function (url, data, callback, type) {
        return (
          Flits.isFunction(data) &&
            ((type = type || callback), (callback = data), (data = undefined)),
          Flits.ajax(
            Flits.extend(
              {
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback,
              },
              Flits.isPlainObject(url) && url
            )
          )
        );
      };
    }),
    (Flits._evalUrl = function (url) {
      return Flits.ajax({
        url: url,
        type: "GET",
        dataType: "script",
        async: !1,
        global: !1,
        throws: !0,
      });
    }),
    Flits.fn.extend({
      wrapAll: function (html) {
        var wrap;
        return Flits.isFunction(html)
          ? this.each(function (i) {
              Flits(this).wrapAll(html.call(this, i));
            })
          : (this[0] &&
              ((wrap = Flits(html, this[0].ownerDocument).eq(0).clone(!0)),
              this[0].parentNode && wrap.insertBefore(this[0]),
              wrap
                .map(function () {
                  var elem = this;
                  while (elem.firstElementChild) elem = elem.firstElementChild;
                  return elem;
                })
                .append(this)),
            this);
      },
      wrapInner: function (html) {
        return Flits.isFunction(html)
          ? this.each(function (i) {
              Flits(this).wrapInner(html.call(this, i));
            })
          : this.each(function () {
              var self = Flits(this),
                contents = self.contents();
              contents.length ? contents.wrapAll(html) : self.append(html);
            });
      },
      wrap: function (html) {
        var isFunction = Flits.isFunction(html);
        return this.each(function (i) {
          Flits(this).wrapAll(isFunction ? html.call(this, i) : html);
        });
      },
      unwrap: function () {
        return this.parent()
          .each(function () {
            Flits.nodeName(this, "body") ||
              Flits(this).replaceWith(this.childNodes);
          })
          .end();
      },
    }),
    (Flits.expr.filters.hidden = function (elem) {
      return !Flits.expr.filters.visible(elem);
    }),
    (Flits.expr.filters.visible = function (elem) {
      return (
        elem.offsetWidth > 0 ||
        elem.offsetHeight > 0 ||
        elem.getClientRects().length > 0
      );
    });
  var r20 = /%20/g,
    rbracket = /\[\]$/,
    rCRLF = /\r?\n/g,
    rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
    rsubmittable = /^(?:input|select|textarea|keygen)/i;
  (Flits.param = function (a, traditional) {
    var prefix,
      s = [],
      add = function (key, value) {
        (value = Flits.isFunction(value)
          ? value()
          : value == null
          ? ""
          : value),
          (s[s.length] =
            encodeURIComponent(key) + "=" + encodeURIComponent(value));
      };
    if (
      (traditional === undefined &&
        (traditional = Flits.ajaxSettings && Flits.ajaxSettings.traditional),
      Flits.isArray(a) || (a.Flits && !Flits.isPlainObject(a)))
    )
      Flits.each(a, function () {
        add(this.name, this.value);
      });
    else for (prefix in a) buildParams(prefix, a[prefix], traditional, add);
    return s.join("&").replace(r20, "+");
  }),
    Flits.fn.extend({
      serialize: function () {
        return Flits.param(this.serializeArray());
      },
      serializeArray: function () {
        return this.map(function () {
          var elements = Flits.prop(this, "elements");
          return elements ? Flits.makeArray(elements) : this;
        })
          .filter(function () {
            var type = this.type;
            return (
              this.name &&
              !Flits(this).is(":disabled") &&
              rsubmittable.test(this.nodeName) &&
              !rsubmitterTypes.test(type) &&
              (this.checked || !rcheckableType.test(type))
            );
          })
          .map(function (i, elem) {
            var val = Flits(this).val();
            return val == null
              ? null
              : Flits.isArray(val)
              ? Flits.map(val, function (val) {
                  return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
                })
              : { name: elem.name, value: val.replace(rCRLF, "\r\n") };
          })
          .get();
      },
    }),
    (Flits.ajaxSettings.xhr = function () {
      try {
        return new window.XMLHttpRequest();
      } catch (e) {}
    });
  var xhrSuccessStatus = { 0: 200, 1223: 204 },
    xhrSupported = Flits.ajaxSettings.xhr();
  (support.cors = !!xhrSupported && "withCredentials" in xhrSupported),
    (support.ajax = xhrSupported = !!xhrSupported),
    Flits.ajaxTransport(function (options) {
      var callback, errorCallback;
      return support.cors || (xhrSupported && !options.crossDomain)
        ? {
            send: function (headers, complete) {
              var i,
                xhr = options.xhr();
              if (
                (xhr.open(
                  options.type,
                  options.url,
                  options.async,
                  options.username,
                  options.password
                ),
                options.xhrFields)
              )
                for (i in options.xhrFields) xhr[i] = options.xhrFields[i];
              options.mimeType &&
                xhr.overrideMimeType &&
                xhr.overrideMimeType(options.mimeType),
                options.crossDomain ||
                  headers["X-Requested-With"] ||
                  (headers["X-Requested-With"] = "XMLHttpRequest");
              for (i in headers) xhr.setRequestHeader(i, headers[i]);
              (callback = function (type) {
                return function () {
                  callback &&
                    ((callback =
                      errorCallback =
                      xhr.onload =
                      xhr.onerror =
                      xhr.onabort =
                      xhr.onreadystatechange =
                        null),
                    type === "abort"
                      ? xhr.abort()
                      : type === "error"
                      ? typeof xhr.status !== "number"
                        ? complete(0, "error")
                        : complete(xhr.status, xhr.statusText)
                      : complete(
                          xhrSuccessStatus[xhr.status] || xhr.status,
                          xhr.statusText,
                          (xhr.responseType || "text") !== "text" ||
                            typeof xhr.responseText !== "string"
                            ? { binary: xhr.response }
                            : { text: xhr.responseText },
                          xhr.getAllResponseHeaders()
                        ));
                };
              }),
                (xhr.onload = callback()),
                (errorCallback = xhr.onerror = callback("error")),
                xhr.onabort !== undefined
                  ? (xhr.onabort = errorCallback)
                  : (xhr.onreadystatechange = function () {
                      xhr.readyState === 4 &&
                        window.setTimeout(function () {
                          callback && errorCallback();
                        });
                    }),
                (callback = callback("abort"));
              try {
                xhr.send((options.hasContent && options.data) || null);
              } catch (e) {
                if (callback) {
                  throw e;
                }
              }
            },
            abort: function () {
              callback && callback();
            },
          }
        : void 0;
    }),
    Flits.ajaxSetup({
      accepts: {
        script:
          "text/javascript, application/javascript, " +
          "application/ecmascript, application/x-ecmascript",
      },
      contents: { script: /\b(?:java|ecma)script\b/ },
      converters: {
        "text script": function (text) {
          return Flits.globalEval(text), text;
        },
      },
    }),
    Flits.ajaxPrefilter("script", function (s) {
      s.cache === undefined && (s.cache = !1),
        s.crossDomain && (s.type = "GET");
    }),
    Flits.ajaxTransport("script", function (s) {
      if (s.crossDomain) {
        var script, callback;
        return {
          send: function (_, complete) {
            (script = Flits("<script>")
              .prop({ charset: s.scriptCharset, src: s.url })
              .on(
                "load error",
                (callback = function (evt) {
                  script.remove(),
                    (callback = null),
                    evt && complete(evt.type === "error" ? 404 : 200, evt.type);
                })
              )),
              document.head.appendChild(script[0]);
          },
          abort: function () {
            callback && callback();
          },
        };
      }
    });
  var oldCallbacks = [],
    rjsonp = /(=)\?(?=&|$)|\?\?/;
  Flits.ajaxSetup({
    jsonp: "callback",
    jsonpCallback: function () {
      var callback = oldCallbacks.pop() || Flits.expando + "_" + nonce++;
      return (this[callback] = !0), callback;
    },
  }),
    Flits.ajaxPrefilter("json jsonp", function (s, originalSettings, flitsXHR) {
      var callbackName,
        overwritten,
        responseContainer,
        jsonProp =
          s.jsonp !== !1 &&
          (rjsonp.test(s.url)
            ? "url"
            : typeof s.data === "string" &&
              (s.contentType || "").indexOf(
                "application/x-www-form-urlencoded"
              ) === 0 &&
              rjsonp.test(s.data) &&
              "data");
      return jsonProp || s.dataTypes[0] === "jsonp"
        ? ((callbackName = s.jsonpCallback =
            Flits.isFunction(s.jsonpCallback)
              ? s.jsonpCallback()
              : s.jsonpCallback),
          jsonProp
            ? (s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName))
            : s.jsonp !== !1 &&
              (s.url +=
                (rquery.test(s.url) ? "&" : "?") +
                s.jsonp +
                "=" +
                callbackName),
          (s.converters["script json"] = function () {
            return (
              responseContainer ||
                Flits.error(callbackName + " was not called"),
              responseContainer[0]
            );
          }),
          (s.dataTypes[0] = "json"),
          (overwritten = window[callbackName]),
          (window[callbackName] = function () {
            responseContainer = arguments;
          }),
          flitsXHR.always(function () {
            overwritten === undefined
              ? Flits(window).removeProp(callbackName)
              : (window[callbackName] = overwritten),
              s[callbackName] &&
                ((s.jsonpCallback = originalSettings.jsonpCallback),
                oldCallbacks.push(callbackName)),
              responseContainer &&
                Flits.isFunction(overwritten) &&
                overwritten(responseContainer[0]),
              (responseContainer = overwritten = undefined);
          }),
          "script")
        : void 0;
    }),
    (Flits.parseHTML = function (data, context, keepScripts) {
      if (!data || typeof data !== "string") return null;
      typeof context === "boolean" && ((keepScripts = context), (context = !1)),
        (context = context || document);
      var parsed = rsingleTag.exec(data),
        scripts = !keepScripts && [];
      return parsed
        ? [context.createElement(parsed[1])]
        : ((parsed = buildFragment([data], context, scripts)),
          scripts && scripts.length && Flits(scripts).remove(),
          Flits.merge([], parsed.childNodes));
    });
  var _load = Flits.fn.load;
  (Flits.fn.load = function (url, params, callback) {
    if (typeof url !== "string" && _load) return _load.apply(this, arguments);
    var selector,
      type,
      response,
      self = this,
      off = url.indexOf(" ");
    return (
      off > -1 &&
        ((selector = Flits.trim(url.slice(off))), (url = url.slice(0, off))),
      Flits.isFunction(params)
        ? ((callback = params), (params = undefined))
        : params && typeof params === "object" && (type = "POST"),
      self.length > 0 &&
        Flits.ajax({
          url: url,
          type: type || "GET",
          dataType: "html",
          data: params,
        })
          .done(function (responseText) {
            (response = arguments),
              self.html(
                selector
                  ? Flits("<div>")
                      .append(Flits.parseHTML(responseText))
                      .find(selector)
                  : responseText
              );
          })
          .always(
            callback &&
              function (flitsXHR, status) {
                self.each(function () {
                  callback.apply(
                    this,
                    response || [flitsXHR.responseText, status, flitsXHR]
                  );
                });
              }
          ),
      this
    );
  }),
    Flits.each(
      [
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend",
      ],
      function (i, type) {
        Flits.fn[type] = function (fn) {
          return this.on(type, fn);
        };
      }
    ),
    (Flits.expr.filters.animated = function (elem) {
      return Flits.grep(Flits.timers, function (fn) {
        return elem === fn.elem;
      }).length;
    }),
    (Flits.offset = {
      setOffset: function (elem, options, i) {
        var curPosition,
          curLeft,
          curCSSTop,
          curTop,
          curOffset,
          curCSSLeft,
          calculatePosition,
          position = Flits.css(elem, "position"),
          curElem = Flits(elem),
          props = {};
        position === "static" && (elem.style.position = "relative"),
          (curOffset = curElem.offset()),
          (curCSSTop = Flits.css(elem, "top")),
          (curCSSLeft = Flits.css(elem, "left")),
          (calculatePosition =
            (position === "absolute" || position === "fixed") &&
            (curCSSTop + curCSSLeft).indexOf("auto") > -1),
          calculatePosition
            ? ((curPosition = curElem.position()),
              (curTop = curPosition.top),
              (curLeft = curPosition.left))
            : ((curTop = parseFloat(curCSSTop) || 0),
              (curLeft = parseFloat(curCSSLeft) || 0)),
          Flits.isFunction(options) &&
            (options = options.call(elem, i, Flits.extend({}, curOffset))),
          options.top != null &&
            (props.top = options.top - curOffset.top + curTop),
          options.left != null &&
            (props.left = options.left - curOffset.left + curLeft),
          "using" in options
            ? options.using.call(elem, props)
            : curElem.css(props);
      },
    }),
    Flits.fn.extend({
      offset: function (options) {
        if (arguments.length)
          return options === undefined
            ? this
            : this.each(function (i) {
                Flits.offset.setOffset(this, options, i);
              });
        var docElem,
          win,
          elem = this[0],
          box = { top: 0, left: 0 },
          doc = elem && elem.ownerDocument;
        return doc
          ? ((docElem = doc.documentElement),
            Flits.contains(docElem, elem)
              ? ((box = elem.getBoundingClientRect()),
                (win = getWindow(doc)),
                {
                  top: box.top + win.pageYOffset - docElem.clientTop,
                  left: box.left + win.pageXOffset - docElem.clientLeft,
                })
              : box)
          : void 0;
      },
      position: function () {
        if (!this[0]) return;
        var offsetParent,
          offset,
          elem = this[0],
          parentOffset = { top: 0, left: 0 };
        return (
          Flits.css(elem, "position") === "fixed"
            ? (offset = elem.getBoundingClientRect())
            : ((offsetParent = this.offsetParent()),
              (offset = this.offset()),
              Flits.nodeName(offsetParent[0], "html") ||
                (parentOffset = offsetParent.offset()),
              (parentOffset.top += Flits.css(
                offsetParent[0],
                "borderTopWidth",
                !0
              )),
              (parentOffset.left += Flits.css(
                offsetParent[0],
                "borderLeftWidth",
                !0
              ))),
          {
            top:
              offset.top - parentOffset.top - Flits.css(elem, "marginTop", !0),
            left:
              offset.left -
              parentOffset.left -
              Flits.css(elem, "marginLeft", !0),
          }
        );
      },
      offsetParent: function () {
        return this.map(function () {
          var offsetParent = this.offsetParent;
          while (
            offsetParent &&
            Flits.css(offsetParent, "position") === "static"
          )
            offsetParent = offsetParent.offsetParent;
          return offsetParent || documentElement;
        });
      },
    }),
    Flits.each(
      { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
      function (method, prop) {
        var top = "pageYOffset" === prop;
        Flits.fn[method] = function (val) {
          return access(
            this,
            function (elem, method, val) {
              var win = getWindow(elem);
              if (val === undefined) return win ? win[prop] : elem[method];
              win
                ? win.scrollTo(
                    top ? win.pageXOffset : val,
                    top ? val : win.pageYOffset
                  )
                : (elem[method] = val);
            },
            method,
            val,
            arguments.length
          );
        };
      }
    ),
    Flits.each(["top", "left"], function (i, prop) {
      Flits.cssHooks[prop] = addGetHookIf(
        support.pixelPosition,
        function (elem, computed) {
          return computed
            ? ((computed = curCSS(elem, prop)),
              rnumnonpx.test(computed)
                ? Flits(elem).position()[prop] + "px"
                : computed)
            : void 0;
        }
      );
    }),
    Flits.each({ Height: "height", Width: "width" }, function (name, type) {
      Flits.each(
        { padding: "inner" + name, content: type, "": "outer" + name },
        function (defaultExtra, funcName) {
          Flits.fn[funcName] = function (margin, value) {
            var chainable =
                arguments.length &&
                (defaultExtra || typeof margin !== "boolean"),
              extra =
                defaultExtra ||
                (margin === !0 || value === !0 ? "margin" : "border");
            return access(
              this,
              function (elem, type, value) {
                var doc;
                return Flits.isWindow(elem)
                  ? elem.document.documentElement["client" + name]
                  : elem.nodeType === 9
                  ? ((doc = elem.documentElement),
                    Math.max(
                      elem.body["scroll" + name],
                      doc["scroll" + name],
                      elem.body["offset" + name],
                      doc["offset" + name],
                      doc["client" + name]
                    ))
                  : value === undefined
                  ? Flits.css(elem, type, extra)
                  : Flits.style(elem, type, value, extra);
              },
              type,
              chainable ? margin : undefined,
              chainable,
              null
            );
          };
        }
      );
    }),
    Flits.fn.extend({
      bind: function (types, data, fn) {
        return this.on(types, null, data, fn);
      },
      unbind: function (types, fn) {
        return this.off(types, null, fn);
      },
      delegate: function (selector, types, data, fn) {
        return this.on(types, selector, data, fn);
      },
      undelegate: function (selector, types, fn) {
        return arguments.length === 1
          ? this.off(selector, "**")
          : this.off(types, selector || "**", fn);
      },
      size: function () {
        return this.length;
      },
    }),
    (Flits.fn.andSelf = Flits.fn.addBack),
    typeof define === "function" &&
      define.amd &&
      define("Flits", [], function () {
        return Flits;
      });
  var _Flits = window.Flits;
  return (
    (Flits.noConflict = function (deep) {
      return deep && window.Flits === Flits && (window.Flits = _Flits), Flits;
    }),
    noGlobal || (window.Flits = Flits),
    Flits
  );
});

(function (Flits) {
  (function (t, o) {
    "function" == typeof define && define.amd
      ? define(o)
      : "object" == typeof exports
      ? (module.exports = o())
      : (t.flits_tingle = o());
  })(this, function () {
    function t(t) {
      var o = {
        onClose: null,
        onOpen: null,
        beforeOpen: null,
        beforeClose: null,
        stickyFooter: !1,
        footer: !1,
        cssClass: [],
        closeLabel: "Close",
        closeMethods: ["overlay", "button", "escape"],
      };
      (this.opts = r({}, o, t)), this.init();
    }
    function o() {
      this.modalBoxFooter &&
        ((this.modalBoxFooter.style.width = this.modalBox.clientWidth + "px"),
        (this.modalBoxFooter.style.left = this.modalBox.offsetLeft + "px"));
    }
    function e() {
      (this.modal = document.createElement("div")),
        this.modal.classList.add("flits-tingle-modal"),
        (0 === this.opts.closeMethods.length ||
          -1 === this.opts.closeMethods.indexOf("overlay")) &&
          this.modal.classList.add("flits-tingle-modal-noOverlayClose"),
        (this.modal.style.display = "none"),
        this.opts.cssClass.forEach(function (t) {
          "string" == typeof t && this.modal.classList.add(t);
        }, this),
        -1 !== this.opts.closeMethods.indexOf("button") &&
          ((this.modalCloseBtn = document.createElement("button")),
          this.modalCloseBtn.classList.add("flits-tingle-modal-close"),
          (this.modalCloseBtnIcon = document.createElement("span")),
          this.modalCloseBtnIcon.classList.add("flits-tingle-moda-closeIcon"),
          (this.modalCloseBtnIcon.innerHTML = "\xD7"),
          (this.modalCloseBtnLabel = document.createElement("span")),
          this.modalCloseBtnLabel.classList.add(
            "flits-tingle-modal-closeLabel"
          ),
          (this.modalCloseBtnLabel.innerHTML = this.opts.closeLabel),
          this.modalCloseBtn.appendChild(this.modalCloseBtnIcon),
          this.modalCloseBtn.appendChild(this.modalCloseBtnLabel)),
        (this.modalBox = document.createElement("div")),
        this.modalBox.classList.add("flits-tingle-modal-box"),
        -1 !== this.opts.closeMethods.indexOf("button") &&
          this.modalBox.appendChild(this.modalCloseBtn),
        (this.modalBoxContent = document.createElement("div")),
        this.modalBoxContent.classList.add("flits-tingle-modal-box-content"),
        this.modalBox.appendChild(this.modalBoxContent),
        this.modal.appendChild(this.modalBox);
    }
    function s() {
      (this.modalBoxFooter = document.createElement("div")),
        this.modalBoxFooter.classList.add("flits-tingle-modal-box-footer"),
        this.modalBox.appendChild(this.modalBoxFooter);
    }
    function i() {
      (this._events = {
        clickCloseBtn: this.close.bind(this),
        clickOverlay: l.bind(this),
        resize: this.checkOverflow.bind(this),
        keyboardNav: n.bind(this),
      }),
        -1 !== this.opts.closeMethods.indexOf("button") &&
          this.modalCloseBtn.addEventListener(
            "click",
            this._events.clickCloseBtn
          ),
        this.modal.addEventListener("mousedown", this._events.clickOverlay),
        window.addEventListener("resize", this._events.resize),
        document.addEventListener("keydown", this._events.keyboardNav);
    }
    function n(t) {
      -1 !== this.opts.closeMethods.indexOf("escape") &&
        27 === t.which &&
        this.isOpen() &&
        this.close();
    }
    function l(t) {
      -1 !== this.opts.closeMethods.indexOf("overlay") &&
        !d(t.target, "tingle-modal") &&
        t.clientX < this.modal.clientWidth &&
        this.close();
    }
    function d(t, o) {
      for (; (t = t.parentElement) && !t.classList.contains(o); );
      return t;
    }
    function a() {
      -1 !== this.opts.closeMethods.indexOf("button") &&
        this.modalCloseBtn.removeEventListener(
          "click",
          this._events.clickCloseBtn
        ),
        this.modal.removeEventListener("mousedown", this._events.clickOverlay),
        window.removeEventListener("resize", this._events.resize),
        document.removeEventListener("keydown", this._events.keyboardNav);
    }
    function r() {
      for (var t = 1; t < arguments.length; t++)
        for (var o in arguments[t])
          arguments[t].hasOwnProperty(o) && (arguments[0][o] = arguments[t][o]);
      return arguments[0];
    }
    var h = (function (t, o, e) {
      (o = document.createElement("flits-tingle-test-transition")),
        (e = {
          transition: "transitionend",
          OTransition: "oTransitionEnd",
          MozTransition: "transitionend",
          WebkitTransition: "webkitTransitionEnd",
        });
      for (t in e) if (void 0 !== o.style[t]) return e[t];
    })();
    return (
      (t.prototype.init = function () {
        this.modal ||
          (e.call(this),
          i.call(this),
          document.body.insertBefore(this.modal, document.body.firstChild),
          this.opts.footer && this.addFooter());
      }),
      (t.prototype.destroy = function () {
        null !== this.modal &&
          (a.call(this),
          this.modal.parentNode.removeChild(this.modal),
          (this.modal = null));
      }),
      (t.prototype.open = function () {
        var t = this;
        "function" == typeof t.opts.beforeOpen && t.opts.beforeOpen(),
          this.modal.style.removeProperty
            ? this.modal.style.removeProperty("display")
            : this.modal.style.removeAttribute("display"),
          document.body.classList.add("flits-tingle-enabled"),
          this.setStickyFooter(this.opts.stickyFooter),
          this.modal.classList.add("flits-tingle-modal-visible"),
          h
            ? this.modal.addEventListener(
                h,
                function o() {
                  "function" == typeof t.opts.onOpen && t.opts.onOpen.call(t),
                    t.modal.removeEventListener(h, o, !1);
                },
                !1
              )
            : "function" == typeof t.opts.onOpen && t.opts.onOpen.call(t),
          this.checkOverflow();
      }),
      (t.prototype.isOpen = function () {
        return !!this.modal.classList.contains("flits-tingle-modal-visible");
      }),
      (t.prototype.close = function () {
        if (
          "function" != typeof this.opts.beforeClose ||
          this.opts.beforeClose.call(this)
        ) {
          document.body.classList.remove("flits-tingle-enabled"),
            this.modal.classList.remove("flits-tingle-modal-visible");
          var t = this;
          h
            ? this.modal.addEventListener(
                h,
                function o() {
                  t.modal.removeEventListener(h, o, !1),
                    (t.modal.style.display = "none"),
                    "function" == typeof t.opts.onClose &&
                      t.opts.onClose.call(this);
                },
                !1
              )
            : ((t.modal.style.display = "none"),
              "function" == typeof t.opts.onClose && t.opts.onClose.call(this));
        }
      }),
      (t.prototype.setContent = function (t) {
        "string" == typeof t
          ? (this.modalBoxContent.innerHTML = t)
          : ((this.modalBoxContent.innerHTML = ""),
            this.modalBoxContent.appendChild(t));
      }),
      (t.prototype.getContent = function () {
        return this.modalBoxContent;
      }),
      (t.prototype.addFooter = function () {
        s.call(this);
      }),
      (t.prototype.setFooterContent = function (t) {
        this.modalBoxFooter.innerHTML = t;
      }),
      (t.prototype.getFooterContent = function () {
        return this.modalBoxFooter;
      }),
      (t.prototype.setStickyFooter = function (t) {
        this.isOverflow() || (t = !1),
          t
            ? this.modalBox.contains(this.modalBoxFooter) &&
              (this.modalBox.removeChild(this.modalBoxFooter),
              this.modal.appendChild(this.modalBoxFooter),
              this.modalBoxFooter.classList.add(
                "flits-tingle-modal-box-footer-sticky"
              ),
              o.call(this),
              (this.modalBoxContent.style["padding-bottom"] =
                this.modalBoxFooter.clientHeight + 20 + "px"))
            : this.modalBoxFooter &&
              (this.modalBox.contains(this.modalBoxFooter) ||
                (this.modal.removeChild(this.modalBoxFooter),
                this.modalBox.appendChild(this.modalBoxFooter),
                (this.modalBoxFooter.style.width = "auto"),
                (this.modalBoxFooter.style.left = ""),
                (this.modalBoxContent.style["padding-bottom"] = ""),
                this.modalBoxFooter.classList.remove(
                  "flits-tingle-modal-box-footer-sticky"
                )));
      }),
      (t.prototype.addFooterBtn = function (t, o, e) {
        var s = document.createElement("button");
        return (
          (s.innerHTML = t),
          s.addEventListener("click", e),
          "string" == typeof o &&
            o.length &&
            o.split(" ").forEach(function (t) {
              s.classList.add(t);
            }),
          this.modalBoxFooter.appendChild(s),
          s
        );
      }),
      (t.prototype.resize = function () {
        console.warn("Resize is deprecated and will be removed in version 1.0");
      }),
      (t.prototype.isOverflow = function () {
        var t = window.innerHeight;
        return this.modalBox.clientHeight >= t;
      }),
      (t.prototype.checkOverflow = function () {
        this.modal.classList.contains("flits-tingle-modal-visible") &&
          (this.isOverflow()
            ? this.modal.classList.add("flits-tingle-modal-overflow")
            : this.modal.classList.remove("flits-tingle-modal-overflow"),
          !this.isOverflow() && this.opts.stickyFooter
            ? this.setStickyFooter(!1)
            : this.isOverflow() &&
              this.opts.stickyFooter &&
              (o.call(this), this.setStickyFooter(!0)));
      }),
      { modal: t }
    );
  }),
    (function (root, factory) {
      "use strict";
      typeof define === "function" && define.amd
        ? define([], function () {
            return (root.flitsSnackbar = factory());
          })
        : typeof module === "object" && module.exports
        ? (module.exports = root.flitsSnackbar = factory())
        : (root.flitsSnackbar = factory());
    })(this, function () {
      var flitsSnackbar = {};
      flitsSnackbar.current = null;
      var $defaults = {
        text: "Default Text",
        textColor: "#FFFFFF",
        width: "auto",
        showAction: !0,
        actionText: "Dismiss",
        actionTextAria: "Dismiss, Description for Screen Readers",
        alertScreenReader: !1,
        actionTextColor: "#4CAF50",
        showSecondButton: !1,
        secondButtonText: "",
        secondButtonAria: "Description for Screen Readers",
        secondButtonTextColor: "#4CAF50",
        backgroundColor: "#323232",
        pos: "bottom-left",
        duration: 5000,
        customClass: "",
        content: null,
        container: "body",
        onActionClick: function (element) {
          element.style.opacity = 0;
        },
        onSecondButtonClick: function (element) {},
        onClose: function (element) {},
      };
      (flitsSnackbar.show = function ($options) {
        var options = Extend(!0, $defaults, $options);
        if (
          (flitsSnackbar.current &&
            ((flitsSnackbar.current.style.opacity = 0),
            setTimeout(
              function () {
                var $parent = this.parentElement;
                $parent && $parent.removeChild(this);
              }.bind(flitsSnackbar.current),
              500
            )),
          options.content != null)
        )
          (flitsSnackbar.snackbar = document.createElement("div")),
            (flitsSnackbar.snackbar.className =
              "flits-snackbar-container " + options.customClass),
            flitsSnackbar.snackbar.appendChild(options.content);
        else {
          (flitsSnackbar.snackbar = document.createElement("div")),
            (flitsSnackbar.snackbar.className =
              "flits-snackbar-container " + options.customClass),
            (flitsSnackbar.snackbar.style.width = options.width);
          var $p = document.createElement("p");
          ($p.style.margin = 0),
            ($p.style.padding = 0),
            ($p.style.color = options.textColor),
            ($p.style.fontSize = "14px"),
            ($p.style.fontWeight = 300),
            ($p.style.lineHeight = "1.2"),
            ($p.innerHTML = options.text),
            flitsSnackbar.snackbar.appendChild($p),
            (flitsSnackbar.snackbar.style.background = options.backgroundColor);
        }
        if (options.showSecondButton) {
          var secondButton = document.createElement("button");
          (secondButton.className = "action"),
            (secondButton.innerHTML = options.secondButtonText),
            secondButton.setAttribute("aria-label", options.secondButtonAria),
            (secondButton.style.color = options.secondButtonTextColor),
            secondButton.addEventListener("click", function () {
              options.onSecondButtonClick(flitsSnackbar.snackbar);
            }),
            flitsSnackbar.snackbar.appendChild(secondButton);
        }
        if (options.showAction) {
          var actionButton = document.createElement("button");
          (actionButton.className = "action"),
            (actionButton.innerHTML = options.actionText),
            actionButton.setAttribute("aria-label", options.actionTextAria),
            (actionButton.style.color = options.actionTextColor),
            actionButton.addEventListener("click", function () {
              options.onActionClick(flitsSnackbar.snackbar);
            }),
            flitsSnackbar.snackbar.appendChild(actionButton);
        }
        options.duration != 0 &&
          setTimeout(
            function () {
              flitsSnackbar.current === this &&
                ((flitsSnackbar.current.style.opacity = 0),
                (flitsSnackbar.current.style.top = "-100px"),
                (flitsSnackbar.current.style.bottom = "-100px"));
            }.bind(flitsSnackbar.snackbar),
            options.duration
          ),
          options.alertScreenReader &&
            flitsSnackbar.snackbar.setAttribute("role", "alert"),
          flitsSnackbar.snackbar.addEventListener(
            "transitionend",
            function (event, elapsed) {
              event.propertyName === "opacity" &&
                this.style.opacity === "0" &&
                (typeof options.onClose === "function" && options.onClose(this),
                this.parentElement.removeChild(this),
                flitsSnackbar.current === this &&
                  (flitsSnackbar.current = null));
            }.bind(flitsSnackbar.snackbar)
          ),
          (flitsSnackbar.current = flitsSnackbar.snackbar),
          Flits(options.container).append(flitsSnackbar.snackbar);
        var $bottom = getComputedStyle(flitsSnackbar.snackbar).bottom;
        var $top = getComputedStyle(flitsSnackbar.snackbar).top;
        (flitsSnackbar.snackbar.style.opacity = 1),
          (flitsSnackbar.snackbar.className =
            "flits-snackbar-container " +
            options.customClass +
            " flits-snackbar-pos " +
            options.pos);
      }),
        (flitsSnackbar.close = function () {
          flitsSnackbar.current && (flitsSnackbar.current.style.opacity = 0);
        });
      var Extend = function () {
        var extended = {};
        var deep = !1;
        var i = 0;
        var length = arguments.length;
        Object.prototype.toString.call(arguments[0]) === "[object Boolean]" &&
          ((deep = arguments[0]), i++);
        var merge = function (obj) {
          for (var prop in obj)
            Object.prototype.hasOwnProperty.call(obj, prop) &&
              (deep &&
              Object.prototype.toString.call(obj[prop]) === "[object Object]"
                ? (extended[prop] = Extend(!0, extended[prop], obj[prop]))
                : (extended[prop] = obj[prop]));
        };
        for (; i < length; i++) {
          var obj = arguments[i];
          merge(obj);
        }
        return extended;
      };
      return flitsSnackbar;
    });
  var recentlyViewDataStore = (Flits.recentlyViewDataStore = function (item) {
    function updateProduct() {
      Flits.getLocalStorage(settings.recentHandle) == null ||
      Flits.getLocalStorage(settings.recentHandle) == undefined
        ? (Flits.setLocalStorage(settings.recentHandle, []),
          (settings.queue = Flits.getLocalStorage(settings.recentHandle, [])))
        : (settings.queue = Flits.getLocalStorage(settings.recentHandle));
    }
    function isPresent(item) {
      for (let i = 0; i < settings.queue.length; i++)
        if (settings.queue[i].product_handle.indexOf(item) !== -1) return 1;
      return -1;
    }
    function isFull() {
      return settings.limit == settings.queue.length;
    }
    function removeFirstProduct() {
      settings.queue.splice(0, 1);
    }
    var settings = {
      queue: "",
      finalQueue: [],
      limit: 9,
      recentHandle: "flits_recently_products",
      recentHandle_1: "flits_recently_products_copy",
    };
    updateProduct(),
      isPresent(item) == -1 &&
        (isFull() && removeFirstProduct(),
        settings.queue.push({ product_handle: item }),
        settings.queue.forEach(function (v, i) {
          settings.finalQueue.push({
            product_handle: settings.queue[i].product_handle,
          });
        }),
        Flits.setLocalStorage(settings.recentHandle, settings.finalQueue));
  });
  Flits.extend({
    LoadStyleScript: function (index, url, callback) {
      try {
        if (index && window.flitsObjects.allCssJs[index].status) return;
        window.flitsObjects.allCssJs[index].status = 2;
        var isCss = url.indexOf(".css") != -1;
        var tag = isCss
          ? document.createElement("link")
          : document.createElement("script");
        (tag.type = isCss ? "text/css" : "text/javascript"),
          isCss && (tag.rel = "stylesheet"),
          tag.readyState
            ? (tag.onreadystatechange = function () {
                (tag.readyState == "loaded" || tag.readyState == "complete") &&
                  ((window.flitsObjects.allCssJs[index].status = 1),
                  (tag.onreadystatechange = null),
                  typeof callback === "function" && callback.apply(this));
              })
            : (tag.onload = function () {
                (window.flitsObjects.allCssJs[index].status = 1),
                  typeof callback === "function" && callback.apply(this);
              }),
          isCss && (tag.href = url),
          isCss || (tag.src = url),
          document.getElementsByTagName("head")[0].appendChild(tag);
      } catch (ex) {
        console.error(ex);
      }
    },
    localStorageVar: "flits",
    setLocalStorage: function (k, v) {
      if (localStorage.getItem(Flits.localStorageVar) == null) {
        localStorage.setItem(Flits.localStorageVar, "{}");
        var existing = JSON.parse(localStorage.getItem(Flits.localStorageVar));
        return (
          (existing[k] = v),
          localStorage.setItem(Flits.localStorageVar, JSON.stringify(existing))
        );
      } else {
        var existing = JSON.parse(localStorage.getItem(Flits.localStorageVar));
        return (
          (existing[k] = v),
          localStorage.setItem(Flits.localStorageVar, JSON.stringify(existing))
        );
      }
    },
    getLocalStorage: function (k) {
      var existing = JSON.parse(localStorage.getItem(Flits.localStorageVar));
      var _key = k.split(".");
      var _val = existing;
      if (_key.length > 1)
        for (let i = 0; i < _key.length; i++)
          _val != null && (_val = _val[_key[i]]);
      else _val != null && (_val = _val[_key[0]]);
      return _val;
    },
    getCookie: function (cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
      }
      return "";
    },
    setCookie: function (cname, cvalue, exdays) {
      let d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    styleCreate: function (option) {
      let style = '<style type="text/css">' + option + "</style>";
      Flits("head").append(style);
    },
    isNull: function (x) {
      return x === void 0 || x == null || x.toString().trim() == "";
    },
    getURLParameter: function (name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.search
          ) || [null, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    formatMoney: function (cents, format, replaceObject) {
      function defaultOption(opt, def) {
        return opt === void 0 ? def : opt;
      }
      function formatWithDelimiters(number, precision, thousands, decimal) {
        if (
          ((precision = defaultOption(precision, 2)),
          (thousands = defaultOption(thousands, ",")),
          (decimal = defaultOption(decimal, ".")),
          isNaN(number) || number == null)
        )
          return "0";
        number = (number / 100).toFixed(precision);
        var parts = number.split("."),
          dollars = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            "$1" + thousands
          ),
          cents = parts[1] ? decimal + parts[1] : "";
        return dollars + cents;
      }
      typeof cents == "string" && (cents = cents.replace(".", ""));
      var value = "";
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || "${{amount}}";
      var replaceRegex =
        Flits.money_format_replace.moneyReplaceRegex || /((\,00)|(\.00))$/g;
      var replaceWith = Flits.money_format_replace.replaceTo || "";
      replaceObject &&
        ((replaceRegex = replaceObject.moneyReplaceRegex),
        (replaceWith = replaceObject.replaceTo));
      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
      }
      return Flits.unescapeHtml(
        formatString.replace(
          placeholderRegex,
          value.replace(replaceRegex, replaceWith)
        )
      );
    },
    unescapeHtml: function (value) {
      return value
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#039;/g, "'")
        .replace(/&#39;/g, "'");
    },
    escapeHtml: function (value) {
      return value
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;")
        .replace(/'/g, "&#39;");
    },
    emptySectionShow: function (
      hideSelector,
      parentSelector,
      childSelector,
      showSelector
    ) {
      Flits(parentSelector + " " + childSelector).length <= 0
        ? (Flits(hideSelector).removeClass("flits-hide"),
          Flits(showSelector).addClass("flits-hide"))
        : (Flits(hideSelector).addClass("flits-hide"),
          Flits(showSelector).removeClass("flits-hide"));
    },
    copyClipBoardCode: function (e) {
      let temp = Flits(e)
        .parents(".flits-referral-link-input-wrap")
        .find('input[name="referral link"]');
      temp.select(), document.execCommand("copy");
    },
    popupWindow: function (url, title, win, w, h) {
      const y = win.top.outerHeight / 2 + win.top.screenY - h / 2;
      const x = win.top.outerWidth / 2 + win.top.screenX - w / 2;
      return win.open(
        url,
        title,
        "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" +
          w +
          ", height=" +
          h +
          ", top=" +
          y +
          ", left=" +
          x
      );
    },
    t: function (translation_text, default_text) {
      try {
        var translation = translation_text;
        return (
          translation_text.indexOf("Flits.locals") != -1 &&
            (translation = eval(translation_text)),
          translation == null || translation == " " || translation == undefined
            ? default_text
            : translation
        );
      } catch (err) {}
      return default_text;
    },
    ajaxEventsCallbacks: [],
    fetchEventsCallbacks: [],
    getCart: function () {
      return Flits.ajax({
        url: "/cart.json",
        method: "get",
        data: { app: "flits" },
      });
    },
    redirectToCheckout: function (parameters) {
      parameters = parameters || {};
      var form = Flits(
        Flits.StoreCreditCart.settings.checkoutFormSelectors.join(",")
      );
      if (form.length <= 0)
        return (location.href = "/checkout?" + Flits.param(parameters)), !0;
      var form_action = form.attr("action");
      var form_action_data = Flits.parseURL(form_action);
      Flits.each(parameters, function (index, item) {
        var existing = form.find("[name='" + index + "']");
        existing.length <= 0
          ? form.append(
              "<input type='hidden' name='" + index + "' value='" + item + "'>"
            )
          : existing.val(item),
          form_action_data.searchObject[index]
            ? (form_action = form_action.replace(
                index + "=" + form_action_data.searchObject[index],
                item
              ))
            : (form_action +=
                (form_action.indexOf("?") !== -1 ? "&" : "?") +
                index +
                "=" +
                item);
      }),
        form.append("<input type='hidden' name='checkout' value='true'>"),
        form.attr("action", form_action),
        form.trigger("submit", [{ flitsFormSubmitted: !0 }]);
    },
    parseURL: function (url) {
      var parser = document.createElement("a");
      var searchObject = {};
      var queries, split, i;
      for (
        parser.href = url,
          queries = parser.search.replace(/^\?/, "").split("&"),
          i = 0;
        i < queries.length;
        i++
      )
        (split = queries[i].split("=")), (searchObject[split[0]] = split[1]);
      return {
        protocol: parser.protocol,
        host: parser.host,
        hostname: parser.hostname,
        port: parser.port,
        pathname: parser.pathname,
        search: parser.search,
        searchObject: searchObject,
        hash: parser.hash,
      };
    },
    newGuid: function () {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"
        .replace(/[xy]/g, function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 3) | 8;
          return v.toString(16);
        })
        .toUpperCase();
    },
    dispatchEvent: function (name, data) {
      document.dispatchEvent(
        new CustomEvent(name, { bubbles: !0, detail: data })
      );
    },
    listenAjaxEvents: function () {
      const send = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function () {
        return (
          this.addEventListener("load", function () {
            let isNeedToCall = !1;
            if (
              (this.readyState == 4 && this._url && (isNeedToCall = !0),
              isNeedToCall)
            ) {
              var xhrData = this;
              Flits.each(Flits.ajaxEventsCallbacks, function (index, item) {
                item.apply(xhrData, ["ajax"]);
              });
            }
          }),
          send.apply(this, arguments)
        );
      };
    },
    listenFetchEvents: function () {
      if (window.fetch && "function" == typeof window.fetch) {
        const t = window.fetch,
          e = function () {
            const e = t.apply(this, arguments);
            return (
              e
                .then(function (t) {
                  let e = !1;
                  t && 200 === t.status && t.url && (e = !0),
                    e &&
                      ((t._url = t.url),
                      Flits.each(Flits.fetchEventsCallbacks, function (e, o) {
                        o.apply(t, ["fetch"]);
                      }));
                })
                .catch((t) => {}),
              e
            );
          };
        window.fetch = e;
      } else console.log("we have no fetch to observe");
    },
    addAjaxEvents: function (callback) {
      typeof callback == "function" && Flits.ajaxEventsCallbacks.push(callback);
    },
    addFetchEvents: function (callback) {
      typeof callback == "function" &&
        Flits.fetchEventsCallbacks.push(callback);
    },
    addToCartAjaxEvent: function () {
      var addToCartFunction = function (xhrOrFetch) {
        var url = this._url;
        url.indexOf("/cart/add.js") !== -1 &&
          Flits.dispatchEvent("Flits:AjaxCart:ProductAdded", {
            response: this,
            xhrOrFetch: xhrOrFetch,
          });
      };
      Flits.addAjaxEvents(addToCartFunction),
        Flits.addFetchEvents(addToCartFunction);
    },
    updateCartAjaxEvent: function () {
      var updateCartFunction = function (xhrOrFetch) {
        var url = this._url;
        (url.indexOf("/cart/update.js") !== -1 ||
          url.indexOf("/cart/change.js") !== -1) &&
          Flits.dispatchEvent("Flits:AjaxCart:CartUpdated", {
            response: this,
            xhrOrFetch: xhrOrFetch,
          });
      };
      Flits.addAjaxEvents(updateCartFunction),
        Flits.addFetchEvents(updateCartFunction);
    },
    clearCartAjaxEvent: function () {
      var clearCartFunction = function (xhrOrFetch) {
        var url = this._url;
        url.indexOf("/cart/clear.js") !== -1 &&
          Flits.dispatchEvent("Flits:AjaxCart:CartCleared", {
            response: this,
            xhrOrFetch: xhrOrFetch,
          });
      };
      Flits.addAjaxEvents(clearCartFunction),
        Flits.addFetchEvents(clearCartFunction);
    },
    getCartAjaxEvent: function () {
      var getCartFunction = function (xhrOrFetch) {
        var url = this._url;
        url.indexOf("flits") === -1 &&
          (url.indexOf("/cart.js") !== -1 ||
            url.indexOf("/cart?view=drawer") !== -1) &&
          Flits.dispatchEvent("Flits:AjaxCart:CartRendered", {
            response: this,
            xhrOrFetch: xhrOrFetch,
          });
      };
      Flits.addAjaxEvents(getCartFunction),
        Flits.addFetchEvents(getCartFunction);
    },
    debounce: function (func, wait, immediate) {
      var timeout;
      return function () {
        var context = this,
          args = arguments;
        var callNow = immediate && !timeout;
        clearTimeout(timeout),
          (timeout = setTimeout(function () {
            (timeout = null), immediate || func.apply(context, args);
          }, wait)),
          callNow && func.apply(context, args);
      };
    },
    compareObject: function (obj1, obj2) {
      for (var p in obj1) {
        if (obj1.hasOwnProperty(p) !== obj2.hasOwnProperty(p)) return !1;
        switch (typeof obj1[p]) {
          case "object":
            if (!Flits.compareObject(obj1[p], obj2[p])) return !1;
            break;
          case "function":
            if (
              obj2[p] === void 0 ||
              (p != "compare" && obj1[p].toString() != obj2[p].toString())
            )
              return !1;
            break;
          default:
            if (obj1[p] != obj2[p]) return !1;
        }
      }
      for (var p in obj2) if (obj1[p] === void 0) return !1;
      return !0;
    },
    lightOrDark: function (color) {
      var colorToHex = color;
      if (color.match(/^rgb/)) {
        (color = color.match(
          /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
        )),
          (r = parseInt(color[1])),
          (g = parseInt(color[2])),
          (b = parseInt(color[3]));
        function rgbToHex(r, g, b) {
          return (
            "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)
          );
        }
        colorToHex = rgbToHex(r, g, b);
      } else
        (color = +(
          "0x" + color.slice(1).replace(color.length < 5 && /./g, "$&$&")
        )),
          (r = color >> 16),
          (g = (color >> 8) & 255),
          (b = color & 255);
      return (
        (hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b))),
        hsp > 127.5
          ? Flits.shade(colorToHex, -0.4)
          : Flits.shade(colorToHex, 0.4)
      );
    },
    shade: function (color, percent) {
      function hexToRgb(hex) {
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function (m, r, g, b) {
          return r + r + g + g + b + b;
        });
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        var r = parseInt(result[1], 16);
        var g = parseInt(result[2], 16);
        var b = parseInt(result[3], 16);
        return "rgb(" + r + "," + g + "," + b + ")";
      }
      var f = parseInt(color.slice(1), 16);
      var t = percent < 0 ? 0 : 255;
      var p = percent < 0 ? percent * -1 : percent;
      var R = f >> 16;
      var G = (f >> 8) & 255;
      var B = f & 255;
      var shadeColor =
        "#" +
        (
          16777216 +
          (Math.round((t - R) * p) + R) * 65536 +
          (Math.round((t - G) * p) + G) * 256 +
          (Math.round((t - B) * p) + B)
        )
          .toString(16)
          .slice(1);
      return hexToRgb(shadeColor);
    },
    timeDiffer: function (options) {
      var date1 = options.date1;
      var date2 = options.date2;
      var type = options.type || "day";
      var isAbs = options.isAbsDisabled ? options.isAbsDisabled : !1;
      let diff = new Date(date1) - new Date(date2);
      let value;
      return (
        type == "day"
          ? (value = Math.floor(diff / 86400000))
          : type == "minute"
          ? ((value = Math.round(diff / 1000)), (value /= 60))
          : type == "hour" &&
            ((value = Math.floor(diff / 1000)), (value /= 60 * 60)),
        isAbs ? parseInt(value) : parseInt(Math.abs(value))
      );
    },
    getStoreCredit: function (callback) {
      let url = Flits.base_url + "/" + Flits.customer_id + "/credit/get_credit";
      let params = { customer_hash: Flits.customerHash, token: Flits.token };
      Flits.ajax({ method: "GET", url: url, data: params })
        .done(function (resp) {
          callback(resp);
        })
        .fail(function (resp) {})
        .always(function () {});
    },
    getWishlist: function (callback) {
      let url = Flits.base_url + "/wishlist";
      let params = {
        customer_id: Flits.customer_id,
        customer_hash: Flits.customerHash,
        token: Flits.token,
      };
      Flits.ajax({ method: "GET", url: url, data: params })
        .done(function (resp) {
          callback(resp);
        })
        .fail(function (resp) {})
        .always(function () {});
    },
  }),
    Flits.listenAjaxEvents(),
    Flits.listenFetchEvents(),
    Flits.extend(window.flitsObjects.global),
    Flits.extend(window.flitsObjects.storeData),
    Flits.ajax({
      url: window.flitsObjects.storeData.jsonSettingsPath,
      method: "GET",
    })
      .done(function (data) {
        Flits.dispatchEvent("Flits:Loaded"),
          Flits.AccountPageDefaultSettings,
          (window.flitsObjects.accountPage = data),
          Flits.extend(window.flitsObjects.accountPage),
          Flits.each(window.flitsObjects.allCssJs, function (index, item) {
            let isNeedToLoadPage = !1;
            let isNeedToLoadCondition = !1;
            switch (!0) {
              case Flits.inArray("all", item.requestPageType) != -1:
                isNeedToLoadPage = !0;
                break;
              case Flits.inArray(
                window.flitsObjects.storeData.request.page_type,
                item.requestPageType
              ) != -1:
                isNeedToLoadPage = !0;
                break;
              default:
                break;
            }
            if (!isNeedToLoadPage) return !0;
            let metaCount = 0;
            Flits.each(
              item.loadBasedOnMetafields,
              function (metaIndex, metaName) {
                if (Array.isArray(metaName)) {
                  var op, left, right;
                  switch (metaName.length) {
                    case 1:
                      left = metaName[0];
                      op = "==";
                      right = 1;
                      break;
                    case 2:
                      left = metaName[0];
                      op = "==";
                      right = metaName[1];
                      break;
                    case 3:
                      left = metaName[0];
                      op = metaName[1];
                      right = metaName[2];
                      break;
                  }
                  var str =
                    "Flits.Metafields['" +
                    left +
                    "'] " +
                    op +
                    " '" +
                    right +
                    "'";
                  eval(str) && metaCount++;
                } else Flits.Metafields[metaName] == 1 && metaCount++;
              }
            ),
              metaCount == item.loadBasedOnMetafields.length &&
                (isNeedToLoadCondition = !0),
              isNeedToLoadCondition && Flits.LoadStyleScript(index, item.url);
          }),
          window.flitsObjects.storeData.request.page_type == "product" &&
            window.flitsObjects.storeData.product &&
            window.flitsObjects.storeData.product.handle &&
            Flits.recentlyViewDataStore(
              window.flitsObjects.storeData.product.handle
            );
      })
      .fail(function (data) {})
      .always(function (data) {});
})(Flits);
